var _a, _b;
import * as React$3 from "react";
import React__default, { useRef, useEffect, useState, createRef, Fragment as Fragment$1, forwardRef, isValidElement, useMemo } from "react";
import styled, { css as css$1, createGlobalStyle } from "styled-components";
import { Form as Form$1, Formik, connect, useFormikContext } from "formik";
import * as Yup from "yup";
import * as require$$1 from "react-dom";
import require$$1__default from "react-dom";
import { Link as Link$1 } from "react-router-dom";
import axios from "axios";
const iconWidth = (height, width) => `width: ${height / width}em`;
const Wrapper$e = styled.svg.withConfig({
  displayName: "Iconstyled__Wrapper",
  componentId: "sc-14amfav-0"
})(["height:1em;", ""], ({
  $name
}) => {
  switch ($name) {
    case "arrow-down":
      return iconWidth(10, 14);
    case "basket":
      return iconWidth(27, 24);
    case "cart":
      return iconWidth(22, 20);
    case "chevron-down":
      return iconWidth(13, 8);
    case "chevron-left":
      return iconWidth(10, 13);
    case "delivery":
      return iconWidth(16, 12);
    case "email":
      return iconWidth(21, 19);
    case "eye":
      return iconWidth(19, 12);
    case "express-delivery":
      return iconWidth(23, 13);
    case "home":
      return iconWidth(20, 17);
    case "location":
      return iconWidth(17, 22);
    case "locator":
      return iconWidth(19, 18);
    case "minus":
      return iconWidth(10, 1);
    case "payment":
      return iconWidth(16, 13);
    case "tick":
      return iconWidth(11, 9);
    default:
      return iconWidth(1, 1);
  }
});
function getAugmentedNamespace(n) {
  var f = n.default;
  if (typeof f == "function") {
    var a = function() {
      return f.apply(this, arguments);
    };
    a.prototype = f.prototype;
  } else
    a = {};
  Object.defineProperty(a, "__esModule", {
    value: true
  });
  Object.keys(n).forEach(function(k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function() {
        return n[k];
      }
    });
  });
  return a;
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min)
    return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f = React__default, k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = { key: true, ref: true, __self: true, __source: true };
  function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for (b in a)
      m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps)
      for (b in a = c.defaultProps, a)
        void 0 === d[b] && (d[b] = a[b]);
    return { $$typeof: k, type: c, key: e, ref: h, props: d, _owner: n.current };
  }
  reactJsxRuntime_production_min.Fragment = l;
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  return reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development)
    return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var React2 = React__default;
      var REACT_ELEMENT_TYPE = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") {
          return null;
        }
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") {
          return maybeIterator;
        }
        return null;
      }
      var ReactSharedInternals = React2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error(format2) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format2, args);
          }
        }
      }
      function printWarning(level, format2, args) {
        {
          var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame2.getStackAddendum();
          if (stack !== "") {
            format2 += "%s";
            args = args.concat([stack]);
          }
          var argsWithFormat = args.map(function(item) {
            return String(item);
          });
          argsWithFormat.unshift("Warning: " + format2);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }
      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }
      function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") {
          return true;
        }
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (typeof type === "object" && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) {
            return true;
          }
        }
        return false;
      }
      function getWrappedName2(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) {
          return displayName;
        }
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
      }
      function getContextName(type) {
        return type.displayName || "Context";
      }
      function getComponentNameFromType(type) {
        if (type == null) {
          return null;
        }
        {
          if (typeof type.tag === "number") {
            error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
          }
        }
        if (typeof type === "function") {
          return type.displayName || type.name || null;
        }
        if (typeof type === "string") {
          return type;
        }
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return "Fragment";
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_PROFILER_TYPE:
            return "Profiler";
          case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
          case REACT_SUSPENSE_TYPE:
            return "Suspense";
          case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
              return getWrappedName2(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;
              if (outerName !== null) {
                return outerName;
              }
              return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return getComponentNameFromType(init(payload));
              } catch (x) {
                return null;
              }
            }
          }
        }
        return null;
      }
      var assign = Object.assign;
      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;
      function disabledLog() {
      }
      disabledLog.__reactDisabledLog = true;
      function disableLogs() {
        {
          if (disabledDepth === 0) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            };
            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
          }
          disabledDepth++;
        }
      }
      function reenableLogs() {
        {
          disabledDepth--;
          if (disabledDepth === 0) {
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            };
            Object.defineProperties(console, {
              log: assign({}, props, {
                value: prevLog
              }),
              info: assign({}, props, {
                value: prevInfo
              }),
              warn: assign({}, props, {
                value: prevWarn
              }),
              error: assign({}, props, {
                value: prevError
              }),
              group: assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign({}, props, {
                value: prevGroupEnd
              })
            });
          }
          if (disabledDepth < 0) {
            error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
          }
        }
      }
      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix2;
      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix2 === void 0) {
            try {
              throw Error();
            } catch (x) {
              var match = x.stack.trim().match(/\n( *(at )?)/);
              prefix2 = match && match[1] || "";
            }
          }
          return "\n" + prefix2 + name;
        }
      }
      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }
      function describeNativeComponentFrame(fn2, construct) {
        if (!fn2 || reentry) {
          return "";
        }
        {
          var frame = componentFrameCache.get(fn2);
          if (frame !== void 0) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current;
          ReactCurrentDispatcher.current = null;
          disableLogs();
        }
        try {
          if (construct) {
            var Fake = function() {
              throw Error();
            };
            Object.defineProperty(Fake.prototype, "props", {
              set: function() {
                throw Error();
              }
            });
            if (typeof Reflect === "object" && Reflect.construct) {
              try {
                Reflect.construct(Fake, []);
              } catch (x) {
                control = x;
              }
              Reflect.construct(fn2, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x) {
                control = x;
              }
              fn2.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x) {
              control = x;
            }
            fn2();
          }
        } catch (sample) {
          if (sample && control && typeof sample.stack === "string") {
            var sampleLines = sample.stack.split("\n");
            var controlLines = control.stack.split("\n");
            var s = sampleLines.length - 1;
            var c = controlLines.length - 1;
            while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
              c--;
            }
            for (; s >= 1 && c >= 0; s--, c--) {
              if (sampleLines[s] !== controlLines[c]) {
                if (s !== 1 || c !== 1) {
                  do {
                    s--;
                    c--;
                    if (c < 0 || sampleLines[s] !== controlLines[c]) {
                      var _frame = "\n" + sampleLines[s].replace(" at new ", " at ");
                      if (fn2.displayName && _frame.includes("<anonymous>")) {
                        _frame = _frame.replace("<anonymous>", fn2.displayName);
                      }
                      {
                        if (typeof fn2 === "function") {
                          componentFrameCache.set(fn2, _frame);
                        }
                      }
                      return _frame;
                    }
                  } while (s >= 1 && c >= 0);
                }
                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        }
        var name = fn2 ? fn2.displayName || fn2.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        {
          if (typeof fn2 === "function") {
            componentFrameCache.set(fn2, syntheticFrame);
          }
        }
        return syntheticFrame;
      }
      function describeFunctionComponentFrame(fn2, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn2, false);
        }
      }
      function shouldConstruct(Component2) {
        var prototype = Component2.prototype;
        return !!(prototype && prototype.isReactComponent);
      }
      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return "";
        }
        if (typeof type === "function") {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }
        if (typeof type === "string") {
          return describeBuiltInComponentFrame(type);
        }
        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame("Suspense");
          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
              } catch (x) {
              }
            }
          }
        }
        return "";
      }
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }
      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          var has2 = Function.call.bind(hasOwnProperty);
          for (var typeSpecName in typeSpecs) {
            if (has2(typeSpecs, typeSpecName)) {
              var error$1 = void 0;
              try {
                if (typeof typeSpecs[typeSpecName] !== "function") {
                  var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  err.name = "Invariant Violation";
                  throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ex) {
                error$1 = ex;
              }
              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }
              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }
      var isArrayImpl = Array.isArray;
      function isArray(a) {
        return isArrayImpl(a);
      }
      function typeName(value) {
        {
          var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
          return type;
        }
      }
      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e) {
            return true;
          }
        }
      }
      function testStringCoercion(value) {
        return "" + value;
      }
      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value);
          }
        }
      }
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      var didWarnAboutStringRefs;
      {
        didWarnAboutStringRefs = {};
      }
      function hasValidRef(config) {
        {
          if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.ref !== void 0;
      }
      function hasValidKey(config) {
        {
          if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.key !== void 0;
      }
      function warnIfStringRefCannotBeAutoConverted(config, self2) {
        {
          if (typeof config.ref === "string" && ReactCurrentOwner.current && self2 && ReactCurrentOwner.current.stateNode !== self2) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
              error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
              didWarnAboutStringRefs[componentName] = true;
            }
          }
        }
      }
      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }
      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }
      var ReactElement = function(type, key, ref, self2, source, owner, props) {
        var element = {
          $$typeof: REACT_ELEMENT_TYPE,
          type,
          key,
          ref,
          props,
          _owner: owner
        };
        {
          element._store = {};
          Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          });
          Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self2
          });
          Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });
          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };
      function jsxDEV(type, config, maybeKey, source, self2) {
        {
          var propName;
          var props = {};
          var key = null;
          var ref = null;
          if (maybeKey !== void 0) {
            {
              checkKeyStringCoercion(maybeKey);
            }
            key = "" + maybeKey;
          }
          if (hasValidKey(config)) {
            {
              checkKeyStringCoercion(config.key);
            }
            key = "" + config.key;
          }
          if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self2);
          }
          for (propName in config) {
            if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config[propName];
            }
          }
          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for (propName in defaultProps) {
              if (props[propName] === void 0) {
                props[propName] = defaultProps[propName];
              }
            }
          }
          if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }
            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }
          return ReactElement(type, key, ref, self2, source, ReactCurrentOwner.current, props);
        }
      }
      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }
      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      function isValidElement2(object) {
        {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
      }
      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) {
              return "\n\nCheck the render method of `" + name + "`.";
            }
          }
          return "";
        }
      }
      function getSourceInfoErrorAddendum(source) {
        {
          if (source !== void 0) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
          }
          return "";
        }
      }
      var ownerHasKeyUseWarning = {};
      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum();
          if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }
          return info;
        }
      }
      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }
          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
          var childOwner = "";
          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
          }
          setCurrentlyValidatingElement$1(element);
          error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }
      function validateChildKeys(node, parentType) {
        {
          if (typeof node !== "object") {
            return;
          }
          if (isArray(node)) {
            for (var i = 0; i < node.length; i++) {
              var child = node[i];
              if (isValidElement2(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement2(node)) {
            if (node._store) {
              node._store.validated = true;
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") {
              if (iteratorFn !== node.entries) {
                var iterator = iteratorFn.call(node);
                var step;
                while (!(step = iterator.next()).done) {
                  if (isValidElement2(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }
      function validatePropTypes(element) {
        {
          var type = element.type;
          if (type === null || type === void 0 || typeof type === "string") {
            return;
          }
          var propTypes2;
          if (typeof type === "function") {
            propTypes2 = type.propTypes;
          } else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes2 = type.propTypes;
          } else {
            return;
          }
          if (propTypes2) {
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes2, element.props, "prop", name, element);
          } else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true;
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
          }
          if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) {
            error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
          }
        }
      }
      function validateFragmentProps(fragment) {
        {
          var keys2 = Object.keys(fragment.props);
          for (var i = 0; i < keys2.length; i++) {
            var key = keys2[i];
            if (key !== "children" && key !== "key") {
              setCurrentlyValidatingElement$1(fragment);
              error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }
          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
          }
        }
      }
      function jsxWithValidation(type, props, key, isStaticChildren, source, self2) {
        {
          var validType = isValidElementType(type);
          if (!validType) {
            var info = "";
            if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
              info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            }
            var sourceInfo = getSourceInfoErrorAddendum(source);
            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }
            var typeString;
            if (type === null) {
              typeString = "null";
            } else if (isArray(type)) {
              typeString = "array";
            } else if (type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
              info = " Did you accidentally export a JSX literal instead of a component?";
            } else {
              typeString = typeof type;
            }
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
          }
          var element = jsxDEV(type, props, key, source, self2);
          if (element == null) {
            return element;
          }
          if (validType) {
            var children = props.children;
            if (children !== void 0) {
              if (isStaticChildren) {
                if (isArray(children)) {
                  for (var i = 0; i < children.length; i++) {
                    validateChildKeys(children[i], type);
                  }
                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }
          if (type === REACT_FRAGMENT_TYPE) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }
          return element;
        }
      }
      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }
      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }
      var jsx2 = jsxWithValidationDynamic;
      var jsxs2 = jsxWithValidationStatic;
      reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
      reactJsxRuntime_development.jsx = jsx2;
      reactJsxRuntime_development.jsxs = jsxs2;
    })();
  }
  return reactJsxRuntime_development;
}
(function(module) {
  if (process.env.NODE_ENV === "production") {
    module.exports = requireReactJsxRuntime_production_min();
  } else {
    module.exports = requireReactJsxRuntime_development();
  }
})(jsxRuntime);
const Fragment = jsxRuntime.exports.Fragment;
const jsx = jsxRuntime.exports.jsx;
const jsxs = jsxRuntime.exports.jsxs;
const icons = {
  "arrow-down": ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 10 14",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M4.47345 0.75L5.52576 0.75L5.52576 11.3815L8.41928 8.70556L9.1665 9.3963L4.99984 13.25L0.833171 9.3963L1.58039 8.70556L4.47391 11.3815L4.47345 0.75Z",
      fill: "currentColor"
    })
  }),
  "arrow-right": ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 12 8",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M0.9 4.44217L0.9 4.54217L1 4.54217L9.28384 4.54179L7.2894 6.80624L7.2312 6.87232L7.28939 6.93841L7.84198 7.56608L7.91702 7.65131L7.99208 7.5661L11.075 4.0661L11.1333 4L11.075 3.9339L7.99208 0.433902L7.91702 0.348689L7.84198 0.433921L7.28939 1.06159L7.2312 1.12768L7.2894 1.19376L9.28385 3.45822L1 3.45822L0.9 3.45822L0.9 3.55822L0.9 4.44217Z",
      fill: "#2A2A2A",
      stroke: "#2A2A2A",
      strokeWidth: "0.2"
    })
  }),
  basket: ({
    name,
    ...props
  }) => /* @__PURE__ */ jsxs(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/* @__PURE__ */ jsx("path", {
      d: "M25.6191 4.93957C25.1359 4.32212 24.3843 3.94629 23.6057 3.94629H7.25683L6.74677 1.95972C6.45147 0.805365 5.43134 0 4.25014 0H1.5119C1.05552 0 0.679688 0.375837 0.679688 0.83221C0.679688 1.28858 1.05552 1.66442 1.5119 1.66442H4.25014C4.65282 1.66442 5.00181 1.93288 5.10919 2.33556L8.38434 15.3825C8.67964 16.5368 9.69977 17.3422 10.881 17.3422H21.5923C22.7735 17.3422 23.8205 16.5368 24.089 15.3825L26.1024 7.11406C26.2903 6.36238 26.1292 5.55702 25.6191 4.93957ZM24.4648 6.73822L22.4514 15.0066C22.344 15.4093 21.995 15.6778 21.5923 15.6778H10.881C10.4783 15.6778 10.1293 15.4093 10.0219 15.0066L7.68636 5.63755H23.6057C23.8742 5.63755 24.1426 5.77178 24.3037 5.98655C24.4648 6.20131 24.5453 6.46976 24.4648 6.73822Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx("path", {
      d: "M11.4448 18.4161C9.91457 18.4161 8.65283 19.6779 8.65283 21.2081C8.65283 22.7383 9.91457 24 11.4448 24C12.975 24 14.2367 22.7383 14.2367 21.2081C14.2367 19.6779 12.975 18.4161 11.4448 18.4161ZM11.4448 22.3087C10.8273 22.3087 10.3441 21.8255 10.3441 21.2081C10.3441 20.5906 10.8273 20.1074 11.4448 20.1074C12.0622 20.1074 12.5454 20.5906 12.5454 21.2081C12.5454 21.7987 12.0354 22.3087 11.4448 22.3087Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx("path", {
      d: "M20.6796 18.4161C19.1494 18.4161 17.8877 19.6779 17.8877 21.2081C17.8877 22.7383 19.1494 24 20.6796 24C22.2098 24 23.4716 22.7383 23.4716 21.2081C23.4447 19.6779 22.2098 18.4161 20.6796 18.4161ZM20.6796 22.3087C20.0622 22.3087 19.579 21.8255 19.579 21.2081C19.579 20.5906 20.0622 20.1074 20.6796 20.1074C21.2971 20.1074 21.7803 20.5906 21.7803 21.2081C21.7803 21.7987 21.2702 22.3087 20.6796 22.3087Z",
      fill: "currentColor"
    })]
  }),
  cart: ({
    name,
    ...props
  }) => /* @__PURE__ */ jsxs(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/* @__PURE__ */ jsx("path", {
      d: "M20.7829 4.11631C20.3802 3.60177 19.7538 3.28857 19.105 3.28857H5.48095L5.0559 1.6331C4.80982 0.671137 3.95971 0 2.97538 0H0.693509C0.313197 0 0 0.313197 0 0.693508C0 1.07382 0.313197 1.38702 0.693509 1.38702H2.97538C3.31094 1.38702 3.60177 1.61073 3.69126 1.9463L6.42055 12.8187C6.66663 13.7807 7.51674 14.4518 8.50107 14.4518H17.4272C18.4115 14.4518 19.284 13.7807 19.5077 12.8187L21.1856 5.92838C21.3422 5.30198 21.2079 4.63085 20.7829 4.11631ZM19.8209 5.61518L18.1431 12.5055C18.0536 12.8411 17.7628 13.0648 17.4272 13.0648H8.50107C8.1655 13.0648 7.87468 12.8411 7.78519 12.5055L5.83889 4.69796H19.105C19.3288 4.69796 19.5525 4.80982 19.6867 4.98879C19.8209 5.16776 19.888 5.39147 19.8209 5.61518Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx("path", {
      d: "M8.97114 15.3467C7.69598 15.3467 6.64453 16.3981 6.64453 17.6733C6.64453 18.9485 7.69598 19.9999 8.97114 19.9999C10.2463 19.9999 11.2977 18.9485 11.2977 17.6733C11.2977 16.3981 10.2463 15.3467 8.97114 15.3467ZM8.97114 18.5905C8.4566 18.5905 8.05392 18.1878 8.05392 17.6733C8.05392 17.1588 8.4566 16.7561 8.97114 16.7561C9.48568 16.7561 9.88836 17.1588 9.88836 17.6733C9.88836 18.1655 9.46331 18.5905 8.97114 18.5905Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx("path", {
      d: "M16.6665 15.3467C15.3913 15.3467 14.3398 16.3981 14.3398 17.6733C14.3398 18.9485 15.3913 19.9999 16.6665 19.9999C17.9416 19.9999 18.9931 18.9485 18.9931 17.6733C18.9707 16.3981 17.9416 15.3467 16.6665 15.3467ZM16.6665 18.5905C16.1519 18.5905 15.7492 18.1878 15.7492 17.6733C15.7492 17.1588 16.1519 16.7561 16.6665 16.7561C17.181 16.7561 17.5837 17.1588 17.5837 17.6733C17.5837 18.1655 17.1586 18.5905 16.6665 18.5905Z",
      fill: "currentColor"
    })]
  }),
  "chevron-down": ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 13 8",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M0.800194 6.39269L2.21705 8L6.50019 3.19635L10.7752 8L12.2002 6.39269L6.50019 2.49155e-07L0.800194 6.39269Z",
      fill: "currentColor"
    })
  }),
  "chevron-left": ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 10 13",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M7.69178 12.8002L9.5 11.2342L4.09589 6.5002L9.5 1.7752L7.69178 0.200195L0.5 6.5002L7.69178 12.8002Z",
      fill: "currentColor"
    })
  }),
  "chevron-right-thin": ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 12 17",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M2.41002 16.3327L11.2462 8.5L2.40907 0.666487L0.756186 2.115L7.53715 8.12584L7.95965 8.50036L7.53679 8.87447L0.755375 14.8743L2.41002 16.3327Z",
      fill: "currentColor"
    })
  }),
  close: ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M0.585366 0L4 3.43902L7.41463 0L8 0.585366L4.56098 4L8 7.41463L7.41463 8L4 4.56098L0.585366 8L0 7.41463L3.43902 4L0 0.585366L0.585366 0Z",
      fill: "currentColor"
    })
  }),
  compass: ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M5.5 0C2.46632 0 0 2.46632 0 5.5C0 8.53368 2.46632 11 5.5 11C8.53368 11 11 8.53368 11 5.5C11 2.46632 8.53368 0 5.5 0ZM6.50737 6.50737L2.86 8.11684L4.46947 4.46947L8.11684 2.86L6.50737 6.50737Z",
      fill: "#2A2A2A"
    })
  }),
  configure: ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.4375 6.13665C14.3333 6.33681 15 7.09805 15 8.00656C15 8.91508 14.3333 9.67631 13.4375 9.87647V15.1007C13.4375 15.3456 13.2276 15.5441 12.9688 15.5441C12.7099 15.5441 12.5 15.3456 12.5 15.1007V9.87647C11.6042 9.67631 10.9375 8.91508 10.9375 8.00656C10.9375 7.09805 11.6042 6.33681 12.5 6.13665V1.20803C12.5 0.963157 12.7099 0.764648 12.9688 0.764648C13.2276 0.764648 13.4375 0.963157 13.4375 1.20803V6.13665ZM8.125 9.9793C9.02084 10.1795 9.6875 10.9407 9.6875 11.8492C9.6875 12.7577 9.02084 13.519 8.125 13.7191V15.1007C8.125 15.3456 7.91513 15.5441 7.65625 15.5441C7.39737 15.5441 7.1875 15.3456 7.1875 15.1007V13.7191C6.29166 13.519 5.625 12.7577 5.625 11.8492C5.625 10.9407 6.29166 10.1795 7.1875 9.9793V1.20803C7.1875 0.963157 7.39737 0.764648 7.65625 0.764648C7.91513 0.764648 8.125 0.963157 8.125 1.20803V9.9793ZM2.5 6.32941V15.1007C2.5 15.3456 2.29013 15.5441 2.03125 15.5441C1.77237 15.5441 1.5625 15.3456 1.5625 15.1007V6.32941C0.666656 6.12925 0 5.36802 0 4.4595C0 3.55099 0.666656 2.78975 1.5625 2.58959V1.20803C1.5625 0.963157 1.77237 0.764648 2.03125 0.764648C2.29013 0.764648 2.5 0.963157 2.5 1.20803V2.58959C3.39584 2.78975 4.0625 3.55099 4.0625 4.4595C4.0625 5.36802 3.39584 6.12925 2.5 6.32941ZM2.03125 5.49406C2.63531 5.49406 3.125 5.03087 3.125 4.4595C3.125 3.88813 2.63531 3.42494 2.03125 3.42494C1.42719 3.42494 0.9375 3.88813 0.9375 4.4595C0.9375 5.03087 1.42719 5.49406 2.03125 5.49406ZM7.65625 12.8838C8.26031 12.8838 8.75 12.4206 8.75 11.8492C8.75 11.2778 8.26031 10.8147 7.65625 10.8147C7.05219 10.8147 6.5625 11.2778 6.5625 11.8492C6.5625 12.4206 7.05219 12.8838 7.65625 12.8838ZM12.9688 9.04112C13.5728 9.04112 14.0625 8.57793 14.0625 8.00656C14.0625 7.43519 13.5728 6.972 12.9688 6.972C12.3647 6.972 11.875 7.43519 11.875 8.00656C11.875 8.57793 12.3647 9.04112 12.9688 9.04112Z",
      fill: "currentColor"
    })
  }),
  download: ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M14 11V14H2V11H0V14C0 15.1 0.9 16 2 16H14C15.1 16 16 15.1 16 14V11H14ZM13 7L11.59 5.59L9 8.17V0H7V8.17L4.41 5.59L3 7L8 12L13 7Z",
      fill: "currentColor"
    })
  }),
  delivery: ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M0.000533316 0H9.60021V2H12.4833L12.6502 2.1405L15.8501 5.1405L16 5.297V10.5H14.3169C14.0785 11.36 13.255 12 12.2668 12C11.2786 12 10.4551 11.36 10.2167 10.5H5.78327C5.54488 11.36 4.72144 12 3.73321 12C2.74498 12 1.92154 11.36 1.68314 10.5H0V0H0.000533316ZM1.06716 1V9.5H1.68368C1.92207 8.64 2.74551 8 3.73374 8C4.72198 8 5.54541 8.64 5.78381 9.5H8.53358V1H1.06716ZM9.60021 3V9.5H10.2167C10.4551 8.64 11.2786 8 12.2668 8C13.255 8 14.0785 8.64 14.3169 9.5H14.9334V5.7185L12.0332 2.9995H9.59968L9.60021 3ZM3.73374 9C3.13856 9 2.66711 9.442 2.66711 10C2.66711 10.558 3.13856 11 3.73374 11C4.32892 11 4.80037 10.558 4.80037 10C4.80037 9.442 4.32892 9 3.73374 9ZM12.2668 9C11.6716 9 11.2002 9.442 11.2002 10C11.2002 10.558 11.6716 11 12.2668 11C12.862 11 13.3334 10.558 13.3334 10C13.3334 9.442 12.862 9 12.2668 9Z",
      fill: "currentColor"
    })
  }),
  email: ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M18 0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H11V14H2V4L10 9L18 4V9H20V2C20 0.9 19.1 0 18 0ZM10 7L2 2H18L10 7ZM17 11L21 15L17 19V16H13V14H17V11Z",
      fill: "currentColor"
    })
  }),
  eye: ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 19 12",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M9.5 1.6C12.7732 1.6 15.6923 3.304 17.1173 6C15.6923 8.696 12.7818 10.4 9.5 10.4C6.21818 10.4 3.30773 8.696 1.88273 6C3.30773 3.304 6.22682 1.6 9.5 1.6ZM9.5 0C5.18182 0 1.49409 2.488 0 6C1.49409 9.512 5.18182 12 9.5 12C13.8182 12 17.5059 9.512 19 6C17.5059 2.488 13.8182 0 9.5 0ZM9.5 4C10.6918 4 11.6591 4.896 11.6591 6C11.6591 7.104 10.6918 8 9.5 8C8.30818 8 7.34091 7.104 7.34091 6C7.34091 4.896 8.30818 4 9.5 4ZM9.5 2.4C7.35818 2.4 5.61364 4.016 5.61364 6C5.61364 7.984 7.35818 9.6 9.5 9.6C11.6418 9.6 13.3864 7.984 13.3864 6C13.3864 4.016 11.6418 2.4 9.5 2.4Z",
      fill: "currentColor"
    })
  }),
  "express-delivery": ({
    name,
    ...props
  }) => /* @__PURE__ */ jsxs(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 23 13",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/* @__PURE__ */ jsx("path", {
      d: "M6.40318 12.5967C5.32248 12.5967 4.44464 11.679 4.44464 10.5513C4.44464 9.42362 5.32248 8.50586 6.40318 8.50586C7.48386 8.50586 8.36354 9.42362 8.36354 10.5513C8.36354 11.679 7.48386 12.5967 6.40318 12.5967ZM6.40318 9.30112C5.74317 9.30112 5.20527 9.86261 5.20527 10.5513C5.20527 11.2416 5.74317 11.8015 6.40318 11.8015C7.06468 11.8015 7.60291 11.24 7.60291 10.5513C7.60139 9.86261 7.06316 9.30112 6.40318 9.30112Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx("path", {
      d: "M18.7913 12.5967C17.7106 12.5967 16.8324 11.679 16.8324 10.5513C16.8324 9.42362 17.7106 8.50586 18.7913 8.50586C19.872 8.50586 20.7513 9.42362 20.7513 10.5513C20.7513 11.679 19.872 12.5967 18.7913 12.5967ZM18.7913 9.30112C18.1298 9.30112 17.593 9.86261 17.593 10.5513C17.593 11.2416 18.1313 11.8015 18.7913 11.8015C19.4513 11.8015 19.9907 11.24 19.9907 10.5513C19.9891 9.86261 19.4513 9.30112 18.7913 9.30112Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx("path", {
      d: "M21.6621 10.9488H20.3726C20.1623 10.9488 19.9915 10.7707 19.9915 10.5512C19.9915 10.3317 20.1623 10.1535 20.3726 10.1535H21.281V5.95775C21.281 3.97914 19.7387 2.36948 17.8425 2.36948H15.5818C15.3715 2.36948 15.2007 2.19134 15.2007 1.97183C15.2007 1.75235 15.3715 1.57422 15.5818 1.57422H17.8425C20.1578 1.57422 22.0416 3.54009 22.0416 5.95611V10.5495C22.0416 10.7722 21.8724 10.9488 21.6621 10.9488Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx("path", {
      d: "M14.5796 7.81479H3.53659C3.32623 7.81479 3.15552 7.63665 3.15552 7.41715C3.15552 7.19767 3.32623 7.01953 3.53659 7.01953H14.5796C14.7899 7.01953 14.9606 7.19767 14.9606 7.41715C14.9606 7.63665 14.7899 7.81479 14.5796 7.81479Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx("path", {
      d: "M4.82303 10.9495H3.53659C3.32623 10.9495 3.15552 10.7714 3.15552 10.5519C3.15552 10.3324 3.32623 10.1543 3.53659 10.1543H4.82303C5.03339 10.1543 5.2041 10.3324 5.2041 10.5519C5.2041 10.773 5.03339 10.9495 4.82303 10.9495Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx("path", {
      d: "M17.2094 10.9495H7.98456C7.77423 10.9495 7.60352 10.7714 7.60352 10.5519C7.60352 10.3324 7.77423 10.1543 7.98456 10.1543H17.2094C17.4197 10.1543 17.5904 10.3324 17.5904 10.5519C17.5904 10.773 17.4197 10.9495 17.2094 10.9495Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx("path", {
      d: "M15.5841 7.81427H4.18274C3.97241 7.81427 3.8017 7.63614 3.8017 7.41663C3.8017 7.19715 3.97241 7.02057 4.18274 7.02057H15.203V0.795256H7.18213C6.97177 0.795256 6.80106 0.617121 6.80106 0.397642C6.80106 0.178136 6.97177 0 7.18213 0H15.5826C15.793 0 15.9637 0.178136 15.9637 0.397642V7.41663C15.9637 7.63772 15.7945 7.81427 15.5841 7.81427Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx("path", {
      d: "M21.6591 6.84427H18.1183C17.908 6.84427 17.7372 6.66613 17.7372 6.44665V1.98358C17.7372 1.76407 17.908 1.58594 18.1183 1.58594C18.3287 1.58594 18.4994 1.76407 18.4994 1.98358V6.04901H21.6591C21.8695 6.04901 22.0402 6.22714 22.0402 6.44665C22.0402 6.66613 21.8695 6.84427 21.6591 6.84427Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx("path", {
      d: "M8.47525 2.3812H3.53968C3.32934 2.3812 3.15863 2.20306 3.15863 1.98358C3.15863 1.76407 3.32934 1.58594 3.53968 1.58594H8.47525C8.68558 1.58594 8.85629 1.76407 8.85629 1.98358C8.85629 2.20306 8.68558 2.3812 8.47525 2.3812Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx("path", {
      d: "M6.30517 6.02475H1.36959C1.15924 6.02475 0.988525 5.84661 0.988525 5.62714C0.988525 5.40763 1.15924 5.22949 1.36959 5.22949H6.30517C6.51551 5.22949 6.68625 5.40763 6.68625 5.62714C6.68625 5.84661 6.51551 6.02475 6.30517 6.02475Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx("path", {
      d: "M7.29191 4.30539H0.381064C0.170716 4.30539 0 4.12723 0 3.90934C0 3.68985 0.170716 3.51172 0.381064 3.51172H7.29191C7.50227 3.51172 7.67299 3.68985 7.67299 3.90934C7.67299 4.12723 7.50227 4.30539 7.29191 4.30539Z",
      fill: "currentColor"
    })]
  }),
  home: ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M10 0L11.25 1.25874L11.2491 1.25909L20 10.07L18.75 11.3287L16.8745 9.44003L16.875 16.3637H3.125L3.12455 9.44094L1.25 11.3287L0 10.07L8.75 1.25909V1.25874L10 0V0.000909028V0ZM10 2.51728L5 7.55247V14.4756H15V7.55247L10 2.51728Z",
      fill: "currentColor"
    })
  }),
  information: ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.5 0C8.53262 0 11 2.46738 11 5.5C11 8.53262 8.53262 11 5.5 11C2.46738 11 0 8.53262 0 5.5C0 2.46738 2.46738 0 5.5 0ZM5.5 0.846154C2.92473 0.846154 0.846154 2.92473 0.846154 5.5C0.846154 8.07527 2.92473 10.1538 5.5 10.1538C8.07527 10.1538 10.1538 8.07527 10.1538 5.5C10.1538 2.92473 8.07527 0.846154 5.5 0.846154ZM5.07692 2.96154H5.92308V3.80769H5.07692V2.96154ZM5.07692 4.65385H5.92308V8.03846H5.07692V4.65385Z",
      fill: "currentColor"
    })
  }),
  location: ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 17 22",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsxs("g", {
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd",
      children: [/* @__PURE__ */ jsx("path", {
        d: "M5.73113 7.0566C5.73113 8.66135 7.03204 9.96226 8.63679 9.96226C10.2415 9.96226 11.5425 8.66135 11.5425 7.0566C11.5425 5.45185 10.2415 4.15094 8.63679 4.15094C7.03204 4.15094 5.73113 5.45185 5.73113 7.0566ZM10.2972 7.0566C10.2972 7.97361 9.55379 8.71698 8.63679 8.71698C7.71979 8.71698 6.97641 7.97361 6.97641 7.0566C6.97641 6.1396 7.71979 5.39623 8.63679 5.39623C9.55379 5.39623 10.2972 6.1396 10.2972 7.0566Z"
      }), /* @__PURE__ */ jsx("path", {
        d: "M1.16509 7.17283C1.16509 9.37305 2.89374 12.6905 6.35104 17.1251C3.1099 17.4345 0.75 18.3849 0.75 19.5094C0.75 20.8849 4.28104 22 8.63679 22C12.9925 22 16.5236 20.8849 16.5236 19.5094C16.5236 18.3849 14.1637 17.4345 10.9225 17.1251C14.3798 12.6905 16.1085 9.37305 16.1085 7.17283C16.1085 3.21139 12.7633 0 8.63679 0C4.51029 0 1.16509 3.21139 1.16509 7.17283ZM8.63679 19.9245C9.11126 19.3663 9.56313 18.8227 9.9924 18.2938C12.7793 18.4175 14.8632 18.9148 14.8632 19.5094C14.8632 20.1972 12.0755 20.7547 8.63679 20.7547C5.19804 20.7547 2.41038 20.1972 2.41038 19.5094C2.41038 18.9148 4.4943 18.4175 7.28119 18.2938C7.71046 18.8227 8.16233 19.3663 8.63679 19.9245ZM14.8632 7.28302C14.8632 9.50605 12.7877 13.0281 8.63679 17.8491C4.48585 13.0281 2.41038 9.50605 2.41038 7.28302C2.41038 3.94847 5.19804 1.24528 8.63679 1.24528C12.0755 1.24528 14.8632 3.94847 14.8632 7.28302Z"
      })]
    })
  }),
  locator: ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M17.2209 8.18182C16.8236 4.77 13.965 2.06182 10.3636 1.68545V0H8.63636V1.68545C5.035 2.06182 2.17636 4.77 1.77909 8.18182H0V9.81818H1.77909C2.17636 13.23 5.035 15.9382 8.63636 16.3145V18H10.3636V16.3145C13.965 15.9382 16.8236 13.23 17.2209 9.81818H19V8.18182H17.2209ZM9.5 14.7273C6.15773 14.7273 3.45455 12.1664 3.45455 9C3.45455 5.83364 6.15773 3.27273 9.5 3.27273C12.8423 3.27273 15.5455 5.83364 15.5455 9C15.5455 12.1664 12.8423 14.7273 9.5 14.7273Z",
      fill: "currentColor"
    })
  }),
  "magnify-minus": ({
    name,
    ...props
  }) => /* @__PURE__ */ jsxs(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/* @__PURE__ */ jsx("path", {
      d: "M10.8491 5.32495C10.8501 4.12035 10.4343 2.95105 9.66975 2.00834C8.90518 1.06562 7.83709 0.405275 6.64016 0.135324C5.44324 -0.134626 4.18835 0.00179391 3.08075 0.52227C1.97315 1.04275 1.0784 1.91647 0.542869 3.00052C0.0073353 4.08457 -0.137287 5.31479 0.13266 6.48994C0.402606 7.66508 1.07114 8.7156 2.02891 9.46965C2.98668 10.2237 4.17699 10.6367 5.40514 10.641C6.63329 10.6453 7.82658 10.2407 8.78983 9.49336L12.1009 12.7409L12.9855 11.8733L9.67444 8.62571C10.4358 7.68766 10.8499 6.52392 10.8491 5.32495ZM5.42453 9.41764C4.59925 9.41764 3.7925 9.17761 3.1063 8.7279C2.4201 8.27819 1.88527 7.639 1.56945 6.89116C1.25362 6.14332 1.17099 5.32041 1.332 4.52651C1.493 3.7326 1.89041 3.00336 2.47398 2.43098C3.05754 1.85861 3.80105 1.46882 4.61048 1.3109C5.4199 1.15299 6.2589 1.23403 7.02136 1.5438C7.78382 1.85357 8.43551 2.37814 8.89402 3.05118C9.35252 3.72422 9.59725 4.51549 9.59725 5.32495C9.59725 6.4104 9.15762 7.45139 8.37509 8.21892C7.59255 8.98645 6.5312 9.41764 5.42453 9.41764Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx("path", {
      d: "M7.92816 4.71094H2.9209V5.93884H7.92816V4.71094Z",
      fill: "currentColor"
    })]
  }),
  "magnify-plus": ({
    name,
    ...props
  }) => /* @__PURE__ */ jsxs(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/* @__PURE__ */ jsx("path", {
      d: "M9.67697 8.62375C10.5365 7.55926 10.9485 6.21271 10.8287 4.85992C10.7088 3.50712 10.0662 2.25047 9.03233 1.34735C7.99848 0.444226 6.65169 -0.0370047 5.26782 0.00222276C3.88396 0.0414502 2.56776 0.598166 1.58881 1.55834C0.609862 2.51852 0.0422606 3.80948 0.00226622 5.1668C-0.0377282 6.52413 0.452911 7.84509 1.37369 8.85911C2.29447 9.87314 3.57569 10.5035 4.95494 10.621C6.33418 10.7386 7.70705 10.3344 8.79236 9.4914L12.1034 12.739L12.988 11.8713L9.67697 8.62375ZM5.42706 9.41568C4.60178 9.41568 3.79503 9.17565 3.10883 8.72594C2.42263 8.27623 1.8878 7.63704 1.57198 6.8892C1.25615 6.14135 1.17352 5.31845 1.33453 4.52454C1.49553 3.73064 1.89294 3.00139 2.47651 2.42902C3.06007 1.85664 3.80358 1.46685 4.61301 1.30893C5.42243 1.15102 6.26143 1.23207 7.02389 1.54183C7.78636 1.8516 8.43804 2.37617 8.89655 3.04921C9.35505 3.72225 9.59978 4.51353 9.59978 5.32299C9.59978 6.40844 9.16015 7.44943 8.37762 8.21696C7.59508 8.98449 6.53374 9.41568 5.42706 9.41568Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx("path", {
      d: "M6.05287 2.86719H4.80106V4.70886H2.92334V5.93665H4.80106V7.77832H6.05287V5.93665H7.93059V4.70886H6.05287V2.86719Z",
      fill: "currentColor"
    })]
  }),
  menu: ({
    name,
    ...props
  }) => /* @__PURE__ */ jsxs(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 1H0V0H16V1Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13 5H3V4H13V5Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 9H6V8H10V9Z",
      fill: "currentColor"
    })]
  }),
  minus: ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 10 1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M10 0H0V1H10V0Z",
      fill: "currentColor"
    })
  }),
  payment: ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 16 13",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M1.71429 0H12C12.94 0 13.7143 0.800682 13.7143 1.77273V2.36364H14.2857C15.2257 2.36364 16 3.16432 16 4.13636V11.2273C16 12.1993 15.2257 13 14.2857 13H4C3.06 13 2.28571 12.1993 2.28571 11.2273V10.6364H1.71429C0.774286 10.6364 0 9.83568 0 8.86364V1.77273C0 0.800682 0.774286 0 1.71429 0ZM1.71429 1.18182C1.39143 1.18182 1.14286 1.43886 1.14286 1.77273V8.86364C1.14286 9.1975 1.39143 9.45455 1.71429 9.45455H12C12.3229 9.45455 12.5714 9.1975 12.5714 8.86364V3.54545H1.71429V2.36364H12.5714V1.77273C12.5714 1.43886 12.3229 1.18182 12 1.18182H1.71429ZM13.7143 3.54545V4.72727H14.8571V4.13636C14.8571 3.8025 14.6086 3.54545 14.2857 3.54545H13.7143ZM13.7143 5.90909V8.86364C13.7143 9.83568 12.94 10.6364 12 10.6364H3.42857V11.2273C3.42857 11.5611 3.67714 11.8182 4 11.8182H14.2857C14.6086 11.8182 14.8571 11.5611 14.8571 11.2273V5.90909H13.7143Z",
      fill: "currentColor"
    })
  }),
  pencil: ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M7.37231 4.01333L7.98556 4.62667L1.9464 10.6667H1.33315V10.0533L7.37231 4.01333ZM9.77198 0C9.60533 0 9.43202 0.0666666 9.30537 0.193333L8.08554 1.41333L10.5852 3.91333L11.805 2.69333C12.065 2.43333 12.065 2.01333 11.805 1.75333L10.2452 0.193333C10.1119 0.06 9.94529 0 9.77198 0ZM7.37231 2.12667L0 9.5V12H2.49965L9.87196 4.62667L7.37231 2.12667Z",
      fill: "currentColor"
    })
  }),
  phone: ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.0922 20.8393C15.2115 20.8579 15.3307 20.8765 15.4497 20.8965L16.2679 20.8854C16.3143 20.869 16.3615 20.8551 16.4094 20.8438C17.0798 20.7796 17.7109 20.4981 18.2066 20.0422C18.9027 19.371 19.5906 18.6777 20.2118 17.9455C20.871 17.1799 20.8483 16.0409 20.1591 15.3023C19.1773 14.2632 18.1696 13.2518 17.136 12.2681C16.5943 11.7509 15.7954 11.6088 15.1086 11.9076C14.6809 12.0978 14.3016 12.3823 13.9992 12.7396L12.7678 13.9849C10.2701 12.6143 8.2129 10.5628 6.83524 8.06903C6.87823 8.03021 6.9122 8.00109 6.94132 7.97612C6.97045 7.95116 6.99471 7.93036 7.01829 7.90817C7.18713 7.73479 7.35864 7.56409 7.5301 7.39344C7.88253 7.04267 8.23475 6.69211 8.56313 6.31896C9.26183 5.56575 9.26183 4.40128 8.56313 3.64808C7.6451 2.65794 6.69102 1.68444 5.70365 0.758094C4.76898 -0.112785 3.71505 -0.112784 2.7471 0.719265C2.26497 1.1374 1.82058 1.59984 1.37606 2.0624C1.24267 2.20121 1.10927 2.34003 0.974838 2.47766C0.286639 3.1984 -0.0640574 4.17692 0.00966104 5.17073C0.0572649 6.17543 0.274831 7.16479 0.653113 8.09677C1.62938 10.6872 3.177 12.9143 5.03801 14.9362C6.56704 16.58 8.34537 17.9727 10.3077 19.0632C11.5544 19.8023 12.9028 20.3545 14.3098 20.7023C14.5689 20.7576 14.8306 20.7984 15.0922 20.8393ZM17.602 18.919C17.1223 19.4182 16.4489 19.6836 15.7576 19.6456V19.6345C15.0136 19.5947 14.2801 19.4403 13.5832 19.1769C10.5201 18.029 7.78785 16.1426 5.62877 13.6854C4.37418 12.3102 3.31407 10.7695 2.47807 9.10632C1.99082 8.16313 1.62726 7.16102 1.39641 6.12481C1.20427 5.45761 1.21295 4.74859 1.42137 4.08629C1.55433 3.77762 1.74229 3.49569 1.97607 3.25424C2.31395 2.88475 2.66028 2.54622 3.02007 2.19453C3.1653 2.05258 3.31272 1.90847 3.46267 1.75933C3.98408 1.24068 4.44726 1.24623 4.96868 1.75933L7.40381 4.20555C7.4676 4.27212 7.53139 4.33868 7.5924 4.41079C7.75142 4.56355 7.83967 4.7756 7.83599 4.99607C7.8323 5.21654 7.73702 5.42553 7.57299 5.57289C7.1137 6.06009 6.61959 6.54033 6.15012 6.99661C6.10646 7.03904 6.06302 7.08127 6.01983 7.12327C5.51228 7.61695 5.44849 7.93313 5.74248 8.58213C6.32417 9.77699 7.0939 10.8707 8.0223 11.8216C9.02389 12.9426 10.1845 13.9107 11.467 14.6949C11.7582 14.8669 12.0577 15.0194 12.36 15.172C12.7495 15.3966 13.2435 15.3141 13.5388 14.975C13.8547 14.6662 14.1672 14.3529 14.4799 14.0393C14.6587 13.8601 14.8375 13.6809 15.0171 13.5023C15.0274 13.492 15.0377 13.4817 15.0479 13.4714C15.1092 13.4097 15.1696 13.349 15.2362 13.2943C15.398 13.1314 15.6199 13.0426 15.8494 13.0489C16.0789 13.0552 16.2956 13.156 16.4482 13.3276C16.8253 13.6946 17.1965 14.0675 17.5683 14.4409C17.7078 14.5811 17.8474 14.7213 17.9875 14.8613C18.0949 14.9695 18.2029 15.0771 18.311 15.1846C18.599 15.4714 18.8871 15.7582 19.1634 16.0567C19.3322 16.2132 19.4301 16.4315 19.435 16.6616C19.4395 16.8917 19.3506 17.1138 19.1884 17.277C19.1347 17.3449 19.0773 17.4097 19.0164 17.4712C18.8593 17.632 18.7015 17.7923 18.5437 17.9525C18.2282 18.273 17.9126 18.5935 17.602 18.919Z"
    })
  }),
  plus: ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.54545 0H5.45455V4.54545H10V5.45455H5.45455V10H4.54545V5.45455H0V4.54545H4.54545V0Z",
      fill: "currentColor"
    })
  }),
  search: ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M6.65143 12.0086C5.23429 12.0086 3.87429 11.4367 2.88 10.4303C1.88571 9.42387 1.32571 8.0629 1.32571 6.64475C1.33714 5.22659 1.89714 3.86562 2.90286 2.87062C3.90857 1.87563 5.26857 1.31523 6.68571 1.32666C8.09143 1.32666 9.45143 1.8985 10.4343 2.8935C11.4514 3.91137 12 5.2609 12 6.66762C12 8.08578 11.4394 9.44732 10.4343 10.4417C9.42857 11.4487 8.06857 12.0086 6.65143 12.0086ZM16 15.0965L11.8171 10.9107C12.8 9.72123 13.3371 8.22302 13.3371 6.67906C13.3371 4.90636 12.64 3.21372 11.3829 1.95568C10.1257 0.697641 8.43429 0 6.66286 0C4.89143 0 3.18857 0.709078 1.94286 1.96712C0.697143 3.21372 0 4.9178 0 6.69049C0 8.46319 0.708572 10.1558 1.96571 11.4024C3.22286 12.649 4.92571 13.3467 6.69714 13.3352C8.24 13.3352 9.72514 12.7863 10.9029 11.8142L15.0857 16L16 15.0965Z",
      fill: "currentColor"
    })
  }),
  tag: ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 31 30",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.610725 18.0593C0.608203 18.0568 0.605693 18.0543 0.603188 18.0518C-0.0760627 17.372 -0.0760627 16.2697 0.603188 15.5899L15.6698 0.509889C15.9959 0.183412 16.4383 0 16.8996 0H28.3544C29.315 0 30.0938 0.779416 30.0938 1.74087V13.2087C30.0938 13.6687 29.9118 14.11 29.5878 14.4362L14.6353 29.4868C13.9595 30.167 12.8614 30.1719 12.1796 29.4978L0.610725 18.0593ZM3.03264 18.1607L12.07 27.0851C12.7519 27.7585 13.8495 27.7532 14.5249 27.0734L27.8508 13.6601C28.1748 13.3339 28.3567 12.8926 28.3567 12.4326V3.48404C28.3567 2.52259 27.578 1.74317 26.6174 1.74317H17.6797C17.2184 1.74317 16.776 1.92658 16.4498 2.25306L3.02434 15.6905C2.34509 16.3703 2.34509 17.4726 3.02434 18.1524C3.0271 18.1552 3.02986 18.158 3.03264 18.1607ZM21.3972 12.1861C19.4759 12.1861 17.9185 10.6273 17.9185 8.70434C17.9185 6.78143 19.4759 5.22261 21.3972 5.22261C23.3183 5.22261 24.8758 6.78143 24.8758 8.70434C24.8758 10.6273 23.3183 12.1861 21.3972 12.1861ZM21.3972 10.4452C22.3577 10.4452 23.1365 9.66579 23.1365 8.70434C23.1365 7.74289 22.3577 6.96347 21.3972 6.96347C20.4366 6.96347 19.6578 7.74289 19.6578 8.70434C19.6578 9.66579 20.4366 10.4452 21.3972 10.4452Z",
      fill: "currentColor"
    })
  }),
  tick: ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 11 9",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.49574 7.10067L0.888005 4.30201L0 5.24832L3.49574 9L11 0.946309L10.1182 0L3.49574 7.10067Z",
      fill: "currentColor"
    })
  }),
  tools: ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 31 32",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M27.9696 9.54545L30.0938 11.6647L28.2239 14.3109L26.6995 15.1816L22.2848 19.5974L22.6676 19.9794C23.2754 20.589 23.2754 21.5792 22.6685 22.1875C22.2478 22.6086 21.6442 22.7413 21.1066 22.5742L20.9569 22.7235C21.0177 23.191 20.8637 23.6721 20.52 24.0153L13.6252 30.9102C13.3338 31.2024 12.9463 31.3636 12.5337 31.3636C12.1207 31.3636 11.7328 31.202 11.441 30.9093L8.72814 28.1963C8.43635 27.9058 8.27557 27.5178 8.27557 27.1048C8.27557 26.6918 8.43635 26.3038 8.72856 26.0129L15.623 19.118C15.9658 18.7739 16.4461 18.6208 16.9139 18.6803L17.0637 18.531C16.8961 17.9938 17.0288 17.3914 17.4499 16.9703C17.7446 16.6751 18.1368 16.513 18.5532 16.513H18.5541C18.9705 16.513 19.3622 16.6751 19.657 16.9699L20.0407 17.3532L24.4553 12.9365L25.3269 11.4137L27.9696 9.54545ZM27.8309 11.2065L26.2945 12.2929L25.4787 13.7184L20.0407 19.1576L18.7548 17.8721C18.6825 17.7998 18.5975 17.7892 18.5537 17.7892H18.5532C18.5094 17.7892 18.4252 17.7998 18.3525 17.8721C18.2504 17.9746 18.2432 18.1367 18.3355 18.2498L18.7025 18.6965L17.2355 20.1636L16.8289 19.97C16.7944 19.953 16.7532 19.9437 16.7102 19.9437C16.6473 19.9437 16.58 19.9654 16.5265 20.0194L9.6303 26.9155C9.56182 26.984 9.55161 27.0631 9.55161 27.1048C9.55161 27.1465 9.56182 27.2256 9.62987 27.2937L12.3444 30.008C12.4129 30.0769 12.4925 30.0875 12.5337 30.0875C12.575 30.0875 12.6541 30.0769 12.7221 30.0088L19.6179 23.1127C19.7153 23.0157 19.7055 22.8877 19.6676 22.8073L19.475 22.401L20.939 20.9369L21.3856 21.301C21.5 21.3942 21.6638 21.387 21.7659 21.2857C21.8765 21.1751 21.8765 20.9931 21.765 20.8816L20.4796 19.5983L25.9181 14.1578L27.3452 13.3428L28.4311 11.8067L27.8309 11.2065ZM17.8 0.139735C18.1785 0.228262 18.4796 0.514725 18.5864 0.887627C18.6932 1.26095 18.5889 1.66308 18.3138 1.93785L16.0878 3.91636C16.0195 3.98568 15.9676 4.11096 15.9676 4.24375C15.9676 4.37654 16.0195 4.50182 16.1141 4.59619L17.2644 5.74329C17.4596 5.93789 17.7765 5.93705 17.9708 5.74287L19.9293 3.55181C20.2258 3.25449 20.6265 3.14759 20.9975 3.25115C21.3698 3.35346 21.6595 3.64911 21.7533 4.02285C21.8907 4.5728 21.9392 5.14072 21.8974 5.71114C21.7144 8.21455 19.4369 10.462 16.924 10.6182C16.2092 10.6612 15.5124 10.5664 14.8433 10.3325L4.97019 21.1008C4.59793 21.5321 4.03933 21.7977 3.45016 21.8169C3.42755 21.8178 3.40494 21.8182 3.38233 21.8182C2.81703 21.8182 2.27099 21.5902 1.87402 21.1868L0.699035 19.9938C0.290762 19.5795 0.0709236 19.0087 0.0956293 18.4282C0.119916 17.8482 0.387492 17.2983 0.829263 16.9191L11.5821 7.13844C11.325 6.44609 11.2186 5.72033 11.2651 4.97619C11.4196 2.48656 13.6561 0.216152 16.1481 0.0178001C16.7041 -0.0277166 17.2611 0.0144595 17.8 0.139735ZM16.5831 1.25301C16.4717 1.25301 16.3599 1.25761 16.2481 1.26638C14.3776 1.41545 12.6352 3.18517 12.5188 5.05386C12.4757 5.74204 12.6043 6.40934 12.9007 7.03738L13.0975 7.45539L1.66214 17.8566C1.4691 18.0223 1.36065 18.2453 1.3506 18.4809C1.34055 18.7164 1.42974 18.9481 1.59556 19.116L2.77055 20.3095C2.93804 20.479 3.16458 20.5696 3.40954 20.5652C3.64865 20.5575 3.87518 20.4498 4.03054 20.2694L14.5141 8.83508L14.9278 9.01966C15.5388 9.29108 16.1828 9.40843 16.8461 9.36792C18.7321 9.25016 20.5072 7.49923 20.6445 5.61969C20.6679 5.30191 20.655 4.9858 20.6056 4.67595L18.8837 6.6031C18.1743 7.31174 17.0609 7.3109 16.3763 6.62941L15.226 5.48188C14.8939 5.15116 14.7114 4.71144 14.7114 4.24375C14.7114 3.77605 14.8939 3.33634 15.226 3.00561L17.153 1.29268C16.965 1.26638 16.7745 1.25301 16.5831 1.25301Z",
      fill: "currentColor"
    })
  }),
  mouse: ({
    name,
    ...props
  }) => /* @__PURE__ */ jsx(Wrapper$e, {
    $name: name,
    className: `icon icon--${name}`,
    viewBox: "0 0 15 19",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.58113 0.254705C2.60998 1.08177 0.850896 3.11081 0.175083 6.49101C0.0272706 7.23076 0.0323124 7.23581 0.930875 7.23581C1.81683 7.23581 1.83815 7.21633 1.96167 6.29599C2.2126 4.42416 4.0189 2.41987 5.96361 1.85475C6.47809 1.70533 6.47923 1.71083 6.47923 4.47045V7.23581H7.3959H8.31256V4.47045C8.31256 1.71083 8.31371 1.70533 8.82819 1.85475C10.7729 2.41987 12.5792 4.42416 12.8301 6.29599C12.9536 7.21633 12.975 7.23581 13.8609 7.23581C14.7595 7.23581 14.7645 7.23076 14.6167 6.49101C14.1987 4.39987 13.7156 3.43554 12.4559 2.17581C10.5575 0.277392 8.03367 -0.427753 5.58113 0.254705ZM0.124896 10.2723C0.295625 13.1728 0.770917 14.3945 2.33956 15.9648C3.81333 17.4401 5.37327 18.0983 7.3959 18.0983C9.41852 18.0983 10.9785 17.4401 12.4522 15.9648C14.0209 14.3945 14.4962 13.1728 14.6669 10.2723L14.7918 8.15247H7.3959H0L0.124896 10.2723ZM12.8528 11.3432C12.7236 13.1291 11.8007 14.6493 10.2724 15.5944C9.27942 16.2081 8.94896 16.2879 7.3959 16.2879C5.84283 16.2879 5.51238 16.2081 4.5194 15.5944C2.99108 14.6493 2.06823 13.1291 1.93898 11.3432L1.8409 9.9858H7.3959H12.9509L12.8528 11.3432Z",
      fill: "currentColor"
    })
  })
};
function Icon({
  name,
  ...props
}) {
  const Component2 = icons == null ? void 0 : icons[name];
  if (!Component2)
    return null;
  return /* @__PURE__ */ jsx(Component2, {
    name,
    ...props
  });
}
const resolve = (obj, path, defaultValue = null) => {
  if (!obj || !path) {
    return defaultValue;
  }
  const parts = path.split(".");
  return parts.reduce((newObj, part) => {
    if (!newObj) {
      return defaultValue;
    }
    if (newObj[part]) {
      newObj = newObj[part];
      return newObj;
    }
    return defaultValue;
  }, obj);
};
const getViewportWidth = () => Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
const getViewportHeight = () => Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
const getViewportDimensions = () => ({
  width: getViewportWidth(),
  height: getViewportHeight()
});
const getScrollHeight = () => Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight);
const openSocialPopup = (url) => window.open(url, "fbShareWindow", `height=450, width=550, top=${getViewportHeight() / 2 - 275}, left=${getViewportWidth() / 2 - 225}, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0`);
const bodyNoScroll = {
  scrollTop: 0,
  add(breakpoint) {
    var _a2;
    this.breakpoint = breakpoint;
    if (!breakpoint || getViewportWidth() < breakpoint) {
      this.scrollTop = window.scrollY;
      document.documentElement.classList.add("lock-scroll");
      if (typeof window.bb !== "undefined" && typeof ((_a2 = window.bb.header) == null ? void 0 : _a2.destroy) === "function") {
        window.bb.header.headroom.destroy();
      }
    }
  },
  remove() {
    var _a2;
    document.documentElement.classList.remove("lock-scroll");
    window.scrollTo(0, this.scrollTop);
    if (typeof window.bb !== "undefined" && typeof ((_a2 = window.bb.header) == null ? void 0 : _a2.init) === "function") {
      window.bb.header.init();
    }
  }
};
const getUserAgent = () => navigator.userAgent || navigator.vendor || window.opera;
const isAndroid = () => {
  const userAgent = getUserAgent();
  return /android/i.test(userAgent);
};
const isIOS = () => {
  const userAgent = getUserAgent();
  return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
};
const isAndroidOrIOS = () => isAndroid() || isIOS();
const stripHtmlTags = (html) => new DOMParser().parseFromString(html, "text/html").body.textContent;
const getLanguageCode = () => {
  const languageCode = document.documentElement.lang || "en-GB";
  if (languageCode == "en")
    return "en-GB";
  return languageCode;
};
const getTwoLetterIsoName = () => getLanguageCode().split("-")[1];
const getTwoLetterIsoLanguageName = () => getLanguageCode().split("-")[0];
const pluraliseEn = (string, count) => count === 1 ? string : `${string}s`;
const interceptLinkClick = (event, callback) => {
  event.preventDefault();
  callback();
  const link = event.target.closest("a");
  if (link.target === "_blank") {
    window.open(link.href);
  } else {
    window.location.href = link.href;
  }
};
const getContentBasePath = () => {
  const rootEl = document.querySelector("triumph-webapp-root");
  const contentApiEndpoint = rootEl.dataset.apiEntrypoint;
  return contentApiEndpoint;
};
const truncateString = (str, length = 35, delim = " ", ellipses = "...") => {
  if (str.length <= length) {
    return str;
  }
  let trimmedStr = str.substr(0, length + delim.length);
  const lastDelimIndex = trimmedStr.lastIndexOf(delim);
  if (lastDelimIndex >= 0) {
    trimmedStr = trimmedStr.substr(0, lastDelimIndex);
  }
  if (trimmedStr) {
    trimmedStr += ellipses;
  }
  return trimmedStr;
};
const roundPrecisionDecimal = (decimal) => Number(decimal.toFixed(2));
const isIE = () => Boolean(window.document.documentMode);
const isEdge = () => window.navigator.userAgent.toLowerCase().indexOf("edge") > -1;
const isWindows = navigator.appVersion.indexOf("Win") !== -1;
const formatNumber = (number) => new Intl.NumberFormat(getLanguageCode()).format(number);
const toQueryString = (params) => {
  const queryString = Object.keys(params).map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join("&");
  return queryString;
};
const isZhLanguage = (_b = (_a = getLanguageCode()) == null ? void 0 : _a.toLowerCase()) == null ? void 0 : _b.startsWith("zh");
const pxToRem = (px2) => `${px2 / 16}rem`;
const spacingScale = [
  pxToRem(10),
  pxToRem(15),
  pxToRem(20),
  pxToRem(25),
  pxToRem(30),
  pxToRem(40),
  pxToRem(60),
  pxToRem(100)
];
const theme = {
  heights: {
    header: {
      desktop: 70
    },
    tray: {
      mobile: 70,
      desktop: 80
    }
  },
  fonts: {
    dinRegular: isZhLanguage ? '"NotoSansSC-Regular", "DIN2014-Regular", Arial, Helvetica, sans-serif' : '"DIN2014-Regular", Arial, Helvetica, sans-serif',
    dinDemi: isZhLanguage ? '"NotoSansSC-Medium", "DIN2014-Demi", Arial, Helvetica, sans-serif' : '"DIN2014-Demi", Arial, Helvetica, sans-serif'
  },
  colors: {
    body: "#585a5f",
    heading: "#000000",
    primary: "#cd192d",
    buttons: {
      default: "#000000",
      primary: "#cd192d",
      white: "#ffffff"
    },
    hairline: "#e0e0e0",
    outline: "#dadada",
    offWhite: "#f3f3f3",
    gray: {
      5: "#f6f6f6",
      10: "#e6e6e6",
      20: "#cccccc",
      50: "#808080",
      60: "#666666",
      84: "#2a2a2a"
    },
    focus: "#ff611b"
  },
  breakpoints: {
    mobileEnd: 480,
    tablet: 768,
    tabletLarge: 1024,
    desktop: 1260,
    additional: {
      mobile: 375,
      desktopLarge: 1440
    }
  },
  spacing: (number) => spacingScale == null ? void 0 : spacingScale[number - 1],
  widths: {
    full: "83.75rem"
  }
};
const minBp = (breakpoint) => `(min-width: ${resolve(theme.breakpoints, breakpoint)}px)`;
const maxBp = (breakpoint) => `(max-width: ${theme.breakpoints[breakpoint] - 1}px)`;
const Focusable = (offset2 = 1) => `
  &:focus {
    z-index: 8;
    outline: 0.125rem solid ${theme.colors.focus};
    outline-offset: ${0.125 * offset2}rem;
    transition: none;

    /*
     * This class is provided by the legacy site, see the
     * tabbing.js component for more info.
     */ 
    
    .using-mouse & {
      outline: none;
    }
  }
`;
const Wrapper$d = styled.div.withConfig({
  displayName: "Accordionstyled__Wrapper",
  componentId: "sc-18wu3cn-0"
})(["display:flex;flex-direction:column;border:1px solid #000;"]);
const Handle$1 = styled.button.withConfig({
  displayName: "Accordionstyled__Handle",
  componentId: "sc-18wu3cn-1"
})(["display:flex;align-items:first baseline;justify-content:space-between;gap:1.25rem;min-height:3.75rem;padding:", " clamp(", ",5vw,", ");border:none;background-color:#000;font-family:", ";font-weight:600;font-size:1rem;line-height:1.25;text-transform:uppercase;color:#fff;text-align:left;appearance:none;cursor:pointer;.icon{flex-shrink:0;font-size:0.75rem;transition:transform 0.2s ease-in-out;", "}", ""], theme.spacing(3), theme.spacing(5), theme.spacing(6), theme.fonts.dinRegular, ({
  expanded = false
}) => !expanded && css$1(["transform:scaleY(-1);"]), Focusable());
const Panel$1 = styled.div.withConfig({
  displayName: "Accordionstyled__Panel",
  componentId: "sc-18wu3cn-2"
})(["padding:", " clamp(", ",5vw,", ");background-color:#fff;display:flex;flex-direction:column;gap:1rem;"], theme.spacing(5), theme.spacing(5), theme.spacing(6));
const Heading = styled.div.withConfig({
  displayName: "Accordionstyled__Heading",
  componentId: "sc-18wu3cn-3"
})(["font-size:1.2rem;font-family:", ";"], theme.fonts.dinDemi);
const Accordion = ({
  children,
  expanded = false,
  title,
  heading,
  onToggle
}) => /* @__PURE__ */ jsxs(Wrapper$d, {
  children: [/* @__PURE__ */ jsxs(Handle$1, {
    expanded,
    onClick: onToggle,
    "aria-expanded": expanded,
    children: [title, /* @__PURE__ */ jsx(Icon, {
      name: "chevron-down",
      "aria-hidden": true
    })]
  }), expanded && /* @__PURE__ */ jsxs(Panel$1, {
    children: [heading && /* @__PURE__ */ jsx(Heading, {
      children: heading
    }), children]
  })]
});
const Wrapper$c = styled.button.withConfig({
  displayName: "Actionstyled__Wrapper",
  componentId: "sc-d4ftom-0"
})(["display:flex;align-items:first baseline;gap:0.75rem;padding:0;border:none;appearance:none;background:none;cursor:pointer;color:", ";.icon{font-size:0.8125rem;flex-shrink:0;transition:color 0.2s ease-in-out;}&:hover,&:focus{color:", ";}", " ", ""], ({
  primary = false
}) => primary ? theme.colors.primary : "#000", theme.colors.primary, ({
  iconLeft = false
}) => iconLeft && css$1(["flex-direction:row-reverse;"]), Focusable());
const Text$4 = styled.span.withConfig({
  displayName: "Actionstyled__Text",
  componentId: "sc-d4ftom-1"
})(["diaply:block;flex-shrink:0;font-family:", ";font-weight:600;font-size:1rem;line-height:1.25;text-transform:uppercase;transition:color 0.2s ease-in-out;"], theme.fonts.dinRegular);
const Action = ({
  children,
  icon,
  ...props
}) => /* @__PURE__ */ jsxs(Wrapper$c, {
  ...props,
  children: [/* @__PURE__ */ jsx(Text$4, {
    children
  }), /* @__PURE__ */ jsx(Icon, {
    name: icon,
    "aria-hidden": true
  })]
});
const Wrapper$b = styled.div.withConfig({
  displayName: "BikeNamestyled__Wrapper",
  componentId: "sc-cfalie-0"
})(["display:flex;align-items:center;gap:", ";", ""], theme.spacing(4), ({
  padded = false
}) => padded && css$1(["padding:", ";border:1px solid #e6e6e6;"], theme.spacing(3)));
const FamilyAndName = styled.div.withConfig({
  displayName: "BikeNamestyled__FamilyAndName",
  componentId: "sc-cfalie-1"
})([""]);
const Line = styled.p.withConfig({
  displayName: "BikeNamestyled__Line",
  componentId: "sc-cfalie-2"
})(["margin:0;font-family:", ";font-weight:", ";font-size:", ";line-height:1.25;text-transform:uppercase;color:#000;"], theme.fonts.dinRegular, ({
  strong
}) => strong ? 600 : 400, ({
  small = false
}) => small ? "1rem" : "1.25rem");
const BikeName = ({
  name,
  family,
  image,
  padded = false,
  small = false
}) => /* @__PURE__ */ jsxs(Wrapper$b, {
  padded,
  children: [(image == null ? void 0 : image.src) ? /* @__PURE__ */ jsx("img", {
    src: image == null ? void 0 : image.src,
    width: (image == null ? void 0 : image.width) || 84,
    height: (image == null ? void 0 : image.height) || 47,
    alt: image == null ? void 0 : image.alt,
    loading: "lazy"
  }) : null, /* @__PURE__ */ jsxs(FamilyAndName, {
    children: [/* @__PURE__ */ jsx(Line, {
      small,
      strong: true,
      dangerouslySetInnerHTML: {
        __html: family
      }
    }), /* @__PURE__ */ jsx(Line, {
      small,
      dangerouslySetInnerHTML: {
        __html: name
      }
    })]
  })]
});
const Wrapper$a = styled.section.withConfig({
  displayName: "Breadcrumbstyled__Wrapper",
  componentId: "sc-ljh2md-0"
})(["position:relative;margin:0 -1rem;"]);
const Navigation = styled.nav.withConfig({
  displayName: "Breadcrumbstyled__Navigation",
  componentId: "sc-ljh2md-1"
})(["display:flex;align-items:baseline;gap:", `;overflow-y:auto;padding-left:1rem;padding-right:1rem;::-webkit-scrollbar{display:none;}> * + *:before{display:block;flex-shrink:0;content:'';height:0.75rem;width:0.5625rem;background-image:url("data:image/svg+xml,%3Csvg width='9' height='12' viewBox='0 0 9 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2.25685 0.559572L0.75 1.88666L5.25342 5.89844L0.75 9.90259L2.25685 11.2373L8.25 5.89844L2.25685 0.559572Z' fill='%23666666'/%3E%3C/svg%3E%0A");transform:matrix(1,0,0,-1,0,0);}`], theme.spacing(2));
const Item = styled.a.withConfig({
  displayName: "Breadcrumbstyled__Item",
  componentId: "sc-ljh2md-2"
})(["appearance:none;border:none;background:transparent;display:flex;flex-shrink:0;align-items:baseline;gap:", ";font-family:", ";font-weight:600;font-size:1rem;line-height:1.25;text-transform:uppercase;text-decoration:none;text-underline-position:under;color:#666;transition:color 150ms ease-in-out;", " &:focus-visible{outline:none;}", ""], theme.spacing(1), theme.fonts.dinRegular, ({
  $isLink
}) => $isLink && `
    :hover, :focus {
      cursor: pointer;
      text-decoration: underline;
      color: ${theme.colors.primary};
    }
  `, Focusable());
const Home = styled(Icon).withConfig({
  displayName: "Breadcrumbstyled__Home",
  componentId: "sc-ljh2md-3"
})(["transform:translateY(0.125em);"]);
const FadeStart = styled.div.withConfig({
  displayName: "Breadcrumbstyled__FadeStart",
  componentId: "sc-ljh2md-4"
})(["position:absolute;top:0;left:0;bottom:0;width:1rem;background-image:linear-gradient(to right,white,transparent);"]);
const FadeEnd = styled.div.withConfig({
  displayName: "Breadcrumbstyled__FadeEnd",
  componentId: "sc-ljh2md-5"
})(["position:absolute;top:0;right:0;bottom:0;width:1rem;background-image:linear-gradient(to left,white,transparent);"]);
const Breadcrumb = ({
  items = [],
  hasHome = true
}) => {
  const containerRef = useRef();
  useEffect(() => {
    if (containerRef.current) {
      const lastItemWidth = document.getElementById("last-item").offsetWidth;
      containerRef.current.scrollTo({
        left: containerRef.current.scrollWidth - (lastItemWidth + 30),
        behavior: "smooth"
      });
    }
  }, [containerRef.current, items.length]);
  return /* @__PURE__ */ jsxs(Wrapper$a, {
    children: [/* @__PURE__ */ jsx(Navigation, {
      ref: containerRef,
      children: items.map(({
        name,
        path,
        onClick
      }, index) => {
        const isLastItem = index === items.length - 1;
        const isLink = !isLastItem && (onClick || path);
        let as = "span";
        if (onClick) {
          as = "button";
        }
        if (path) {
          as = "a";
        }
        if (isLastItem) {
          as = "span";
        }
        return /* @__PURE__ */ jsxs(Item, {
          as,
          href: !isLastItem ? path : void 0,
          onClick: !isLastItem ? onClick : void 0,
          $isLink: isLink,
          id: isLastItem ? "last-item" : "",
          children: [hasHome && index === 0 && /* @__PURE__ */ jsx(Home, {
            name: "home",
            "aria-hidden": true
          }), name]
        }, path + name);
      })
    }), /* @__PURE__ */ jsx(FadeStart, {}), /* @__PURE__ */ jsx(FadeEnd, {})]
  });
};
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _assertThisInitialized$1(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$1(o, p);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$1(subClass, superClass);
}
function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$1(o);
}
function _isNativeFunction(fn2) {
  return Function.toString.call(fn2).indexOf("[native code]") !== -1;
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct$1()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct2(Parent2, args2, Class2) {
      var a = [null];
      a.push.apply(a, args2);
      var Constructor = Function.bind.apply(Parent2, a);
      var instance = new Constructor();
      if (Class2)
        _setPrototypeOf$1(instance, Class2.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? /* @__PURE__ */ new Map() : void 0;
  _wrapNativeSuper = function _wrapNativeSuper2(Class2) {
    if (Class2 === null || !_isNativeFunction(Class2))
      return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2))
        return _cache.get(Class2);
      _cache.set(Class2, Wrapper2);
    }
    function Wrapper2() {
      return _construct(Class2, arguments, _getPrototypeOf$1(this).constructor);
    }
    Wrapper2.prototype = Object.create(Class2.prototype, {
      constructor: {
        value: Wrapper2,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf$1(Wrapper2, Class2);
  };
  return _wrapNativeSuper(Class);
}
var ERRORS = {
  "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
  "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
  "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
  "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
  "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
  "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
  "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
  "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
  "9": "Please provide a number of steps to the modularScale helper.\n\n",
  "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "11": 'Invalid value passed as base to modularScale, expected number or em string but got "%s"\n\n',
  "12": 'Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.\n\n',
  "13": 'Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.\n\n',
  "14": 'Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.\n\n',
  "15": 'Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.\n\n',
  "16": "You must provide a template to this method.\n\n",
  "17": "You passed an unsupported selector state to this method.\n\n",
  "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "23": "fontFace expects a name of a font-family.\n\n",
  "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "25": "fontFace expects localFonts to be an array.\n\n",
  "26": "fontFace expects fileFormats to be an array.\n\n",
  "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
  "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
  "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
  "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "35": 'borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.\n\n',
  "36": "Property must be a string value.\n\n",
  "37": "Syntax Error at %s.\n\n",
  "38": "Formula contains a function that needs parentheses at %s.\n\n",
  "39": "Formula is missing closing parenthesis at %s.\n\n",
  "40": "Formula has too many closing parentheses at %s.\n\n",
  "41": "All values in a formula must have the same unit or be unitless.\n\n",
  "42": "Please provide a number of steps to the modularScale helper.\n\n",
  "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
  "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
  "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
  "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
  "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
  "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "53": "fontFace expects localFonts to be an array.\n\n",
  "54": "fontFace expects fileFormats to be an array.\n\n",
  "55": "fontFace expects a name of a font-family.\n\n",
  "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
  "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "61": "Property must be a string value.\n\n",
  "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "63": 'borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.\n\n',
  "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
  "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
  "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
  "67": "You must provide a template to this method.\n\n",
  "68": "You passed an unsupported selector state to this method.\n\n",
  "69": 'Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.\n\n',
  "70": 'Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.\n\n',
  "71": 'Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.\n\n',
  "72": 'Passed invalid base value %s to %s(), please pass a value like "12px" or 12.\n\n',
  "73": "Please provide a valid CSS variable.\n\n",
  "74": "CSS variable not found and no default was provided.\n\n",
  "75": "important requires a valid style object, got a %s instead.\n\n",
  "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
  "77": 'remToPx expects a value in "rem" but you provided it in "%s".\n\n',
  "78": 'base must be set in "px" or "%" but you set it in "%s".\n'
};
function format$1() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var a = args[0];
  var b = [];
  var c;
  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }
  b.forEach(function(d) {
    a = a.replace(/%[a-z]/, d);
  });
  return a;
}
var PolishedError = /* @__PURE__ */ function(_Error) {
  _inheritsLoose(PolishedError2, _Error);
  function PolishedError2(code) {
    var _this;
    if (process.env.NODE_ENV === "production") {
      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
    } else {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      _this = _Error.call(this, format$1.apply(void 0, [ERRORS[code]].concat(args))) || this;
    }
    return _assertThisInitialized$1(_this);
  }
  return PolishedError2;
}(/* @__PURE__ */ _wrapNativeSuper(Error));
function colorToInt(color) {
  return Math.round(color * 255);
}
function convertToInt(red2, green2, blue2) {
  return colorToInt(red2) + "," + colorToInt(green2) + "," + colorToInt(blue2);
}
function hslToRgb$1(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }
  if (saturation === 0) {
    return convert(lightness, lightness, lightness);
  }
  var huePrime = (hue % 360 + 360) % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red2 = 0;
  var green2 = 0;
  var blue2 = 0;
  if (huePrime >= 0 && huePrime < 1) {
    red2 = chroma;
    green2 = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red2 = secondComponent;
    green2 = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green2 = chroma;
    blue2 = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green2 = secondComponent;
    blue2 = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red2 = secondComponent;
    blue2 = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red2 = chroma;
    blue2 = secondComponent;
  }
  var lightnessModification = lightness - chroma / 2;
  var finalRed = red2 + lightnessModification;
  var finalGreen = green2 + lightnessModification;
  var finalBlue = blue2 + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}
var namedColorMap = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "00ffff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "0000ff",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "00ffff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "ff00ff",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "639",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};
function nameToHex(color) {
  if (typeof color !== "string")
    return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}
var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var hslaRegex = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
function parseToRgb(color) {
  if (typeof color !== "string") {
    throw new PolishedError(3);
  }
  var normalizedColor = nameToHex(color);
  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }
  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha
    };
  }
  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }
  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }
  var rgbMatched = rgbRegex.exec(normalizedColor);
  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }
  var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));
  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4])
    };
  }
  var hslMatched = hslRegex.exec(normalizedColor);
  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb$1(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);
    if (!hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, rgbColorString);
    }
    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }
  var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));
  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);
    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
    var _rgbColorString = "rgb(" + hslToRgb$1(_hue, _saturation, _lightness) + ")";
    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);
    if (!_hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, _rgbColorString);
    }
    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4])
    };
  }
  throw new PolishedError(5);
}
function rgbToHsl(color) {
  var red2 = color.red / 255;
  var green2 = color.green / 255;
  var blue2 = color.blue / 255;
  var max2 = Math.max(red2, green2, blue2);
  var min2 = Math.min(red2, green2, blue2);
  var lightness = (max2 + min2) / 2;
  if (max2 === min2) {
    if (color.alpha !== void 0) {
      return {
        hue: 0,
        saturation: 0,
        lightness,
        alpha: color.alpha
      };
    } else {
      return {
        hue: 0,
        saturation: 0,
        lightness
      };
    }
  }
  var hue;
  var delta = max2 - min2;
  var saturation = lightness > 0.5 ? delta / (2 - max2 - min2) : delta / (max2 + min2);
  switch (max2) {
    case red2:
      hue = (green2 - blue2) / delta + (green2 < blue2 ? 6 : 0);
      break;
    case green2:
      hue = (blue2 - red2) / delta + 2;
      break;
    default:
      hue = (red2 - green2) / delta + 4;
      break;
  }
  hue *= 60;
  if (color.alpha !== void 0) {
    return {
      hue,
      saturation,
      lightness,
      alpha: color.alpha
    };
  }
  return {
    hue,
    saturation,
    lightness
  };
}
function parseToHsl(color) {
  return rgbToHsl(parseToRgb(color));
}
var reduceHexValue = function reduceHexValue2(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }
  return value;
};
var reduceHexValue$1 = reduceHexValue;
function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}
function colorToHex(color) {
  return numberToHex(Math.round(color * 255));
}
function convertToHex(red2, green2, blue2) {
  return reduceHexValue$1("#" + colorToHex(red2) + colorToHex(green2) + colorToHex(blue2));
}
function hslToHex(hue, saturation, lightness) {
  return hslToRgb$1(hue, saturation, lightness, convertToHex);
}
function hsl(value, saturation, lightness) {
  if (typeof value === "number" && typeof saturation === "number" && typeof lightness === "number") {
    return hslToHex(value, saturation, lightness);
  } else if (typeof value === "object" && saturation === void 0 && lightness === void 0) {
    return hslToHex(value.hue, value.saturation, value.lightness);
  }
  throw new PolishedError(1);
}
function hsla(value, saturation, lightness, alpha) {
  if (typeof value === "number" && typeof saturation === "number" && typeof lightness === "number" && typeof alpha === "number") {
    return alpha >= 1 ? hslToHex(value, saturation, lightness) : "rgba(" + hslToRgb$1(value, saturation, lightness) + "," + alpha + ")";
  } else if (typeof value === "object" && saturation === void 0 && lightness === void 0 && alpha === void 0) {
    return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + hslToRgb$1(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
  }
  throw new PolishedError(2);
}
function rgb(value, green2, blue2) {
  if (typeof value === "number" && typeof green2 === "number" && typeof blue2 === "number") {
    return reduceHexValue$1("#" + numberToHex(value) + numberToHex(green2) + numberToHex(blue2));
  } else if (typeof value === "object" && green2 === void 0 && blue2 === void 0) {
    return reduceHexValue$1("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }
  throw new PolishedError(6);
}
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === "string" && typeof secondValue === "number") {
    var rgbValue = parseToRgb(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === "number" && typeof secondValue === "number" && typeof thirdValue === "number" && typeof fourthValue === "number") {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === "object" && secondValue === void 0 && thirdValue === void 0 && fourthValue === void 0) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }
  throw new PolishedError(7);
}
var isRgb = function isRgb2(color) {
  return typeof color.red === "number" && typeof color.green === "number" && typeof color.blue === "number" && (typeof color.alpha !== "number" || typeof color.alpha === "undefined");
};
var isRgba = function isRgba2(color) {
  return typeof color.red === "number" && typeof color.green === "number" && typeof color.blue === "number" && typeof color.alpha === "number";
};
var isHsl = function isHsl2(color) {
  return typeof color.hue === "number" && typeof color.saturation === "number" && typeof color.lightness === "number" && (typeof color.alpha !== "number" || typeof color.alpha === "undefined");
};
var isHsla = function isHsla2(color) {
  return typeof color.hue === "number" && typeof color.saturation === "number" && typeof color.lightness === "number" && typeof color.alpha === "number";
};
function toColorString(color) {
  if (typeof color !== "object")
    throw new PolishedError(8);
  if (isRgba(color))
    return rgba(color);
  if (isRgb(color))
    return rgb(color);
  if (isHsla(color))
    return hsla(color);
  if (isHsl(color))
    return hsl(color);
  throw new PolishedError(8);
}
function curried(f, length, acc) {
  return function fn2() {
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
}
function curry(f) {
  return curried(f, f.length, []);
}
function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
function darken$1(amount, color) {
  if (color === "transparent")
    return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness - parseFloat(amount))
  }));
}
var curriedDarken = /* @__PURE__ */ curry(darken$1);
var curriedDarken$1 = curriedDarken;
const buttonStyles = css$1(["background-color:", ";color:", " !important;padding:2px 30px 0;font-family:", ";font-size:17px;font-weight:500;text-transform:uppercase;text-decoration:none !important;border:0;height:40px;outline:none;transition:background-color 0.1s ease-in-out;justify-content:center;display:flex;align-items:center;line-height:1;cursor:pointer;transition:background 250ms,border-color 250ms;", " &:disabled{cursor:default;background:#f4f4f4;color:#63656a !important;pointer-events:none;svg{filter:invert(1);}}@media ", "{&:focus{outline-offset:-0.125rem;background:#8f111f;}&:hover:not(:disabled){background:#8f111f;}}", " ", " ", " ", " ", ""], theme.colors.buttons.default, theme.colors.buttons.white, theme.fonts.dinDemi, Focusable(), minBp("tabletLarge"), ({
  small = false
}) => small && css$1(["font-size:12px;height:29px;@media ", "{font-size:12px;}@media ", "{font-size:17px;height:40px;}"], minBp("tablet"), minBp("tabletLarge")), ({
  large = false
}) => large && `height: 48px;`, ({
  wide = false
}) => wide && `width: 280px;`, ({
  fluid = false
}) => fluid && css$1(["width:100%;@media ", "{max-width:222px;}"], minBp("tablet")), ({
  primary = false
}) => primary && css$1(["background-color:", ";&:focus{background-color:", ";}"], theme.colors.buttons.primary, curriedDarken$1(0.1, theme.colors.buttons.primary)));
const Wrap$m = styled.button.withConfig({
  displayName: "Buttonstyled__Wrap",
  componentId: "sc-1f9octj-0"
})(["", ""], buttonStyles);
const LinkWrap = styled.a.withConfig({
  displayName: "Buttonstyled__LinkWrap",
  componentId: "sc-1f9octj-1"
})(["", " text-align:center;"], buttonStyles);
const Button = ({
  children,
  ...props
}) => /* @__PURE__ */ jsx(Wrap$m, {
  ...props,
  children
});
const LinkButton = ({
  children,
  ...props
}) => /* @__PURE__ */ jsx(LinkWrap, {
  ...props,
  children
});
const Wrap$l = styled.div.withConfig({
  displayName: "Containerstyled__Wrap",
  componentId: "sc-v6hd5z-0"
})(["margin:0 1.25rem;max-width:", "px;@media ", "{margin:0 auto;}"], ({
  maxSize
}) => theme.breakpoints[maxSize || "tabletLarge"], ({
  maxSize
}) => minBp(maxSize));
function Container({
  className = "",
  maxSize = "tabletLarge",
  children
}) {
  return /* @__PURE__ */ jsx(Wrap$l, {
    className,
    maxSize,
    children
  });
}
const Wrap$k = styled.div.withConfig({
  displayName: "DataTablestyled__Wrap",
  componentId: "sc-2axfj-0"
})([""]);
const Header$2 = styled.div.withConfig({
  displayName: "DataTablestyled__Header",
  componentId: "sc-2axfj-1"
})(["background:", ";padding:2px 10px 0;text-transform:uppercase;font-family:", ";margin-bottom:16px;color:black;height:34px;display:flex;align-items:center;@media ", "{margin-bottom:28px;}"], theme.colors.offWhite, theme.fonts.dinDemi, minBp("desktop"));
const TableRow$1 = styled.dl.withConfig({
  displayName: "DataTablestyled__TableRow",
  componentId: "sc-2axfj-2"
})(["display:flex;margin-bottom:16px;@media ", "{margin-bottom:33px;}"], minBp("desktop"));
const TableTerm = styled.dt.withConfig({
  displayName: "DataTablestyled__TableTerm",
  componentId: "sc-2axfj-3"
})(["min-width:85px;color:black;font-family:", ";@media ", "{min-width:100px;}"], theme.fonts.dinDemi, minBp("desktop"));
const TableDefinition = styled.dd.withConfig({
  displayName: "DataTablestyled__TableDefinition",
  componentId: "sc-2axfj-4"
})(["flex:1;overflow-wrap:break-word;min-width:1%;"]);
const DataTable = ({
  headerText,
  tableData = [],
  ...props
}) => /* @__PURE__ */ jsxs(Wrap$k, {
  ...props,
  children: [/* @__PURE__ */ jsx(Header$2, {
    children: headerText
  }), tableData.map((tableRow) => /* @__PURE__ */ jsxs(TableRow$1, {
    children: [/* @__PURE__ */ jsx(TableTerm, {
      children: tableRow.term
    }), /* @__PURE__ */ jsx(TableDefinition, {
      children: tableRow.definition
    })]
  }, tableRow.term))]
});
const DealerAddressComponent = styled.span.withConfig({
  displayName: "DealerAddressstyled__DealerAddressComponent",
  componentId: "sc-7up5u5-0"
})(["white-space:pre-wrap;"]);
const DealerAddress$1 = ({
  dealer,
  format: format2 = "single"
}) => /* @__PURE__ */ jsxs(Fragment, {
  children: [format2 === "multi" && dealer.AS400MultilineAddress && /* @__PURE__ */ jsx(DealerAddressComponent, {
    dangerouslySetInnerHTML: {
      __html: dealer.AS400MultilineAddress
    }
  }), format2 === "single" && dealer.AS400SingleLineAddress && /* @__PURE__ */ jsx(DealerAddressComponent, {
    dangerouslySetInnerHTML: {
      __html: dealer.AS400SingleLineAddress
    }
  }), !dealer.AS400SingleLineAddress && !dealer.AS400MultilineAddress && /* @__PURE__ */ jsx("span", {
    children: dealer.AddressLine1
  })]
});
const getHostname = () => process.env.HOSTNAME || window.location.origin;
const getImageBaseUrl = () => process.env.HOSTNAME || "";
const getApiEntrypoint = () => {
  var _a2, _b2;
  return (_b2 = (_a2 = document.querySelector(".triumph-webapp-root")) == null ? void 0 : _a2.dataset) == null ? void 0 : _b2.apiEntrypoint;
};
const request = async (url, options, absolute = false) => {
  const res = await fetch((absolute ? "" : getHostname()) + url, options);
  if (!res.ok) {
    throw new Error(`${res.status} ${res.statusText}`);
  }
  const data = res.status === 204 ? null : await res.json();
  const headers = {};
  for (const [headerName, headerValue] of res.headers.entries()) {
    headers[headerName] = headerValue;
  }
  if (headers["x-total-count"]) {
    headers["x-total-count"] = parseInt(headers["x-total-count"], 10);
  }
  return {
    headers: {
      get: (headerName) => headers[headerName.toLowerCase()]
    },
    data
  };
};
const Wrap$j = styled.div.withConfig({
  displayName: "DealerCardstyled__Wrap",
  componentId: "sc-c2icyq-0"
})(["margin-bottom:", ";@media ", "{margin-bottom:", ";border:1px solid ", ";display:flex;min-height:250px;}"], ({
  extended
}) => extended ? 0 : "20px", minBp("tablet"), ({
  extended
}) => extended ? 0 : "34px", theme.colors.hairline);
const MapWrap = styled.div.withConfig({
  displayName: "DealerCardstyled__MapWrap",
  componentId: "sc-c2icyq-1"
})(["margin-bottom:16px;img{width:100%;height:auto;}", " @media ", "{margin:0;flex:1;width:50%;img{width:100%;height:100%;object-fit:cover;}}"], ({
  extended
}) => extended ? `
    height: auto;

    img {
      height: 100%;
      object-fit: cover;
      vertical-align: middle;
    }
  ` : ``, minBp("tablet"));
const AddressWrap = styled.div.withConfig({
  displayName: "DealerCardstyled__AddressWrap",
  componentId: "sc-c2icyq-2"
})(["@media ", "{padding:", ";flex:1;width:50%;display:flex;flex-direction:column;justify-content:center;}"], minBp("tablet"), ({
  extended
}) => extended ? "40px 40px 40px 50px" : "52px 91px 52px 52px");
const DealerTitle = styled.h4.withConfig({
  displayName: "DealerCardstyled__DealerTitle",
  componentId: "sc-c2icyq-3"
})(["text-transform:uppercase;font-size:14px;margin:0 0 9px;@media ", "{font-size:16px;line-height:30px;margin-bottom:12px;}"], minBp("tablet"));
const DealerAddress = styled.div.withConfig({
  displayName: "DealerCardstyled__DealerAddress",
  componentId: "sc-c2icyq-4"
})(["margin-bottom:10px;font-size:14px;line-height:22px;@media ", "{font-size:18px;line-height:22px;margin-bottom:14px;}"], minBp("tablet"));
const DealerDistance = styled.div.withConfig({
  displayName: "DealerCardstyled__DealerDistance",
  componentId: "sc-c2icyq-5"
})(["font-size:14px;opacity:0.5;"]);
const PhoneNumber = styled.div.withConfig({
  displayName: "DealerCardstyled__PhoneNumber",
  componentId: "sc-c2icyq-6"
})(["font-size:14px;margin-bottom:20px;svg{vertical-align:middle;margin-right:12px;width:15px;width:15px;}@media ", "{font-size:16px;}"], minBp("tablet"));
const OpeningTimesHeader = styled.div.withConfig({
  displayName: "DealerCardstyled__OpeningTimesHeader",
  componentId: "sc-c2icyq-7"
})(["display:flex;align-items:center;justify-content:space-between;margin:0 0 16px;@media ", "{justify-content:flex-start;}"], minBp("tablet"));
const OpeningTimesTitle = styled.h4.withConfig({
  displayName: "DealerCardstyled__OpeningTimesTitle",
  componentId: "sc-c2icyq-8"
})(["text-transform:uppercase;font-size:14px;margin-bottom:0;@media ", "{font-size:16px;line-height:30px;}"], minBp("tablet"));
const OpeningTimesGuidance = styled.div.withConfig({
  displayName: "DealerCardstyled__OpeningTimesGuidance",
  componentId: "sc-c2icyq-9"
})(["background:#fff3e7;padding:8px 15px;font-size:11px;color:#df7802;line-height:18px;margin-bottom:18px;@media ", "{font-size:12px;line-height:20px;margin-bottom:16px;}"], minBp("tablet"));
const OpeningTimes = styled.div.withConfig({
  displayName: "DealerCardstyled__OpeningTimes",
  componentId: "sc-c2icyq-10"
})(["font-size:14px;line-height:22px;margin-bottom:28px;@media ", "{margin-bottom:18px;}"], minBp("tablet"));
const Actions$1 = styled.div.withConfig({
  displayName: "DealerCardstyled__Actions",
  componentId: "sc-c2icyq-11"
})(["@media ", "{display:flex;flex-wrap:wrap;}"], minBp("tablet"));
const VisitDealerButton = styled(LinkButton).withConfig({
  displayName: "DealerCardstyled__VisitDealerButton",
  componentId: "sc-c2icyq-12"
})(["margin-bottom:10px;@media ", "{max-width:190px;margin:10px 25px 0 0;padding-left:0;padding-right:0;text-align:center;}"], minBp("tablet"));
const DirectionsButton = styled.a.withConfig({
  displayName: "DealerCardstyled__DirectionsButton",
  componentId: "sc-c2icyq-13"
})(["display:inline-flex;align-items:center;appearance:none;width:auto;margin:0 auto;padding:0 10px;font-size:15px;font-family:", ";color:black !important;text-transform:uppercase;height:40px;position:relative;left:50%;transform:translateX(-50%);text-decoration:none !important;svg{display:none;}@media ", "{left:inherit;transform:none;margin:10px 0 0;svg{display:inline-block;vertical-align:middle;width:17px;height:22px;margin-right:12px;}}"], theme.fonts.dinDemi, minBp("tablet"));
const SectionHeading = styled.div.withConfig({
  displayName: "DealerCardstyled__SectionHeading",
  componentId: "sc-c2icyq-14"
})(["color:rgb(88,90,95);font-family:", ";font-size:12px;text-transform:uppercase;line-height:1;"], theme.fonts.dinDemi);
const Status = styled(SectionHeading).withConfig({
  displayName: "DealerCardstyled__Status",
  componentId: "sc-c2icyq-15"
})(["", ""], ({
  isOpen
}) => `
    color: ${isOpen ? "#6ecd34" : "#cd192d"};
    display: inline-block;
    margin-left: 10px;
  `);
const HoursTable = styled.table.withConfig({
  displayName: "DealerCardstyled__HoursTable",
  componentId: "sc-c2icyq-16"
})(["width:100%;display:flex;"]);
const TableBody = styled.tbody.withConfig({
  displayName: "DealerCardstyled__TableBody",
  componentId: "sc-c2icyq-17"
})(["width:50%;@media ", "{width:auto;padding-right:40px;}"], minBp("tablet"));
const TableRow = styled.tr.withConfig({
  displayName: "DealerCardstyled__TableRow",
  componentId: "sc-c2icyq-18"
})(["display:flex;flex-direction:column;align-items:baseline;justify-content:flex-start;text-align:left;padding-bottom:10px;@media ", "{flex-direction:row;padding-bottom:15px;}"], minBp("tablet"));
const TableHeader = styled.th.withConfig({
  displayName: "DealerCardstyled__TableHeader",
  componentId: "sc-c2icyq-19"
})(["color:#000;font-family:", ";font-weight:normal;font-size:16px;min-width:40px;"], theme.fonts.dinRegular);
const TableData = styled.td.withConfig({
  displayName: "DealerCardstyled__TableData",
  componentId: "sc-c2icyq-20"
})(["color:rgb(88,90,95);font-family:", ";font-size:14px;white-space:pre-line;"], theme.fonts.dinRegular);
const DealerCard = ({
  dealer,
  markerImg,
  extended,
  labels = {},
  onVisitClick,
  onDirectionsClick,
  ...props
}) => {
  const [staticMap, setStaticMap] = useState();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const contentRes = await request(`/data/staticMaps?size=${extended ? "450x527" : "450x250"}&center=${dealer.Latitude},${dealer.Longitude}&zoom=14`);
        setStaticMap(contentRes.data.url);
      } catch (ex) {
        console.error(ex);
      }
    };
    fetchData();
  }, []);
  return /* @__PURE__ */ jsxs(Wrap$j, {
    ...props,
    children: [/* @__PURE__ */ jsx(MapWrap, {
      extended,
      children: /* @__PURE__ */ jsx("img", {
        src: staticMap,
        alt: "",
        loading: "lazy"
      })
    }), /* @__PURE__ */ jsxs(AddressWrap, {
      extended,
      children: [/* @__PURE__ */ jsx(DealerTitle, {
        children: dealer.Title
      }), dealer.AS400MultilineAddress && /* @__PURE__ */ jsx(DealerAddress, {
        dangerouslySetInnerHTML: {
          __html: dealer.AS400MultilineAddress
        }
      }), !dealer.AS400MultilineAddress && /* @__PURE__ */ jsx(DealerAddress, {
        children: dealer.AddressLine1
      }), extended ? /* @__PURE__ */ jsx(Fragment, {
        children: dealer.Phone && /* @__PURE__ */ jsxs(PhoneNumber, {
          children: [/* @__PURE__ */ jsx(Icon, {
            name: "phone"
          }), " ", dealer.Phone]
        })
      }) : /* @__PURE__ */ jsxs(DealerDistance, {
        children: [dealer.Distance, " ", dealer.DistanceMeasurement]
      }), extended ? /* @__PURE__ */ jsxs(Fragment, {
        children: [dealer.OpeningTimes || dealer.OpeningTimesDetail ? /* @__PURE__ */ jsxs(OpeningTimesHeader, {
          children: [/* @__PURE__ */ jsx(OpeningTimesTitle, {
            children: labels.openingTimesLabel
          }), dealer.OpeningTimesDetail ? /* @__PURE__ */ jsxs(Status, {
            isOpen: dealer.OpeningTimesDetail.IsOpen,
            children: ["\xA0- ", dealer.OpeningTimesDetail.Status]
          }) : null]
        }) : null, labels.openingTimesGuidance ? /* @__PURE__ */ jsx(OpeningTimesGuidance, {
          children: labels.openingTimesGuidance
        }) : null, dealer.OpeningTimesDetail ? /* @__PURE__ */ jsxs(HoursTable, {
          children: [/* @__PURE__ */ jsxs(TableBody, {
            children: [/* @__PURE__ */ jsxs(TableRow, {
              children: [/* @__PURE__ */ jsx(TableHeader, {
                children: dealer.OpeningTimesDetail.OpeningTimesDays.Mon.Label
              }), /* @__PURE__ */ jsx(TableData, {
                children: dealer.OpeningTimesDetail.OpeningTimesDays.Mon.Value
              })]
            }), /* @__PURE__ */ jsxs(TableRow, {
              children: [/* @__PURE__ */ jsx(TableHeader, {
                children: dealer.OpeningTimesDetail.OpeningTimesDays.Tue.Label
              }), /* @__PURE__ */ jsx(TableData, {
                children: dealer.OpeningTimesDetail.OpeningTimesDays.Tue.Value
              })]
            }), /* @__PURE__ */ jsxs(TableRow, {
              children: [/* @__PURE__ */ jsx(TableHeader, {
                children: dealer.OpeningTimesDetail.OpeningTimesDays.Wed.Label
              }), /* @__PURE__ */ jsx(TableData, {
                children: dealer.OpeningTimesDetail.OpeningTimesDays.Wed.Value
              })]
            }), /* @__PURE__ */ jsxs(TableRow, {
              children: [/* @__PURE__ */ jsx(TableHeader, {
                children: dealer.OpeningTimesDetail.OpeningTimesDays.Thu.Label
              }), /* @__PURE__ */ jsx(TableData, {
                children: dealer.OpeningTimesDetail.OpeningTimesDays.Thu.Value
              })]
            })]
          }), /* @__PURE__ */ jsxs(TableBody, {
            children: [/* @__PURE__ */ jsxs(TableRow, {
              children: [/* @__PURE__ */ jsx(TableHeader, {
                children: dealer.OpeningTimesDetail.OpeningTimesDays.Fri.Label
              }), /* @__PURE__ */ jsx(TableData, {
                children: dealer.OpeningTimesDetail.OpeningTimesDays.Fri.Value
              })]
            }), /* @__PURE__ */ jsxs(TableRow, {
              children: [/* @__PURE__ */ jsx(TableHeader, {
                children: dealer.OpeningTimesDetail.OpeningTimesDays.Sat.Label
              }), /* @__PURE__ */ jsx(TableData, {
                children: dealer.OpeningTimesDetail.OpeningTimesDays.Sat.Value
              })]
            }), /* @__PURE__ */ jsxs(TableRow, {
              children: [/* @__PURE__ */ jsx(TableHeader, {
                children: dealer.OpeningTimesDetail.OpeningTimesDays.Sun.Label
              }), /* @__PURE__ */ jsx(TableData, {
                children: dealer.OpeningTimesDetail.OpeningTimesDays.Sun.Value
              })]
            })]
          })]
        }) : /* @__PURE__ */ jsx(OpeningTimes, {
          dangerouslySetInnerHTML: {
            __html: dealer.OpeningTimes
          }
        }), /* @__PURE__ */ jsxs(Actions$1, {
          children: [/* @__PURE__ */ jsx(VisitDealerButton, {
            href: dealer.DealerUrl,
            target: "_blank",
            onClick: (event) => interceptLinkClick(event, onVisitClick),
            fluid: true,
            primary: true,
            children: labels.visitDealerLabel
          }), /* @__PURE__ */ jsxs(DirectionsButton, {
            href: `https://www.google.com/maps/dir/?api=1&destination=${encodeURI(`${dealer.Latitude},${dealer.Longitude}`)}`,
            target: "_blank",
            onClick: (event) => interceptLinkClick(event, onDirectionsClick),
            children: [/* @__PURE__ */ jsx(Icon, {
              name: "location"
            }), labels.directionsLabel]
          })]
        })]
      }) : null]
    })]
  });
};
const logo$1 = "data:image/svg+xml;base64,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";
function DummyHeader() {
  const primaryNavigationItems = [{
    itemId: "6cd117d4-fa4b-45d7-8ed1-1b4e0cd6c961",
    label: "Motorcycles"
  }, {
    itemId: "e7a07942-4591-4171-9118-543076cb3c8f",
    label: "Motorcycles New"
  }, {
    itemId: "f13a0bd3-1aa2-427c-99b7-862499e9cbad",
    label: "Accessories"
  }, {
    itemId: "50756d1b-d866-41ba-81a6-9544b232673c",
    label: "Clothing Shop",
    path: "/clothing-shop"
  }, {
    itemId: "45bf6543-ec46-4ca9-9ebe-ee9c91b7f099",
    label: "Owners",
    path: "/owners"
  }, {
    itemId: "f19ba617-110a-489b-aa91-e8522a4e708c",
    label: "For the Ride",
    path: "/for-the-ride"
  }];
  return /* @__PURE__ */ jsx(_StyledDiv, {
    "data-navigation-target": "header",
    "data-navigation-version": "2",
    children: /* @__PURE__ */ jsxs(_StyledDiv2, {
      children: [/* @__PURE__ */ jsxs(_StyledDiv3, {
        children: [/* @__PURE__ */ jsx(_StyledButton, {
          "data-navigation-target": "mobile-menu",
          type: "button",
          children: "="
        }), /* @__PURE__ */ jsx("a", {
          href: "/",
          children: /* @__PURE__ */ jsx("img", {
            src: logo$1,
            alt: "Triumph",
            loading: "lazy"
          })
        }), /* @__PURE__ */ jsx(_StyledNav, {
          children: primaryNavigationItems.map(({
            itemId,
            label,
            path
          }) => /* @__PURE__ */ jsx(_StyledA, {
            href: path || "#",
            "data-navigation-target": "primary-navigation",
            "data-item-id": itemId,
            children: label
          }, itemId))
        })]
      }), /* @__PURE__ */ jsxs(_StyledDiv4, {
        children: [/* @__PURE__ */ jsxs(_StyledNav2, {
          children: [/* @__PURE__ */ jsx(_StyledA2, {
            href: "/",
            children: "Dealers"
          }), /* @__PURE__ */ jsx(_StyledA3, {
            href: "/",
            children: "Configure"
          })]
        }), /* @__PURE__ */ jsx(_StyledButton2, {
          type: "button",
          children: /* @__PURE__ */ jsx(Icon, {
            name: "cart"
          })
        }), /* @__PURE__ */ jsx(_StyledButton3, {
          type: "button",
          "data-navigation-target": "country-picker",
          children: "United Kingdom"
        })]
      })]
    })
  });
}
var _StyledDiv = styled("div").withConfig({
  displayName: "dummy-header___StyledDiv",
  componentId: "sc-fvdeqd-0"
})({
  "height": "60px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(0 0 0 / var(--tw-bg-opacity))",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "@media (min-width: 1024px)": {
    "height": "80px"
  },
  "@media (min-width: 1260px)": {
    "height": "70px"
  }
});
var _StyledDiv2 = styled("div").withConfig({
  displayName: "dummy-header___StyledDiv2",
  componentId: "sc-fvdeqd-1"
})({
  "display": "flex",
  "height": "100%",
  "alignItems": "center",
  "justifyContent": "space-between",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))"
});
var _StyledDiv3 = styled("div").withConfig({
  displayName: "dummy-header___StyledDiv3",
  componentId: "sc-fvdeqd-2"
})({
  "display": "flex",
  "height": "100%",
  "alignItems": "center",
  "gap": "0.5rem"
});
var _StyledButton = styled("button").withConfig({
  displayName: "dummy-header___StyledButton",
  componentId: "sc-fvdeqd-3"
})({
  "@media (min-width: 1024px)": {
    "display": "none"
  }
});
var _StyledNav = styled("nav").withConfig({
  displayName: "dummy-header___StyledNav",
  componentId: "sc-fvdeqd-4"
})({
  "display": "none",
  "height": "100%",
  "@media (min-width: 1024px)": {
    "display": "flex"
  }
});
var _StyledA = styled("a").withConfig({
  displayName: "dummy-header___StyledA",
  componentId: "sc-fvdeqd-5"
})({
  "display": "flex",
  "height": "100%",
  "cursor": "pointer",
  "alignItems": "center",
  "padding": "0.5rem",
  "textTransform": "uppercase",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "textDecorationLine": "none",
  ":hover": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(42 42 42 / var(--tw-bg-opacity))"
  }
});
var _StyledDiv4 = styled("div").withConfig({
  displayName: "dummy-header___StyledDiv4",
  componentId: "sc-fvdeqd-6"
})({
  "display": "none",
  "alignItems": "center",
  "gap": "0.5rem",
  "@media (min-width: 1024px)": {
    "display": "flex"
  }
});
var _StyledNav2 = styled("nav").withConfig({
  displayName: "dummy-header___StyledNav2",
  componentId: "sc-fvdeqd-7"
})({
  "display": "flex",
  "gap": "0.5rem"
});
var _StyledA2 = styled("a").withConfig({
  displayName: "dummy-header___StyledA2",
  componentId: "sc-fvdeqd-8"
})({
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "textDecorationLine": "none"
});
var _StyledA3 = styled("a").withConfig({
  displayName: "dummy-header___StyledA3",
  componentId: "sc-fvdeqd-9"
})({
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "textDecorationLine": "none"
});
var _StyledButton2 = styled("button").withConfig({
  displayName: "dummy-header___StyledButton2",
  componentId: "sc-fvdeqd-10"
})({
  "appearance": "none",
  "borderWidth": "0px",
  "padding": "0.5rem"
});
var _StyledButton3 = styled("button").withConfig({
  displayName: "dummy-header___StyledButton3",
  componentId: "sc-fvdeqd-11"
})({
  "appearance": "none",
  "borderWidth": "0px",
  "padding": "0.5rem"
});
const EcommUspsComponent = styled.div.withConfig({
  displayName: "EcommUspsstyled__EcommUspsComponent",
  componentId: "sc-10v9bgb-0"
})(["padding:", ";display:none;flex-direction:column;gap:3rem;background:white;@media ", "{display:flex;}"], `${theme.spacing(7)} ${theme.spacing(6)}`, minBp("tabletLarge"));
const Usp = styled.div.withConfig({
  displayName: "EcommUspsstyled__Usp",
  componentId: "sc-10v9bgb-1"
})(["display:flex;gap:1rem;"]);
const IconWrapper = styled.div.withConfig({
  displayName: "EcommUspsstyled__IconWrapper",
  componentId: "sc-10v9bgb-2"
})(["display:flex;justify-content:center;align-items:start;width:2rem;height:2rem;font-size:1.75rem;color:", ";"], theme.colors.gray["84"]);
const TitleAndDescription = styled.div.withConfig({
  displayName: "EcommUspsstyled__TitleAndDescription",
  componentId: "sc-10v9bgb-3"
})(["display:flex;flex-direction:column;gap:0.75rem;font-weight:600;"]);
const Title$7 = styled.div.withConfig({
  displayName: "EcommUspsstyled__Title",
  componentId: "sc-10v9bgb-4"
})(["font-size:1rem;color:", ";"], theme.colors.gray["84"]);
const Description$4 = styled.div.withConfig({
  displayName: "EcommUspsstyled__Description",
  componentId: "sc-10v9bgb-5"
})(["font-size:0.875rem;color:", ";"], theme.colors.gray["60"]);
const EcommUsps = ({
  usps
}) => {
  return /* @__PURE__ */ jsx(EcommUspsComponent, {
    children: usps.map(({
      icon,
      title,
      description
    }) => /* @__PURE__ */ jsxs(Usp, {
      children: [/* @__PURE__ */ jsx(IconWrapper, {
        children: icon
      }), /* @__PURE__ */ jsxs(TitleAndDescription, {
        children: [/* @__PURE__ */ jsx(Title$7, {
          children: title
        }), /* @__PURE__ */ jsx(Description$4, {
          children: description
        })]
      })]
    }, title))
  });
};
const Wrap$i = styled.div.withConfig({
  displayName: "FormFieldCheckboxstyled__Wrap",
  componentId: "sc-nbsgx8-0"
})(["display:flex;align-items:", ";a{color:#000;}"], ({
  labelVerticalAlignment
}) => labelVerticalAlignment === "top" ? "start" : "center");
const Input$2 = styled.input.withConfig({
  displayName: "FormFieldCheckboxstyled__Input",
  componentId: "sc-nbsgx8-1"
})(["&,&[type='checkbox']{appearance:none;width:", ";height:", ";min-width:", ";position:relative;background:white;border:1px solid ", ";position:relative;margin-right:", ';;cursor:pointer;&:checked{background-color:#000;border-color:#000;}&:checked:after{content:"\\e914";font-family:triumph;width:16px;height:16px;position:absolute;bottom:3px;left:', ";;font-size:16px;color:#fff;}", "}", ""], ({
  large = false
}) => large ? "25px" : "20px", ({
  large = false
}) => large ? "25px" : "20px", ({
  large = false
}) => large ? "25px" : "20px", theme.colors.outline, ({
  large = false
}) => large ? "20px" : "10px", ({
  large = false
}) => large ? "2px" : "0px", ({
  error = false
}) => error && `border-color: #cd192d;`, Focusable());
const Label$3 = styled.label.withConfig({
  displayName: "FormFieldCheckboxstyled__Label",
  componentId: "sc-nbsgx8-2"
})(["font-size:", ";font-weight:", ";font-family:", ";line-height:1.4;color:black;cursor:pointer;.required{color:", ";}p{color:black;font-size:13px;letter-spacing:normal;}p:last-child{margin:0;}*{", "}@media ", "{font-size:16px;p{font-size:16px;color:black;letter-spacing:normal;}}"], ({
  large = false
}) => large ? "14px" : "13px", ({
  bold = false
}) => bold ? "bold" : "regular", theme.fonts.dinRegular, theme.colors.primary, Focusable(), minBp("tabletLarge"));
const Checkbox = ({
  children,
  error = false,
  html,
  bold = false,
  large = false,
  id,
  required = false,
  labelVerticalAlignment = "center",
  ...props
}) => {
  const innerHtmlProps = {};
  if (html) {
    innerHtmlProps.dangerouslySetInnerHTML = {
      __html: `${html}${required === true ? '<span class="required">*</span>' : ""}`
    };
  } else {
    innerHtmlProps.children = /* @__PURE__ */ jsxs(Fragment, {
      children: [children, required === true && /* @__PURE__ */ jsx("span", {
        className: "required",
        children: "*"
      })]
    });
  }
  return /* @__PURE__ */ jsxs(Wrap$i, {
    labelVerticalAlignment,
    children: [/* @__PURE__ */ jsx(Input$2, {
      id,
      type: "checkbox",
      error,
      large,
      ...props
    }), /* @__PURE__ */ jsx(Label$3, {
      htmlFor: id,
      bold,
      large,
      required,
      ...innerHtmlProps
    })]
  });
};
const Wrap$h = styled.div.withConfig({
  displayName: "FormFieldErrorstyled__Wrap",
  componentId: "sc-1p4eri6-0"
})(["color:#000;display:block;max-width:300px;clear:both;font-size:15px;padding:13px 15px;background:#dfdfdf;position:relative;margin-top:10px;line-height:21px;&:before{content:'';width:10px;height:10px;background:#dfdfdf;transform:rotate(-45deg);position:absolute;top:-5px;left:10px;}"]);
const FormFieldError = ({
  ...props
}) => /* @__PURE__ */ jsx(Wrap$h, {
  ...props
});
const Wrap$g = styled.input.withConfig({
  displayName: "FormFieldInputstyled__Wrap",
  componentId: "sc-h935vo-0"
})(["border:1px solid #000;padding:0 15px;height:40px;font-family:inherit;font-size:inherit;font-family:", ";color:#000;transition:box-shadow 0.15s ease-in-out;width:100%;padding-top:3px;", " &:focus{box-shadow:0 0 5px 0 rgba(0,0,0,0.3);border:1px solid #000;}@media ", "{height:50px;}", ""], theme.fonts.dinRegular, Focusable(), minBp("desktop"), ({
  error = false
}) => error && `border-color: #cd192d;`);
const FormFieldInput = ({
  ...props
}) => /* @__PURE__ */ jsx(Wrap$g, {
  ...props
});
const Wrapper$9 = styled.div.withConfig({
  displayName: "EmailBasketstyled__Wrapper",
  componentId: "sc-1ocist-0"
})(["max-width:72ch;"]);
const Header$1 = styled.div.withConfig({
  displayName: "EmailBasketstyled__Header",
  componentId: "sc-1ocist-1"
})(["margin-right:", ";"], theme.spacing(6));
const Title$6 = styled.h2.withConfig({
  displayName: "EmailBasketstyled__Title",
  componentId: "sc-1ocist-2"
})(["margin:0 0 ", ";font-family:", ";font-weight:600;font-size:1.375rem;line-height:1.36;text-transform:uppercase;color:#000;"], theme.spacing(2), theme.fonts.dinRegular);
const Description$3 = styled.p.withConfig({
  displayName: "EmailBasketstyled__Description",
  componentId: "sc-1ocist-3"
})(["margin:0 0 clamp(", ",5vw,", ");font-family:", ";font-size:1rem;line-height:1.375;color:#666;"], theme.spacing(2), theme.spacing(4), theme.fonts.dinRegular);
const Form = styled(Form$1).withConfig({
  displayName: "EmailBasketstyled__Form",
  componentId: "sc-1ocist-4"
})(["display:flex;flex-direction:column;"]);
const EmailInput = styled(FormFieldInput).withConfig({
  displayName: "EmailBasketstyled__EmailInput",
  componentId: "sc-1ocist-5"
})(["width:auto;"]);
const Checkboxes = styled.div.withConfig({
  displayName: "EmailBasketstyled__Checkboxes",
  componentId: "sc-1ocist-6"
})(["margin:", " 0 clamp(", ",5vw,", ");> * + *{margin-top:", ";}"], theme.spacing(4), theme.spacing(5), theme.spacing(6), theme.spacing(3));
const Actions = styled.div.withConfig({
  displayName: "EmailBasketstyled__Actions",
  componentId: "sc-1ocist-7"
})(["display:flex;gap:", ";"], theme.spacing(3));
const EmailBasket = ({
  descriptionReference,
  labels = [],
  onCancel,
  onSubmit,
  titleReference
}) => {
  const validationSchema = Yup.object().shape({
    email: Yup.string().email("invalidEmail").required("invalidEmail"),
    agreeToTerms: Yup.boolean().oneOf([true], "agreeToTermsRequired")
  });
  return /* @__PURE__ */ jsxs(Wrapper$9, {
    children: [/* @__PURE__ */ jsxs(Header$1, {
      children: [/* @__PURE__ */ jsx(Title$6, {
        id: titleReference,
        children: labels == null ? void 0 : labels.emailTitle
      }), /* @__PURE__ */ jsx(Description$3, {
        id: descriptionReference,
        children: labels == null ? void 0 : labels.emailSubtitle
      })]
    }), /* @__PURE__ */ jsx(Formik, {
      initialValues: {
        email: "",
        receiveCommunication: false,
        agreeToTerms: false
      },
      validationSchema,
      onSubmit: (values) => onSubmit(values),
      children: ({
        dirty,
        isValid,
        values,
        errors,
        touched,
        handleChange
      }) => /* @__PURE__ */ jsxs(Form, {
        children: [/* @__PURE__ */ jsx(EmailInput, {
          type: "email",
          name: "email",
          id: "email",
          value: values.email,
          onChange: handleChange,
          placeholder: labels == null ? void 0 : labels.emailPlaceholderText,
          error: (touched == null ? void 0 : touched.email) && (errors == null ? void 0 : errors.email)
        }), (touched == null ? void 0 : touched.email) && (errors == null ? void 0 : errors.email) && /* @__PURE__ */ jsx(FormFieldError, {
          children: labels[errors.email]
        }), /* @__PURE__ */ jsxs(Checkboxes, {
          children: [/* @__PURE__ */ jsx(Checkbox, {
            id: "receiveCommunication",
            name: "receiveCommunication",
            checked: values.receiveCommunication,
            onChange: handleChange,
            html: labels == null ? void 0 : labels.emailOptInText,
            large: true,
            bold: true
          }), /* @__PURE__ */ jsx(Checkbox, {
            id: "agreeToTerms",
            name: "agreeToTerms",
            checked: values.agreeToTerms,
            onChange: handleChange,
            html: labels == null ? void 0 : labels.emailTermsText,
            large: true,
            bold: true,
            required: true
          }), (touched == null ? void 0 : touched.agreeToTerms) && (errors == null ? void 0 : errors.agreeToTerms) && /* @__PURE__ */ jsx(FormFieldError, {
            children: labels[errors.agreeToTerms]
          })]
        }), /* @__PURE__ */ jsxs(Actions, {
          children: [/* @__PURE__ */ jsx(Button, {
            primary: true,
            type: "submit",
            disabled: !(isValid && dirty),
            children: labels == null ? void 0 : labels.emailSubmitCta
          }), /* @__PURE__ */ jsx(Button, {
            type: "button",
            onClick: onCancel,
            children: labels == null ? void 0 : labels.emailCancelCta
          })]
        })]
      })
    })]
  });
};
var propTypes = { exports: {} };
var reactIs$3 = { exports: {} };
var reactIs_production_min$2 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$2;
function requireReactIs_production_min$2() {
  if (hasRequiredReactIs_production_min$2)
    return reactIs_production_min$2;
  hasRequiredReactIs_production_min$2 = 1;
  var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min$2.AsyncMode = l;
  reactIs_production_min$2.ConcurrentMode = m;
  reactIs_production_min$2.ContextConsumer = k;
  reactIs_production_min$2.ContextProvider = h;
  reactIs_production_min$2.Element = c;
  reactIs_production_min$2.ForwardRef = n;
  reactIs_production_min$2.Fragment = e;
  reactIs_production_min$2.Lazy = t;
  reactIs_production_min$2.Memo = r;
  reactIs_production_min$2.Portal = d;
  reactIs_production_min$2.Profiler = g;
  reactIs_production_min$2.StrictMode = f;
  reactIs_production_min$2.Suspense = p;
  reactIs_production_min$2.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min$2.isConcurrentMode = A;
  reactIs_production_min$2.isContextConsumer = function(a) {
    return z(a) === k;
  };
  reactIs_production_min$2.isContextProvider = function(a) {
    return z(a) === h;
  };
  reactIs_production_min$2.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min$2.isForwardRef = function(a) {
    return z(a) === n;
  };
  reactIs_production_min$2.isFragment = function(a) {
    return z(a) === e;
  };
  reactIs_production_min$2.isLazy = function(a) {
    return z(a) === t;
  };
  reactIs_production_min$2.isMemo = function(a) {
    return z(a) === r;
  };
  reactIs_production_min$2.isPortal = function(a) {
    return z(a) === d;
  };
  reactIs_production_min$2.isProfiler = function(a) {
    return z(a) === g;
  };
  reactIs_production_min$2.isStrictMode = function(a) {
    return z(a) === f;
  };
  reactIs_production_min$2.isSuspense = function(a) {
    return z(a) === p;
  };
  reactIs_production_min$2.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min$2.typeOf = z;
  return reactIs_production_min$2;
}
var reactIs_development$2 = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$2;
function requireReactIs_development$2() {
  if (hasRequiredReactIs_development$2)
    return reactIs_development$2;
  hasRequiredReactIs_development$2 = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol2 = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol2 ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol2 ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol2 ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol2 ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol2 ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol2 ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol2 ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol2 ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol2 ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol2 ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol2 ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol2 ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol2 ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol2 ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol2 ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol2 ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol2 ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol2 ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === "object" && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement2(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development$2.AsyncMode = AsyncMode;
      reactIs_development$2.ConcurrentMode = ConcurrentMode;
      reactIs_development$2.ContextConsumer = ContextConsumer;
      reactIs_development$2.ContextProvider = ContextProvider;
      reactIs_development$2.Element = Element2;
      reactIs_development$2.ForwardRef = ForwardRef;
      reactIs_development$2.Fragment = Fragment2;
      reactIs_development$2.Lazy = Lazy;
      reactIs_development$2.Memo = Memo;
      reactIs_development$2.Portal = Portal;
      reactIs_development$2.Profiler = Profiler;
      reactIs_development$2.StrictMode = StrictMode;
      reactIs_development$2.Suspense = Suspense;
      reactIs_development$2.isAsyncMode = isAsyncMode;
      reactIs_development$2.isConcurrentMode = isConcurrentMode;
      reactIs_development$2.isContextConsumer = isContextConsumer;
      reactIs_development$2.isContextProvider = isContextProvider;
      reactIs_development$2.isElement = isElement2;
      reactIs_development$2.isForwardRef = isForwardRef;
      reactIs_development$2.isFragment = isFragment;
      reactIs_development$2.isLazy = isLazy;
      reactIs_development$2.isMemo = isMemo;
      reactIs_development$2.isPortal = isPortal;
      reactIs_development$2.isProfiler = isProfiler;
      reactIs_development$2.isStrictMode = isStrictMode;
      reactIs_development$2.isSuspense = isSuspense;
      reactIs_development$2.isValidElementType = isValidElementType;
      reactIs_development$2.typeOf = typeOf;
    })();
  }
  return reactIs_development$2;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs)
    return reactIs$3.exports;
  hasRequiredReactIs = 1;
  (function(module) {
    if (process.env.NODE_ENV === "production") {
      module.exports = requireReactIs_production_min$2();
    } else {
      module.exports = requireReactIs_development$2();
    }
  })(reactIs$3);
  return reactIs$3.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign)
    return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols2 = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2["_" + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
        return test2[n];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);
      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols2) {
        symbols = getOwnPropertySymbols2(from);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret)
    return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas)
    return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes)
    return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = requireHas();
    printWarning = function(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error(
                (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              err.name = "Invariant Violation";
              throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning(
              (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            );
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : "";
            printWarning(
              "Failed " + location + " type: " + error.message + (stack != null ? stack : "")
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers)
    return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has2 = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    printWarning = function(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function(isValidElement2, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is(x, y) {
      if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
      } else {
        return x !== x && y !== y;
      }
    }
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && typeof data === "object" ? data : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            err.name = "Invariant Violation";
            throw err;
          } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey = componentName + ":" + propName;
            if (!manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3) {
              printWarning(
                "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement2(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning(
              "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
            );
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === "symbol") {
            return String(value);
          }
          return value;
        });
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key in propValue) {
          if (has2(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== "function") {
          printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
          var checker2 = arrayOfTypeCheckers[i2];
          var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has2(shapeTypes, key) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement2(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case "array":
        case "object":
          return "an " + type;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type;
        default:
          return type;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims)
    return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
if (process.env.NODE_ENV !== "production") {
  var ReactIs = requireReactIs();
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  propTypes.exports = requireFactoryWithThrowingShims()();
}
/*!
* tabbable 5.2.1
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var candidateSelectors = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"];
var candidateSelector = /* @__PURE__ */ candidateSelectors.join(",");
var matches = typeof Element === "undefined" ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getCandidates = function getCandidates2(el2, includeContainer, filter) {
  var candidates = Array.prototype.slice.apply(el2.querySelectorAll(candidateSelector));
  if (includeContainer && matches.call(el2, candidateSelector)) {
    candidates.unshift(el2);
  }
  candidates = candidates.filter(filter);
  return candidates;
};
var isContentEditable = function isContentEditable2(node) {
  return node.contentEditable === "true";
};
var getTabindex = function getTabindex2(node) {
  var tabindexAttr = parseInt(node.getAttribute("tabindex"), 10);
  if (!isNaN(tabindexAttr)) {
    return tabindexAttr;
  }
  if (isContentEditable(node)) {
    return 0;
  }
  if ((node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) {
    return 0;
  }
  return node.tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables2(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput2(node) {
  return node.tagName === "INPUT";
};
var isHiddenInput = function isHiddenInput2(node) {
  return isInput(node) && node.type === "hidden";
};
var isDetailsWithSummary = function isDetailsWithSummary2(node) {
  var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
    return child.tagName === "SUMMARY";
  });
  return r;
};
var getCheckedRadio = function getCheckedRadio2(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};
var isTabbableRadio = function isTabbableRadio2(node) {
  if (!node.name) {
    return true;
  }
  var radioScope = node.form || node.ownerDocument;
  var queryRadios = function queryRadios2(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};
var isRadio = function isRadio2(node) {
  return isInput(node) && node.type === "radio";
};
var isNonTabbableRadio = function isNonTabbableRadio2(node) {
  return isRadio(node) && !isTabbableRadio(node);
};
var isHidden = function isHidden2(node, displayCheck) {
  if (getComputedStyle(node).visibility === "hidden") {
    return true;
  }
  var isDirectSummary = matches.call(node, "details>summary:first-of-type");
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (matches.call(nodeUnderDetails, "details:not([open]) *")) {
    return true;
  }
  if (!displayCheck || displayCheck === "full") {
    while (node) {
      if (getComputedStyle(node).display === "none") {
        return true;
      }
      node = node.parentElement;
    }
  } else if (displayCheck === "non-zero-area") {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
  }
  return false;
};
var isDisabledFromFieldset = function isDisabledFromFieldset2(node) {
  if (isInput(node) || node.tagName === "SELECT" || node.tagName === "TEXTAREA" || node.tagName === "BUTTON") {
    var parentNode = node.parentElement;
    while (parentNode) {
      if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);
          if (child.tagName === "LEGEND") {
            if (child.contains(node)) {
              return false;
            }
            return true;
          }
        }
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable2(options, node) {
  if (node.disabled || isHiddenInput(node) || isHidden(node, options.displayCheck) || isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options, node) {
  if (!isNodeMatchingSelectorFocusable(options, node) || isNonTabbableRadio(node) || getTabindex(node) < 0) {
    return false;
  }
  return true;
};
var tabbable = function tabbable2(el2, options) {
  options = options || {};
  var regularTabbables = [];
  var orderedTabbables = [];
  var candidates = getCandidates(el2, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  candidates.forEach(function(candidate, i) {
    var candidateTabindex = getTabindex(candidate);
    if (candidateTabindex === 0) {
      regularTabbables.push(candidate);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        node: candidate
      });
    }
  });
  var tabbableNodes = orderedTabbables.sort(sortOrderedTabbables).map(function(a) {
    return a.node;
  }).concat(regularTabbables);
  return tabbableNodes;
};
var focusable = function focusable2(el2, options) {
  options = options || {};
  var candidates = getCandidates(el2, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
  return candidates;
};
var isTabbable = function isTabbable2(node, options) {
  options = options || {};
  if (!node) {
    throw new Error("No node provided");
  }
  if (matches.call(node, candidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* @__PURE__ */ candidateSelectors.concat("iframe").join(",");
var isFocusable = function isFocusable2(node, options) {
  options = options || {};
  if (!node) {
    throw new Error("No node provided");
  }
  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorFocusable(options, node);
};
/*!
* focus-trap 6.7.3
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function ownKeys(object, enumerableOnly) {
  var keys2 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var activeFocusTraps = function() {
  var trapQueue = [];
  return {
    activateTrap: function activateTrap(trap) {
      if (trapQueue.length > 0) {
        var activeTrap = trapQueue[trapQueue.length - 1];
        if (activeTrap !== trap) {
          activeTrap.pause();
        }
      }
      var trapIndex = trapQueue.indexOf(trap);
      if (trapIndex === -1) {
        trapQueue.push(trap);
      } else {
        trapQueue.splice(trapIndex, 1);
        trapQueue.push(trap);
      }
    },
    deactivateTrap: function deactivateTrap(trap) {
      var trapIndex = trapQueue.indexOf(trap);
      if (trapIndex !== -1) {
        trapQueue.splice(trapIndex, 1);
      }
      if (trapQueue.length > 0) {
        trapQueue[trapQueue.length - 1].unpause();
      }
    }
  };
}();
var isSelectableInput = function isSelectableInput2(node) {
  return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
};
var isEscapeEvent = function isEscapeEvent2(e) {
  return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
};
var isTabEvent = function isTabEvent2(e) {
  return e.key === "Tab" || e.keyCode === 9;
};
var delay = function delay2(fn2) {
  return setTimeout(fn2, 0);
};
var findIndex = function findIndex2(arr, fn2) {
  var idx = -1;
  arr.every(function(value, i) {
    if (fn2(value)) {
      idx = i;
      return false;
    }
    return true;
  });
  return idx;
};
var valueOrHandler = function valueOrHandler2(value) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }
  return typeof value === "function" ? value.apply(void 0, params) : value;
};
var getActualTarget = function getActualTarget2(event) {
  return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
};
var createFocusTrap$1 = function createFocusTrap(elements, userOptions) {
  var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
  var config = _objectSpread2({
    returnFocusOnDeactivate: true,
    escapeDeactivates: true,
    delayInitialFocus: true
  }, userOptions);
  var state = {
    containers: [],
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false,
    delayInitialFocusTimer: void 0
  };
  var trap;
  var getOption = function getOption2(configOverrideOptions, optionName, configOptionName) {
    return configOverrideOptions && configOverrideOptions[optionName] !== void 0 ? configOverrideOptions[optionName] : config[configOptionName || optionName];
  };
  var containersContain = function containersContain2(element) {
    return !!(element && state.containers.some(function(container) {
      return container.contains(element);
    }));
  };
  var getNodeForOption = function getNodeForOption2(optionName) {
    var optionValue = config[optionName];
    if (typeof optionValue === "function") {
      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }
      optionValue = optionValue.apply(void 0, params);
    }
    if (!optionValue) {
      if (optionValue === void 0 || optionValue === false) {
        return optionValue;
      }
      throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
    }
    var node = optionValue;
    if (typeof optionValue === "string") {
      node = doc.querySelector(optionValue);
      if (!node) {
        throw new Error("`".concat(optionName, "` as selector refers to no known node"));
      }
    }
    return node;
  };
  var getInitialFocusNode = function getInitialFocusNode2() {
    var node = getNodeForOption("initialFocus");
    if (node === false) {
      return false;
    }
    if (node === void 0) {
      if (containersContain(doc.activeElement)) {
        node = doc.activeElement;
      } else {
        var firstTabbableGroup = state.tabbableGroups[0];
        var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
        node = firstTabbableNode || getNodeForOption("fallbackFocus");
      }
    }
    if (!node) {
      throw new Error("Your focus-trap needs to have at least one focusable element");
    }
    return node;
  };
  var updateTabbableNodes = function updateTabbableNodes2() {
    state.tabbableGroups = state.containers.map(function(container) {
      var tabbableNodes = tabbable(container);
      var focusableNodes = focusable(container);
      if (tabbableNodes.length > 0) {
        return {
          container,
          firstTabbableNode: tabbableNodes[0],
          lastTabbableNode: tabbableNodes[tabbableNodes.length - 1],
          nextTabbableNode: function nextTabbableNode(node) {
            var forward = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            var nodeIdx = focusableNodes.findIndex(function(n) {
              return n === node;
            });
            if (forward) {
              return focusableNodes.slice(nodeIdx + 1).find(function(n) {
                return isTabbable(n);
              });
            }
            return focusableNodes.slice(0, nodeIdx).reverse().find(function(n) {
              return isTabbable(n);
            });
          }
        };
      }
      return void 0;
    }).filter(function(group) {
      return !!group;
    });
    if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus")) {
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    }
  };
  var tryFocus = function tryFocus2(node) {
    if (node === false) {
      return;
    }
    if (node === doc.activeElement) {
      return;
    }
    if (!node || !node.focus) {
      tryFocus2(getInitialFocusNode());
      return;
    }
    node.focus({
      preventScroll: !!config.preventScroll
    });
    state.mostRecentlyFocusedNode = node;
    if (isSelectableInput(node)) {
      node.select();
    }
  };
  var getReturnFocusNode = function getReturnFocusNode2(previousActiveElement) {
    var node = getNodeForOption("setReturnFocus", previousActiveElement);
    return node ? node : node === false ? false : previousActiveElement;
  };
  var checkPointerDown = function checkPointerDown2(e) {
    var target = getActualTarget(e);
    if (containersContain(target)) {
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      trap.deactivate({
        returnFocus: config.returnFocusOnDeactivate && !isFocusable(target)
      });
      return;
    }
    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }
    e.preventDefault();
  };
  var checkFocusIn = function checkFocusIn2(e) {
    var target = getActualTarget(e);
    var targetContained = containersContain(target);
    if (targetContained || target instanceof Document) {
      if (targetContained) {
        state.mostRecentlyFocusedNode = target;
      }
    } else {
      e.stopImmediatePropagation();
      tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
    }
  };
  var checkTab = function checkTab2(e) {
    var target = getActualTarget(e);
    updateTabbableNodes();
    var destinationNode = null;
    if (state.tabbableGroups.length > 0) {
      var containerIndex = findIndex(state.tabbableGroups, function(_ref) {
        var container = _ref.container;
        return container.contains(target);
      });
      var containerGroup = containerIndex >= 0 ? state.tabbableGroups[containerIndex] : void 0;
      if (containerIndex < 0) {
        if (e.shiftKey) {
          destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
        } else {
          destinationNode = state.tabbableGroups[0].firstTabbableNode;
        }
      } else if (e.shiftKey) {
        var startOfGroupIndex = findIndex(state.tabbableGroups, function(_ref2) {
          var firstTabbableNode = _ref2.firstTabbableNode;
          return target === firstTabbableNode;
        });
        if (startOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target) && !isTabbable(target) && !containerGroup.nextTabbableNode(target, false))) {
          startOfGroupIndex = containerIndex;
        }
        if (startOfGroupIndex >= 0) {
          var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
          var destinationGroup = state.tabbableGroups[destinationGroupIndex];
          destinationNode = destinationGroup.lastTabbableNode;
        }
      } else {
        var lastOfGroupIndex = findIndex(state.tabbableGroups, function(_ref3) {
          var lastTabbableNode = _ref3.lastTabbableNode;
          return target === lastTabbableNode;
        });
        if (lastOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target) && !isTabbable(target) && !containerGroup.nextTabbableNode(target))) {
          lastOfGroupIndex = containerIndex;
        }
        if (lastOfGroupIndex >= 0) {
          var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
          var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
          destinationNode = _destinationGroup.firstTabbableNode;
        }
      }
    } else {
      destinationNode = getNodeForOption("fallbackFocus");
    }
    if (destinationNode) {
      e.preventDefault();
      tryFocus(destinationNode);
    }
  };
  var checkKey = function checkKey2(e) {
    if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
      e.preventDefault();
      trap.deactivate();
      return;
    }
    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  };
  var checkClick = function checkClick2(e) {
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      return;
    }
    var target = getActualTarget(e);
    if (containersContain(target)) {
      return;
    }
    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
  };
  var addListeners = function addListeners2() {
    if (!state.active) {
      return;
    }
    activeFocusTraps.activateTrap(trap);
    state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function() {
      tryFocus(getInitialFocusNode());
    }) : tryFocus(getInitialFocusNode());
    doc.addEventListener("focusin", checkFocusIn, true);
    doc.addEventListener("mousedown", checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener("touchstart", checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener("click", checkClick, {
      capture: true,
      passive: false
    });
    doc.addEventListener("keydown", checkKey, {
      capture: true,
      passive: false
    });
    return trap;
  };
  var removeListeners = function removeListeners2() {
    if (!state.active) {
      return;
    }
    doc.removeEventListener("focusin", checkFocusIn, true);
    doc.removeEventListener("mousedown", checkPointerDown, true);
    doc.removeEventListener("touchstart", checkPointerDown, true);
    doc.removeEventListener("click", checkClick, true);
    doc.removeEventListener("keydown", checkKey, true);
    return trap;
  };
  trap = {
    activate: function activate(activateOptions) {
      if (state.active) {
        return this;
      }
      var onActivate = getOption(activateOptions, "onActivate");
      var onPostActivate = getOption(activateOptions, "onPostActivate");
      var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
      if (!checkCanFocusTrap) {
        updateTabbableNodes();
      }
      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = doc.activeElement;
      if (onActivate) {
        onActivate();
      }
      var finishActivation = function finishActivation2() {
        if (checkCanFocusTrap) {
          updateTabbableNodes();
        }
        addListeners();
        if (onPostActivate) {
          onPostActivate();
        }
      };
      if (checkCanFocusTrap) {
        checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
        return this;
      }
      finishActivation();
      return this;
    },
    deactivate: function deactivate(deactivateOptions) {
      if (!state.active) {
        return this;
      }
      clearTimeout(state.delayInitialFocusTimer);
      state.delayInitialFocusTimer = void 0;
      removeListeners();
      state.active = false;
      state.paused = false;
      activeFocusTraps.deactivateTrap(trap);
      var onDeactivate = getOption(deactivateOptions, "onDeactivate");
      var onPostDeactivate = getOption(deactivateOptions, "onPostDeactivate");
      var checkCanReturnFocus = getOption(deactivateOptions, "checkCanReturnFocus");
      if (onDeactivate) {
        onDeactivate();
      }
      var returnFocus = getOption(deactivateOptions, "returnFocus", "returnFocusOnDeactivate");
      var finishDeactivation = function finishDeactivation2() {
        delay(function() {
          if (returnFocus) {
            tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
          }
          if (onPostDeactivate) {
            onPostDeactivate();
          }
        });
      };
      if (returnFocus && checkCanReturnFocus) {
        checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
        return this;
      }
      finishDeactivation();
      return this;
    },
    pause: function pause() {
      if (state.paused || !state.active) {
        return this;
      }
      state.paused = true;
      removeListeners();
      return this;
    },
    unpause: function unpause() {
      if (!state.paused || !state.active) {
        return this;
      }
      state.paused = false;
      updateTabbableNodes();
      addListeners();
      return this;
    },
    updateContainerElements: function updateContainerElements(containerElements) {
      var elementsAsArray = [].concat(containerElements).filter(Boolean);
      state.containers = elementsAsArray.map(function(element) {
        return typeof element === "string" ? doc.querySelector(element) : element;
      });
      if (state.active) {
        updateTabbableNodes();
      }
      return this;
    }
  };
  trap.updateContainerElements(elements);
  return trap;
};
const focusTrap_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createFocusTrap: createFocusTrap$1
}, Symbol.toStringTag, { value: "Module" }));
const require$$3 = /* @__PURE__ */ getAugmentedNamespace(focusTrap_esm);
function _typeof$3(obj) {
  "@babel/helpers - typeof";
  return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$3(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self2, call) {
  if (call && (_typeof$3(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
var React$2 = React__default;
var ReactDOM = require$$1__default;
var PropTypes = propTypes.exports;
var _require = require$$3, createFocusTrap2 = _require.createFocusTrap;
var FocusTrap = /* @__PURE__ */ function(_React$Component) {
  _inherits(FocusTrap2, _React$Component);
  var _super = _createSuper(FocusTrap2);
  function FocusTrap2(props) {
    var _this;
    _classCallCheck(this, FocusTrap2);
    _this = _super.call(this, props);
    _this.tailoredFocusTrapOptions = {
      returnFocusOnDeactivate: false
    };
    _this.returnFocusOnDeactivate = true;
    var focusTrapOptions = props.focusTrapOptions;
    for (var optionName in focusTrapOptions) {
      if (!Object.prototype.hasOwnProperty.call(focusTrapOptions, optionName)) {
        continue;
      }
      if (optionName === "returnFocusOnDeactivate") {
        _this.returnFocusOnDeactivate = !!focusTrapOptions[optionName];
        continue;
      }
      if (optionName === "onPostDeactivate") {
        _this.onPostDeactivate = focusTrapOptions[optionName];
        continue;
      }
      _this.tailoredFocusTrapOptions[optionName] = focusTrapOptions[optionName];
    }
    _this.focusTrapElements = props.containerElements || [];
    _this.updatePreviousElement();
    return _this;
  }
  _createClass$1(FocusTrap2, [{
    key: "getDocument",
    value: function getDocument() {
      return this.props.focusTrapOptions.document || (typeof document !== "undefined" ? document : void 0);
    }
  }, {
    key: "getNodeForOption",
    value: function getNodeForOption(optionName) {
      var optionValue = this.tailoredFocusTrapOptions[optionName];
      if (!optionValue) {
        return null;
      }
      var node = optionValue;
      if (typeof optionValue === "string") {
        var _this$getDocument;
        node = (_this$getDocument = this.getDocument()) === null || _this$getDocument === void 0 ? void 0 : _this$getDocument.querySelector(optionValue);
        if (!node) {
          throw new Error("`".concat(optionName, "` refers to no known node"));
        }
      }
      if (typeof optionValue === "function") {
        node = optionValue();
        if (!node) {
          throw new Error("`".concat(optionName, "` did not return a node"));
        }
      }
      return node;
    }
  }, {
    key: "getReturnFocusNode",
    value: function getReturnFocusNode() {
      var node = this.getNodeForOption("setReturnFocus");
      return node ? node : this.previouslyFocusedElement;
    }
  }, {
    key: "updatePreviousElement",
    value: function updatePreviousElement() {
      var currentDocument = this.getDocument();
      if (currentDocument) {
        this.previouslyFocusedElement = currentDocument.activeElement;
      }
    }
  }, {
    key: "deactivateTrap",
    value: function deactivateTrap() {
      var _this2 = this;
      var _this$tailoredFocusTr = this.tailoredFocusTrapOptions, checkCanReturnFocus = _this$tailoredFocusTr.checkCanReturnFocus, _this$tailoredFocusTr2 = _this$tailoredFocusTr.preventScroll, preventScroll = _this$tailoredFocusTr2 === void 0 ? false : _this$tailoredFocusTr2;
      if (this.focusTrap) {
        this.focusTrap.deactivate({
          returnFocus: false
        });
      }
      var finishDeactivation = function finishDeactivation2() {
        var returnFocusNode = _this2.getReturnFocusNode();
        var canReturnFocus = (returnFocusNode === null || returnFocusNode === void 0 ? void 0 : returnFocusNode.focus) && _this2.returnFocusOnDeactivate;
        if (canReturnFocus) {
          returnFocusNode.focus({
            preventScroll
          });
        }
        if (_this2.onPostDeactivate) {
          _this2.onPostDeactivate.call(null);
        }
      };
      if (checkCanReturnFocus) {
        checkCanReturnFocus(this.getReturnFocusNode()).then(finishDeactivation, finishDeactivation);
      } else {
        finishDeactivation();
      }
    }
  }, {
    key: "setupFocusTrap",
    value: function setupFocusTrap() {
      if (!this.focusTrap) {
        var focusTrapElementDOMNodes = this.focusTrapElements.map(
          ReactDOM.findDOMNode
        );
        var nodesExist = focusTrapElementDOMNodes.some(Boolean);
        if (nodesExist) {
          this.focusTrap = this.props._createFocusTrap(focusTrapElementDOMNodes, this.tailoredFocusTrapOptions);
          if (this.props.active) {
            this.focusTrap.activate();
          }
          if (this.props.paused) {
            this.focusTrap.pause();
          }
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.active) {
        this.setupFocusTrap();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.focusTrap) {
        if (prevProps.containerElements !== this.props.containerElements) {
          this.focusTrap.updateContainerElements(this.props.containerElements);
        }
        var hasActivated = !prevProps.active && this.props.active;
        var hasDeactivated = prevProps.active && !this.props.active;
        var hasPaused = !prevProps.paused && this.props.paused;
        var hasUnpaused = prevProps.paused && !this.props.paused;
        if (hasActivated) {
          this.updatePreviousElement();
          this.focusTrap.activate();
        }
        if (hasDeactivated) {
          this.deactivateTrap();
          return;
        }
        if (hasPaused) {
          this.focusTrap.pause();
        }
        if (hasUnpaused) {
          this.focusTrap.unpause();
        }
      } else {
        if (prevProps.containerElements !== this.props.containerElements) {
          this.focusTrapElements = this.props.containerElements;
        }
        if (this.props.active) {
          this.updatePreviousElement();
          this.setupFocusTrap();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.deactivateTrap();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var child = this.props.children ? React$2.Children.only(this.props.children) : void 0;
      if (child) {
        if (child.type && child.type === React$2.Fragment) {
          throw new Error("A focus-trap cannot use a Fragment as its child container. Try replacing it with a <div> element.");
        }
        var composedRefCallback = function composedRefCallback2(element) {
          var containerElements = _this3.props.containerElements;
          if (child) {
            if (typeof child.ref === "function") {
              child.ref(element);
            } else if (child.ref) {
              child.ref.current = element;
            }
          }
          _this3.focusTrapElements = containerElements ? containerElements : [element];
        };
        var childWithRef = React$2.cloneElement(child, {
          ref: composedRefCallback
        });
        return childWithRef;
      }
      return null;
    }
  }]);
  return FocusTrap2;
}(React$2.Component);
var ElementType = typeof Element === "undefined" ? Function : Element;
FocusTrap.propTypes = {
  active: PropTypes.bool,
  paused: PropTypes.bool,
  focusTrapOptions: PropTypes.shape({
    document: PropTypes.object,
    onActivate: PropTypes.func,
    onPostActivate: PropTypes.func,
    checkCanFocusTrap: PropTypes.func,
    onDeactivate: PropTypes.func,
    onPostDeactivate: PropTypes.func,
    checkCanReturnFocus: PropTypes.func,
    initialFocus: PropTypes.oneOfType([PropTypes.instanceOf(ElementType), PropTypes.string, PropTypes.func, PropTypes.bool]),
    fallbackFocus: PropTypes.oneOfType([PropTypes.instanceOf(ElementType), PropTypes.string, PropTypes.func]),
    escapeDeactivates: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    clickOutsideDeactivates: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    returnFocusOnDeactivate: PropTypes.bool,
    setReturnFocus: PropTypes.oneOfType([PropTypes.instanceOf(ElementType), PropTypes.string, PropTypes.func]),
    allowOutsideClick: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    preventScroll: PropTypes.bool
  }),
  containerElements: PropTypes.arrayOf(PropTypes.instanceOf(ElementType)),
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.instanceOf(ElementType)
  ])
};
FocusTrap.defaultProps = {
  active: true,
  paused: false,
  focusTrapOptions: {},
  _createFocusTrap: createFocusTrap2
};
var focusTrapReact = FocusTrap;
const Wrapper$8 = styled.div.withConfig({
  displayName: "EmailBasketModalstyled__Wrapper",
  componentId: "sc-1kedlyt-0"
})(["position:fixed;inset:0;display:grid;place-items:center;background-color:rgba(0,0,0,0.6);z-index:2000;"]);
const Dialog = styled.div.withConfig({
  displayName: "EmailBasketModalstyled__Dialog",
  componentId: "sc-1kedlyt-1"
})(["position:relative;width:min(calc(100vw - ", "),42rem);max-height:calc(100vh - ", ");padding:clamp(", ",5vw,3.125rem);background-color:#fff;overflow:auto;"], theme.spacing(5), theme.spacing(5), theme.spacing(3));
const Close = styled.button.withConfig({
  displayName: "EmailBasketModalstyled__Close",
  componentId: "sc-1kedlyt-2"
})(["position:absolute;top:", ";right:", ";display:grid;place-items:center;width:1.875rem;height:1.875rem;border:none;padding:0;appearance:none;background:none;color:#2a2a2a;cursor:pointer;transition:color 200ms ease-in-out;&:hover,&:focus{color:", ";}"], theme.spacing(3), theme.spacing(3), theme.colors.primary);
const CloseIcon = styled(Icon).withConfig({
  displayName: "EmailBasketModalstyled__CloseIcon",
  componentId: "sc-1kedlyt-3"
})(["font-size:0.9375rem;"]);
const EmailBasketModal = ({
  labels = [],
  onClose,
  onSubmit,
  show = false
}) => {
  const dialogRef = createRef();
  const titleReference = Math.random().toString(36).substring(2, 15);
  const descriptionReference = Math.random().toString(36).substring(2, 15);
  const handleClickOutside = (event) => {
    var _a2;
    if (!((_a2 = dialogRef == null ? void 0 : dialogRef.current) == null ? void 0 : _a2.contains(event.target))) {
      onClose();
    }
  };
  const handleEscape = (event) => {
    if (event.key === "Escape") {
      onClose();
    }
  };
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    window.addEventListener("keydown", handleEscape, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
      window.removeEventListener("keydown", handleEscape, true);
    };
  });
  useEffect(() => show ? bodyNoScroll.add() : bodyNoScroll.remove(), [show]);
  if (!show)
    return null;
  return /* @__PURE__ */ jsx(focusTrapReact, {
    children: /* @__PURE__ */ jsx(Wrapper$8, {
      children: /* @__PURE__ */ jsxs(Dialog, {
        ref: dialogRef,
        role: "dialog",
        "aria-labelledby": titleReference,
        "aria-describedby": descriptionReference,
        children: [/* @__PURE__ */ jsx(Close, {
          onClick: onClose,
          "aria-label": labels == null ? void 0 : labels.close,
          children: /* @__PURE__ */ jsx(CloseIcon, {
            name: "close",
            "aria-hidden": "true"
          })
        }), /* @__PURE__ */ jsx(EmailBasket, {
          titleReference,
          descriptionReference,
          onCancel: onClose,
          onSubmit,
          labels
        })]
      })
    })
  });
};
const Wrapper$7 = styled.div.withConfig({
  displayName: "ExpandablePanelstyled__Wrapper",
  componentId: "sc-1fmyrsl-0"
})(["display:flex;flex-direction:column;border:1px solid #e6e6e6;background-color:#fff;"]);
const Handle = styled.button.withConfig({
  displayName: "ExpandablePanelstyled__Handle",
  componentId: "sc-1fmyrsl-1"
})(["display:flex;align-items:first baseline;justify-content:space-between;gap:1.25rem;min-height:3.75rem;padding:1.25rem;border:solid #e6e6e6;border-width:0 0 1px;background-color:#fff;font-family:", ";font-weight:600;font-size:0.875rem;line-height:1.428;text-align:left;appearance:none;cursor:pointer;@media ", "{display:none;}.icon{flex-shrink:0;font-size:12px;transition:transform 0.2s ease-in-out;", "}", ""], theme.fonts.dinRegular, minBp("desktop"), ({
  expanded = false
}) => !expanded && css$1(["transform:scaleY(-1);"]), Focusable());
const panelStyles = css$1(["padding:1.875rem;background-color:#fff;"]);
const PanelMobile = styled.div.withConfig({
  displayName: "ExpandablePanelstyled__PanelMobile",
  componentId: "sc-1fmyrsl-2"
})(["", " @media ", "{display:none;}"], panelStyles, minBp("desktop"));
const PanelDesktop = styled.div.withConfig({
  displayName: "ExpandablePanelstyled__PanelDesktop",
  componentId: "sc-1fmyrsl-3"
})(["", " display:none;@media ", "{display:block;}"], panelStyles, minBp("desktop"));
const ExpandablePanel = ({
  children,
  expanded = false,
  title,
  onToggle
}) => /* @__PURE__ */ jsxs(Wrapper$7, {
  children: [/* @__PURE__ */ jsxs(Handle, {
    expanded,
    onClick: onToggle,
    "aria-expanded": expanded,
    children: [title, /* @__PURE__ */ jsx(Icon, {
      name: "chevron-down",
      "aria-hidden": true
    })]
  }), expanded && /* @__PURE__ */ jsx(PanelMobile, {
    children
  }), /* @__PURE__ */ jsx(PanelDesktop, {
    children
  })]
});
const Wrap$f = styled.div.withConfig({
  displayName: "ExpandingContainerstyled__Wrap",
  componentId: "sc-1yqic12-0"
})(["position:fixed;left:0;right:0;bottom:0;"]);
const ExpandingContainer = ({
  children,
  background
}) => {
  const header = document.querySelector(".header");
  const [height, setHeight] = useState();
  useEffect(() => {
    const handleResize = () => {
      var _a2;
      const headerHeight = ((_a2 = header == null ? void 0 : header.getBoundingClientRect()) == null ? void 0 : _a2.height) || 0;
      const windowHeight = window.innerHeight;
      setHeight(`${windowHeight - headerHeight}px`);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [header]);
  useEffect(() => {
    const mainElement = document.querySelector("main");
    if (!mainElement) {
      return;
    }
    const previousHeight = mainElement.style.minHeight;
    mainElement.style.minHeight = "0";
    return () => {
      mainElement.style.minHeight = previousHeight;
    };
  }, []);
  return /* @__PURE__ */ jsx(Wrap$f, {
    style: {
      height,
      background
    },
    children
  });
};
const Wrap$e = styled.div.withConfig({
  displayName: "FormFieldDisclaimerstyled__Wrap",
  componentId: "sc-td3jyd-0"
})(["margin-top:13px;padding:16px;background-color:", ";color:black;font-size:12px;display:flex;align-items:center;svg{vertical-align:middle;min-width:15px;max-width:15px;height:15px;margin-right:15px;path{fill:black;}}span{flex:1;width:100%;}"], theme.colors.offWhite);
const FormFieldDisclaimer = ({
  children,
  ...props
}) => /* @__PURE__ */ jsxs(Wrap$e, {
  ...props,
  children: [/* @__PURE__ */ jsx("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    children: /* @__PURE__ */ jsx("path", {
      d: "M16 3c7.168 0 13 5.832 13 13s-5.832 13-13 13-13-5.832-13-13 5.832-13 13-13zM16 5c-6.087 0-11 4.913-11 11s4.913 11 11 11 11-4.913 11-11-4.913-11-11-11zM15 10h2v2h-2v-2zM15 14h2v8h-2v-8z",
      fill: "#fff"
    })
  }), /* @__PURE__ */ jsx("span", {
    children
  })]
});
const Wrap$d = styled.div.withConfig({
  displayName: "FormFieldGroupstyled__Wrap",
  componentId: "sc-r4v7eu-0"
})(["margin-bottom:14px;@media ", "{margin-bottom:16px;}"], minBp("desktop"));
const FormFieldGroup = ({
  ...props
}) => /* @__PURE__ */ jsx(Wrap$d, {
  ...props
});
const Wrap$c = styled.div.withConfig({
  displayName: "FormFieldGuidancestyled__Wrap",
  componentId: "sc-113ofbe-0"
})(["margin-top:10px;font-size:14px;line-height:22px;"]);
const FormFieldGuidance = ({
  ...props
}) => /* @__PURE__ */ jsx(Wrap$c, {
  ...props
});
const Wrap$b = styled.label.withConfig({
  displayName: "FormFieldLabelstyled__Wrap",
  componentId: "sc-1hevej4-0"
})(["display:block;font-family:", ";font-size:16px;line-height:20px;margin-bottom:", ";color:#000;span.required{color:", ";}span.optional{display:inline-block;margin-left:8px;color:", ";font-family:", ";}div.description{font-family:", ";color:", ";margin-top:5px;}@media ", "{margin-bottom:", ";}"], theme.fonts.dinDemi, ({
  hasDescription
}) => hasDescription ? "12px" : "5px", theme.colors.primary, theme.colors.body, theme.fonts.dinRegular, theme.fonts.dinRegular, theme.colors.body, minBp("desktop"), ({
  hasDescription
}) => hasDescription ? "5px" : "10px");
const FormFieldLabel = (props) => /* @__PURE__ */ jsxs(Wrap$b, {
  ...props,
  children: [props.children, props.required && props.required === true && /* @__PURE__ */ jsx("span", {
    className: "required",
    children: "*"
  })]
});
const Wrap$a = styled.div.withConfig({
  displayName: "FormFieldRadiostyled__Wrap",
  componentId: "sc-bmkqa4-0"
})(["display:flex;padding:18px 0;border-bottom:1px solid #e0e0e0;position:relative;@media ", "{display:inline-flex;align-items:center;margin:2px 0;padding:0;border:0;&:not(:last-of-type){margin-right:15px;}}@media screen and (-ms-high-contrast:active),screen and (-ms-high-contrast:none){flex-direction:row-reverse;}"], minBp("tabletLarge"));
const Label$2 = styled.label.withConfig({
  displayName: "FormFieldRadiostyled__Label",
  componentId: "sc-bmkqa4-1"
})(["color:#000;display:block;position:relative;padding-left:24px;font-weight:300;font-size:16px;z-index:9;cursor:pointer;@media ", "{padding-top:2px;margin:2px 0;}"], minBp("tabletLarge"));
const Input$1 = styled.input.withConfig({
  displayName: "FormFieldRadiostyled__Input",
  componentId: "sc-bmkqa4-2"
})(["position:absolute;visibility:hidden;"]);
const Check$1 = styled.div.withConfig({
  displayName: "FormFieldRadiostyled__Check",
  componentId: "sc-bmkqa4-3"
})(["display:block;position:absolute;border:1px solid #000;border-radius:50%;height:15px;width:15px;z-index:5;transition:border 0.25s linear;@media screen and (-ms-high-contrast:active),screen and (-ms-high-contrast:none){top:5px;}&:before{display:block;position:absolute;content:'';border-radius:100%;height:9px;width:9px;top:2px;left:2px;margin:auto;}", ":checked ~ &{background-color:#fff;&:before{background-color:#000;}}"], Input$1);
const Radio = ({
  children,
  html,
  id,
  ...props
}) => {
  const innerHtmlProps = {};
  if (html) {
    innerHtmlProps.dangerouslySetInnerHTML = {
      __html: html
    };
  } else {
    innerHtmlProps.children = children;
  }
  return /* @__PURE__ */ jsxs(Wrap$a, {
    children: [/* @__PURE__ */ jsx(Input$1, {
      id,
      type: "radio",
      ...props
    }), /* @__PURE__ */ jsx(Label$2, {
      htmlFor: id,
      ...innerHtmlProps
    }), /* @__PURE__ */ jsx(Check$1, {})]
  });
};
const Wrap$9 = styled.div.withConfig({
  displayName: "FormFieldSelectstyled__Wrap",
  componentId: "sc-1m0vor3-0"
})(["border:1px solid ", ";position:relative;background-color:", ";svg{position:absolute;top:10px;right:8px;width:18px;height:18px;pointer-events:none;@media ", "{top:14px;right:8px;width:22px;height:22px;}}"], ({
  disabled
}) => disabled ? "#dedede" : "black", ({
  disabled
}) => disabled ? "#eeeeee" : "white", minBp("desktop"));
const Select = styled.select.withConfig({
  displayName: "FormFieldSelectstyled__Select",
  componentId: "sc-1m0vor3-1"
})(["appearance:none;border:0;border-radius:0;padding:8px 35px 8px 15px;color:#000;background:transparent;width:100%;text-align:left;font-family:inherit;font-size:16px;height:38px;cursor:pointer;@media ", "{padding:8px 30px 8px 15px;height:48px;}"], minBp("desktop"));
const FormFieldSelect = ({
  disabled = false,
  ...props
}) => /* @__PURE__ */ jsxs(Wrap$9, {
  disabled,
  children: [/* @__PURE__ */ jsx(Select, {
    disabled,
    ...props
  }), /* @__PURE__ */ jsx("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    children: /* @__PURE__ */ jsx("path", {
      d: "M15 4h2v20.063l6.781-6.781 1.438 1.438-8.5 8.5-0.719 0.688-0.719-0.688-8.5-8.5 1.438-1.438 6.781 6.781v-20.063z"
    })
  })]
});
const Wrap$8 = styled.div.withConfig({
  displayName: "FormFieldTogglestyled__Wrap",
  componentId: "sc-188n0y1-0"
})(["display:flex;"]);
const Label$1 = styled.label.withConfig({
  displayName: "FormFieldTogglestyled__Label",
  componentId: "sc-188n0y1-1"
})(["background-color:white;border:1px solid black;color:black;font-family:", ";font-size:17px;text-transform:uppercase;line-height:1;text-align:center;min-width:89px;height:40px;padding:3px 10px 0;margin-right:10px;transition:all 0.1s ease-in-out;cursor:pointer !important;display:flex;align-items:center;justify-content:center;"], theme.fonts.dinDemi);
const Input = styled.input.withConfig({
  displayName: "FormFieldTogglestyled__Input",
  componentId: "sc-188n0y1-2"
})(["position:absolute !important;clip:rect(0,0,0,0);height:1px;width:1px;border:0;overflow:hidden;&:checked + ", "{background-color:black;color:white;}"], Label$1);
const FormFieldToggle = ({
  name,
  onChange,
  value,
  options
}) => /* @__PURE__ */ jsx(Wrap$8, {
  children: options.map((option) => /* @__PURE__ */ jsxs(Fragment$1, {
    children: [/* @__PURE__ */ jsx(Input, {
      type: "radio",
      id: option.id,
      name,
      value: option.id,
      checked: option.id === value,
      onChange
    }), option.value && /* @__PURE__ */ jsx(Label$1, {
      htmlFor: option.id,
      children: option.value
    })]
  }, option.value))
});
const usePrevious$1 = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
const FormikEffect = ({
  onChange,
  values
}) => {
  const [firstRender, setFirstRender] = useState(true);
  const previousValues = usePrevious$1(values);
  useEffect(() => {
    if (firstRender) {
      setFirstRender(false);
    } else {
      onChange(previousValues, values);
    }
  }, [onChange, values]);
  return null;
};
const FormikEffect$1 = connect(FormikEffect);
const FormikSubmitEffect = ({
  onSubmitError
}) => {
  const {
    submitCount,
    isValid
  } = useFormikContext();
  const [lastHandled, setLastHandled] = useState(0);
  useEffect(() => {
    if (submitCount > lastHandled && !isValid) {
      onSubmitError();
      setLastHandled(submitCount);
    }
  }, [submitCount, isValid, onSubmitError, lastHandled]);
  return null;
};
const GlobalStyle = createGlobalStyle(["html{&.lock-scroll{-webkit-overflow-scrolling:auto;overflow:hidden;", "}}body{margin:0;padding:0;font-family:", ";font-size:14px;color:", ";line-height:1.2;background:#f1f1f1;@media ", "{font-size:16.66px;}}&:not(header){h1,h2,h3,h4,h5,h6{font-family:", ";font-weight:500;color:", ";line-height:1;}h1{margin:0 0 45px;font-size:80px;}h2{font-size:60px;}h3{margin:0 0 15px;font-size:25px;}h4{margin:0 0 15px;font-size:17px;@media ", "{font-size:22px;}}p{margin:0 0 5px;line-height:1.375;}small{font-size:75%;}strong{font-weight:500;font-family:", ";}*{box-sizing:border-box;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}select,input{margin:0;border:0;&:focus{border:0;}}select::-ms-expand{display:none;}input[type='radio']{margin-top:0;}}@media (prefers-reduced-motion:no-preference){html{scroll-behavior:smooth;}}"], isAndroidOrIOS() && css$1(["position:fixed;width:100%;height:100%;body{-webkit-overflow-scrolling:auto;overflow:hidden;position:fixed;width:100%;height:100%;}"]), theme.fonts.dinRegular, theme.colors.body, minBp("tablet"), theme.fonts.dinDemi, theme.colors.heading, minBp("tablet"), theme.fonts.dinDemi);
var fromEntries = function fromEntries2(entries) {
  return entries.reduce(function(acc, _ref) {
    var key = _ref[0], value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
var useIsomorphicLayoutEffect = typeof window !== "undefined" && window.document && window.document.createElement ? React$3.useLayoutEffect : React$3.useEffect;
var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [top, bottom, right, left];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function getNodeName(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}
function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (node.toString() !== "[object Window]") {
    var ownerDocument2 = node.ownerDocument;
    return ownerDocument2 ? ownerDocument2.defaultView || window : window;
  }
  return node;
}
function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}
function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function(name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name];
    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    }
    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function(name2) {
      var value = attributes[name2];
      if (value === false) {
        element.removeAttribute(name2);
      } else {
        element.setAttribute(name2, value === true ? "" : value);
      }
    });
  });
}
function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function() {
    Object.keys(state.elements).forEach(function(name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
      var style = styleProperties.reduce(function(style2, property) {
        style2[property] = "";
        return style2;
      }, {});
      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function(attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
const applyStyles$1 = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement(placement) {
  return placement.split("-")[0];
}
var max = Math.max;
var min = Math.min;
var round$1 = Math.round;
function getBoundingClientRect(element, includeScale) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  var rect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (isHTMLElement(element) && includeScale) {
    var offsetHeight = element.offsetHeight;
    var offsetWidth = element.offsetWidth;
    if (offsetWidth > 0) {
      scaleX = round$1(rect.width) / offsetWidth || 1;
    }
    if (offsetHeight > 0) {
      scaleY = round$1(rect.height) / offsetHeight || 1;
    }
  }
  return {
    width: rect.width / scaleX,
    height: rect.height / scaleY,
    top: rect.top / scaleY,
    right: rect.right / scaleX,
    bottom: rect.bottom / scaleY,
    left: rect.left / scaleX,
    x: rect.left / scaleX,
    y: rect.top / scaleY
  };
}
function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element);
  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width,
    height
  };
}
function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode();
  if (parent.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;
    do {
      if (next && parent.isSameNode(next)) {
        return true;
      }
      next = next.parentNode || next.host;
    } while (next);
  }
  return false;
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function isTableElement(element) {
  return ["table", "td", "th"].indexOf(getNodeName(element)) >= 0;
}
function getDocumentElement(element) {
  return ((isElement(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}
function getParentNode(element) {
  if (getNodeName(element) === "html") {
    return element;
  }
  return element.assignedSlot || element.parentNode || (isShadowRoot(element) ? element.host : null) || getDocumentElement(element);
}
function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || getComputedStyle$1(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1;
  var isIE2 = navigator.userAgent.indexOf("Trident") !== -1;
  if (isIE2 && isHTMLElement(element)) {
    var elementCss = getComputedStyle$1(element);
    if (elementCss.position === "fixed") {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && ["html", "body"].indexOf(getNodeName(currentNode)) < 0) {
    var css2 = getComputedStyle$1(currentNode);
    if (css2.transform !== "none" || css2.perspective !== "none" || css2.contain === "paint" || ["transform", "perspective"].indexOf(css2.willChange) !== -1 || isFirefox && css2.willChange === "filter" || isFirefox && css2.filter && css2.filter !== "none") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  var window2 = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle$1(offsetParent).position === "static")) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}
function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}
function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min2, value, max2) {
  var v = within(min2, value, max2);
  return v > max2 ? max2 : v;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
function expandToHashMap(value, keys2) {
  return keys2.reduce(function(hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
var toPaddingObject = function toPaddingObject2(padding, state) {
  padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref) {
  var _state$modifiersData$;
  var state = _ref.state, name = _ref.name, options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? "height" : "width";
  if (!arrowElement || !popperOffsets2) {
    return;
  }
  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === "y" ? top : left;
  var maxProp = axis === "y" ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets2[axis] - state.rects.popper[len];
  var startDiff = popperOffsets2[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2;
  var min2 = paddingObject[minProp];
  var max2 = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset2 = within(min2, center, max2);
  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset2, _state$modifiersData$.centerOffset = offset2 - center, _state$modifiersData$);
}
function effect$1(_ref2) {
  var state = _ref2.state, options = _ref2.options;
  var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
  if (arrowElement == null) {
    return;
  }
  if (typeof arrowElement === "string") {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (process.env.NODE_ENV !== "production") {
    if (!isHTMLElement(arrowElement)) {
      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', "To use an SVG arrow, wrap it in an HTMLElement that will be used as", "the arrow."].join(" "));
    }
  }
  if (!contains(state.elements.popper, arrowElement)) {
    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', "element."].join(" "));
    }
    return;
  }
  state.elements.arrow = arrowElement;
}
const arrow$1 = {
  name: "arrow",
  enabled: true,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(placement) {
  return placement.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(_ref) {
  var x = _ref.x, y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round$1(x * dpr) / dpr || 0,
    y: round$1(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper2 = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
    x,
    y
  }) : {
    x,
    y
  };
  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper2);
    var heightProp = "clientHeight";
    var widthProp = "clientWidth";
    if (offsetParent === getWindow(popper2)) {
      offsetParent = getDocumentElement(popper2);
      if (getComputedStyle$1(offsetParent).position !== "static" && position === "absolute") {
        heightProp = "scrollHeight";
        widthProp = "scrollWidth";
      }
    }
    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x,
    y
  }) : {
    x,
    y
  };
  x = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state, options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  if (process.env.NODE_ENV !== "production") {
    var transitionProperty = getComputedStyle$1(state.elements.popper).transitionProperty || "";
    if (adaptive && ["transform", "top", "right", "bottom", "left"].some(function(property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', "\n\n", 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", "\n\n", "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
    }
  }
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration,
    isFixed: state.options.strategy === "fixed"
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive,
      roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: "absolute",
      adaptive: false,
      roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-placement": state.placement
  });
}
const computeStyles$1 = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: true
};
function effect(_ref) {
  var state = _ref.state, instance = _ref.instance, options = _ref.options;
  var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function(scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }
  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }
  return function() {
    if (scroll) {
      scrollParents.forEach(function(scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }
    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}
const eventListeners = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {
  },
  effect,
  data: {}
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function(matched) {
    return hash$1[matched];
  });
}
var hash = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function(matched) {
    return hash[matched];
  });
}
function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft,
    scrollTop
  };
}
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
function getViewportRect(element) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x: x + getWindowScrollBarX(element),
    y
  };
}
function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;
  if (getComputedStyle$1(body || html).direction === "rtl") {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}
function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle$1(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getScrollParent(node) {
  if (["html", "body", "#document"].indexOf(getNodeName(node)) >= 0) {
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent(getParentNode(node));
}
function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode(target)));
}
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
}
function getClippingParents(element) {
  var clippingParents2 = listScrollParents(getParentNode(element));
  var canEscapeClipping = ["absolute", "fixed"].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
  if (!isElement(clipperElement)) {
    return [];
  }
  return clippingParents2.filter(function(clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== "body";
  });
}
function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
  var clippingParents2 = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents2[0];
  var clippingRect = clippingParents2.reduce(function(accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
function computeOffsets(_ref) {
  var reference2 = _ref.reference, element = _ref.element, placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference2.x + reference2.width / 2 - element.width / 2;
  var commonY = reference2.y + reference2.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference2.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;
    case right:
      offsets = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference2.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference2.x,
        y: reference2.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference2[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference2[len] / 2 - element[len] / 2);
        break;
    }
  }
  return offsets;
}
function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets2 = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: "absolute",
    placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets2));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect;
  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset;
  if (elementContext === popper && offsetData) {
    var offset2 = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function(key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? "y" : "x";
      overflowOffsets[key] += offset2[axis] * multiply;
    });
  }
  return overflowOffsets;
}
function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement2) {
    return getVariation(placement2) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function(placement2) {
    return allowedAutoPlacements.indexOf(placement2) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
    if (process.env.NODE_ENV !== "production") {
      console.error(["Popper: The `allowedAutoPlacements` option did not allow any", "placements. Ensure the `placement` option matches the variation", "of the allowed placements.", 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(" "));
    }
  }
  var overflows = allowedPlacements.reduce(function(acc, placement2) {
    acc[placement2] = detectOverflow(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding
    })[getBasePlacement(placement2)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function(a, b) {
    return overflows[a] - overflows[b];
  });
}
function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref) {
  var state = _ref.state, options = _ref.options, name = _ref.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements2 = [preferredPlacement].concat(fallbackPlacements).reduce(function(acc, placement2) {
    return acc.concat(getBasePlacement(placement2) === auto ? computeAutoPlacement(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding,
      flipVariations,
      allowedAutoPlacements
    }) : placement2);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = /* @__PURE__ */ new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements2[0];
  for (var i = 0; i < placements2.length; i++) {
    var placement = placements2[i];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? "width" : "height";
    var overflow = detectOverflow(state, {
      placement,
      boundary,
      rootBoundary,
      altBoundary,
      padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function(check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop2(_i2) {
      var fittingPlacement = placements2.find(function(placement2) {
        var checks2 = checksMap.get(placement2);
        if (checks2) {
          return checks2.slice(0, _i2).every(function(check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break")
        break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
}
const flip$1 = {
  name: "flip",
  enabled: true,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: false
  }
};
function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function(side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref) {
  var state = _ref.state, name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: "reference"
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets,
    popperEscapeOffsets,
    isReferenceHidden,
    hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-reference-hidden": isReferenceHidden,
    "data-popper-escaped": hasPopperEscaped
  });
}
const hide$1 = {
  name: "hide",
  enabled: true,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(placement, rects, offset2) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset2 === "function" ? offset2(Object.assign({}, rects, {
    placement
  })) : offset2, skidding = _ref[0], distance = _ref[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state, options = _ref2.options, name = _ref2.name;
  var _options$offset = options.offset, offset2 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function(acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset2);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name] = data;
}
const offset$1 = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};
function popperOffsets(_ref) {
  var state = _ref.state, name = _ref.name;
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: "absolute",
    placement: state.placement
  });
}
const popperOffsets$1 = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function preventOverflow(_ref) {
  var state = _ref.state, options = _ref.options, name = _ref.name;
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary,
    rootBoundary,
    padding,
    altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets2) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === "y" ? top : left;
    var altSide = mainAxis === "y" ? bottom : right;
    var len = mainAxis === "y" ? "height" : "width";
    var offset2 = popperOffsets2[mainAxis];
    var min$1 = offset2 + overflow[mainSide];
    var max$1 = offset2 - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len];
    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide];
    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset2 + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset2 + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset2, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets2[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset2;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === "x" ? top : left;
    var _altSide = mainAxis === "x" ? bottom : right;
    var _offset = popperOffsets2[altAxis];
    var _len = altAxis === "y" ? "height" : "width";
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets2[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data;
}
const preventOverflow$1 = {
  name: "preventOverflow",
  enabled: true,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round$1(rect.width) / element.offsetWidth || 1;
  var scaleY = round$1(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
function order(modifiers) {
  var map = /* @__PURE__ */ new Map();
  var visited = /* @__PURE__ */ new Set();
  var result = [];
  modifiers.forEach(function(modifier) {
    map.set(modifier.name, modifier);
  });
  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function(dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function(modifier) {
    if (!visited.has(modifier.name)) {
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function(acc, phase) {
    return acc.concat(orderedModifiers.filter(function(modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
function debounce$1(fn2) {
  var pending;
  return function() {
    if (!pending) {
      pending = new Promise(function(resolve2) {
        Promise.resolve().then(function() {
          pending = void 0;
          resolve2(fn2());
        });
      });
    }
    return pending;
  };
}
function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return [].concat(args).reduce(function(p, c) {
    return p.replace(/%s/, c);
  }, str);
}
var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];
function validateModifiers(modifiers) {
  modifiers.forEach(function(modifier) {
    [].concat(Object.keys(modifier), VALID_PROPERTIES).filter(function(value, index, self2) {
      return self2.indexOf(value) === index;
    }).forEach(function(key) {
      switch (key) {
        case "name":
          if (typeof modifier.name !== "string") {
            console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', '"' + String(modifier.name) + '"'));
          }
          break;
        case "enabled":
          if (typeof modifier.enabled !== "boolean") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', '"' + String(modifier.enabled) + '"'));
          }
          break;
        case "phase":
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(", "), '"' + String(modifier.phase) + '"'));
          }
          break;
        case "fn":
          if (typeof modifier.fn !== "function") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', '"' + String(modifier.fn) + '"'));
          }
          break;
        case "effect":
          if (modifier.effect != null && typeof modifier.effect !== "function") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', '"' + String(modifier.fn) + '"'));
          }
          break;
        case "requires":
          if (modifier.requires != null && !Array.isArray(modifier.requires)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', '"' + String(modifier.requires) + '"'));
          }
          break;
        case "requiresIfExists":
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', '"' + String(modifier.requiresIfExists) + '"'));
          }
          break;
        case "options":
        case "data":
          break;
        default:
          console.error('PopperJS: an invalid property has been provided to the "' + modifier.name + '" modifier, valid properties are ' + VALID_PROPERTIES.map(function(s) {
            return '"' + s + '"';
          }).join(", ") + '; but "' + key + '" was provided.');
      }
      modifier.requires && modifier.requires.forEach(function(requirement) {
        if (modifiers.find(function(mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}
function uniqueBy(arr, fn2) {
  var identifiers = /* @__PURE__ */ new Set();
  return arr.filter(function(item) {
    var identifier = fn2(item);
    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function(merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged2;
  }, {});
  return Object.keys(merged).map(function(key) {
    return merged[key];
  });
}
var INVALID_ELEMENT_ERROR = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.";
var INFINITE_LOOP_ERROR = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.";
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function(element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions2 = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper2(reference2, popper2, options) {
    if (options === void 0) {
      options = defaultOptions2;
    }
    var state = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions2),
      modifiersData: {},
      elements: {
        reference: reference2,
        popper: popper2
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state,
      setOptions: function setOptions(setOptionsAction) {
        var options2 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions2, state.options, options2);
        state.scrollParents = {
          reference: isElement(reference2) ? listScrollParents(reference2) : reference2.contextElement ? listScrollParents(reference2.contextElement) : [],
          popper: listScrollParents(popper2)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function(m) {
          return m.enabled;
        });
        if (process.env.NODE_ENV !== "production") {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function(_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);
          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function(_ref2) {
              var name = _ref2.name;
              return name === "flip";
            });
            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
            }
          }
          var _getComputedStyle = getComputedStyle$1(popper2), marginTop = _getComputedStyle.marginTop, marginRight = _getComputedStyle.marginRight, marginBottom = _getComputedStyle.marginBottom, marginLeft = _getComputedStyle.marginLeft;
          if ([marginTop, marginRight, marginBottom, marginLeft].some(function(margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
          }
        }
        runModifierEffects();
        return instance.update();
      },
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements, reference3 = _state$elements.reference, popper3 = _state$elements.popper;
        if (!areValidElements(reference3, popper3)) {
          if (process.env.NODE_ENV !== "production") {
            console.error(INVALID_ELEMENT_ERROR);
          }
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference3, getOffsetParent(popper3), state.options.strategy === "fixed"),
          popper: getLayoutRect(popper3)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function(modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;
        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (process.env.NODE_ENV !== "production") {
            __debug_loops__ += 1;
            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index], fn2 = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
          if (typeof fn2 === "function") {
            state = fn2({
              state,
              options: _options,
              name,
              instance
            }) || state;
          }
        }
      },
      update: debounce$1(function() {
        return new Promise(function(resolve2) {
          instance.forceUpdate();
          resolve2(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference2, popper2)) {
      if (process.env.NODE_ENV !== "production") {
        console.error(INVALID_ELEMENT_ERROR);
      }
      return instance;
    }
    instance.setOptions(options).then(function(state2) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state2);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function(_ref3) {
        var name = _ref3.name, _ref3$options = _ref3.options, options2 = _ref3$options === void 0 ? {} : _ref3$options, effect2 = _ref3.effect;
        if (typeof effect2 === "function") {
          var cleanupFn = effect2({
            state,
            name,
            instance,
            options: options2
          });
          var noopFn = function noopFn2() {
          };
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function(fn2) {
        return fn2();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});
var hasElementType = typeof Element !== "undefined";
var hasMap = typeof Map === "function";
var hasSet = typeof Set === "function";
var hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
function equal(a, b) {
  if (a === b)
    return true;
  if (a && b && typeof a == "object" && typeof b == "object") {
    if (a.constructor !== b.constructor)
      return false;
    var length, i, keys2;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length)
        return false;
      for (i = length; i-- !== 0; )
        if (!equal(a[i], b[i]))
          return false;
      return true;
    }
    var it;
    if (hasMap && a instanceof Map && b instanceof Map) {
      if (a.size !== b.size)
        return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0]))
          return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0])))
          return false;
      return true;
    }
    if (hasSet && a instanceof Set && b instanceof Set) {
      if (a.size !== b.size)
        return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0]))
          return false;
      return true;
    }
    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length)
        return false;
      for (i = length; i-- !== 0; )
        if (a[i] !== b[i])
          return false;
      return true;
    }
    if (a.constructor === RegExp)
      return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf)
      return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString)
      return a.toString() === b.toString();
    keys2 = Object.keys(a);
    length = keys2.length;
    if (length !== Object.keys(b).length)
      return false;
    for (i = length; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(b, keys2[i]))
        return false;
    if (hasElementType && a instanceof Element)
      return false;
    for (i = length; i-- !== 0; ) {
      if ((keys2[i] === "_owner" || keys2[i] === "__v" || keys2[i] === "__o") && a.$$typeof) {
        continue;
      }
      if (!equal(a[keys2[i]], b[keys2[i]]))
        return false;
    }
    return true;
  }
  return a !== a && b !== b;
}
var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message || "").match(/stack|recursion/i)) {
      console.warn("react-fast-compare cannot handle circular refs");
      return false;
    }
    throw error;
  }
};
var EMPTY_MODIFIERS = [];
var usePopper = function usePopper2(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }
  var prevOptions = React$3.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || "bottom",
    strategy: options.strategy || "absolute",
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };
  var _React$useState = React$3.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), state = _React$useState[0], setState = _React$useState[1];
  var updateStateModifier = React$3.useMemo(function() {
    return {
      name: "updateState",
      enabled: true,
      phase: "write",
      fn: function fn2(_ref) {
        var state2 = _ref.state;
        var elements = Object.keys(state2.elements);
        setState({
          styles: fromEntries(elements.map(function(element) {
            return [element, state2.styles[element] || {}];
          })),
          attributes: fromEntries(elements.map(function(element) {
            return [element, state2.attributes[element]];
          }))
        });
      },
      requires: ["computeStyles"]
    };
  }, []);
  var popperOptions = React$3.useMemo(function() {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: "applyStyles",
        enabled: false
      }])
    };
    if (reactFastCompare(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React$3.useRef();
  useIsomorphicLayoutEffect(function() {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function() {
    if (referenceElement == null || popperElement == null) {
      return;
    }
    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function() {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};
const Wrapper$6 = styled.div.withConfig({
  displayName: "Informationstyled__Wrapper",
  componentId: "sc-6yy8q7-0"
})(["white-space:initial;text-align:left;"]);
const Backdrop = styled.div.withConfig({
  displayName: "Informationstyled__Backdrop",
  componentId: "sc-6yy8q7-1"
})(["position:fixed;top:0;left:0;display:block;content:'';width:100vw;height:100vh;background:rgba(0,0,0,0.5);z-index:3000;transition-property:opacity;transition-duration:300ms;", ""], ({
  isActive
}) => isActive ? `
      opacity: 1;
      pointer-events: auto;
    ` : `
      opacity: 0;
      pointer-events: none;
    `);
const ShowButton = styled.button.withConfig({
  displayName: "Informationstyled__ShowButton",
  componentId: "sc-6yy8q7-2"
})(["padding:0;appearance:none;background:none;border:none;cursor:pointer;color:#666;font-size:", ";", " &:hover,&:focus{color:", ";}"], ({
  $smallIcon = false
}) => $smallIcon ? "0.875rem;" : "1.25rem", Focusable(), theme.colors.primary);
const Popout = styled.div.withConfig({
  displayName: "Informationstyled__Popout",
  componentId: "sc-6yy8q7-3"
})(["position:relative;width:40ch;max-width:16rem;padding:", ";border:none;background-color:#fff;z-index:3001;"], theme.spacing(5));
const HideButton = styled.button.withConfig({
  displayName: "Informationstyled__HideButton",
  componentId: "sc-6yy8q7-4"
})(["position:absolute;top:13px;right:13px;display:flex;align-items:center;justify-content:center;appearance:none;background:none;border:none;cursor:pointer;width:1rem;height:1rem;.icon{flex-shrink:0;color:#2A2A2A;font-size:0.5rem;}"]);
const Arrow$1 = styled.div.withConfig({
  displayName: "Informationstyled__Arrow",
  componentId: "sc-6yy8q7-5"
})(["width:1.5rem;height:0.75rem;background-color:#fff;", ";", ";"], ({
  placement
}) => placement === "top" && css$1(["top:100%;clip-path:polygon(0 0,50% 100%,100% 0);"]), ({
  placement
}) => placement === "bottom" && css$1(["bottom:100%;clip-path:polygon(50% 0%,0% 100%,100% 100%);"]));
const Title$5 = styled.p.withConfig({
  displayName: "Informationstyled__Title",
  componentId: "sc-6yy8q7-6"
})(["margin:0 0 ", ";font-family:", ";font-weight:600;font-size:1rem;line-height:1.375;color:#000;text-transform:uppercase;"], theme.spacing(1), theme.fonts.dinRegular);
const Content$1 = styled.div.withConfig({
  displayName: "Informationstyled__Content",
  componentId: "sc-6yy8q7-7"
})(["font-family:", ";font-weight:600;font-size:0.8125rem;line-height:1.538;color:#666;a{color:", ";}> :first-child{margin-top:0;}> :last-child{margin-bottom:0;}"], theme.fonts.dinRegular, theme.colors.primary);
const Information = ({
  children,
  onShow,
  onClose,
  show = false,
  smallIcon = false,
  title
}) => {
  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const [arrowElement, setArrowElement] = useState(null);
  const {
    styles: styles3,
    attributes,
    state
  } = usePopper(referenceElement, popperElement, {
    modifiers: [{
      name: "arrow",
      options: {
        element: arrowElement,
        padding: 30
      }
    }, {
      name: "offset",
      options: {
        offset: [0, 16]
      }
    }]
  });
  const handleEscape = (event) => {
    if (event.keyCode === 27)
      onClose();
  };
  useEffect(() => {
    window.addEventListener("keydown", handleEscape, true);
    return () => {
      window.removeEventListener("keydown", handleEscape, true);
    };
  });
  return /* @__PURE__ */ jsxs(Wrapper$6, {
    className: "information",
    children: [/* @__PURE__ */ jsx(ShowButton, {
      type: "button",
      ref: setReferenceElement,
      $smallIcon: smallIcon,
      "aria-label": "Show more info",
      onClick: onShow,
      disabled: show,
      className: "information__show",
      children: /* @__PURE__ */ jsx(Icon, {
        name: "information",
        "aria-hidden": true
      })
    }), /* @__PURE__ */ jsx(Backdrop, {
      onClick: onClose,
      isActive: show
    }), show && /* @__PURE__ */ jsx(focusTrapReact, {
      focusTrapOptions: {
        allowOutsideClick: true
      },
      children: /* @__PURE__ */ jsxs(Popout, {
        ref: setPopperElement,
        style: styles3.popper,
        ...attributes.popper,
        children: [/* @__PURE__ */ jsx(HideButton, {
          onClick: onClose,
          "aria-label": "Close",
          children: /* @__PURE__ */ jsx(Icon, {
            name: "close",
            "aria-hidden": true
          })
        }), title && /* @__PURE__ */ jsx(Title$5, {
          children: title
        }), /* @__PURE__ */ jsx(Content$1, {
          children
        }), /* @__PURE__ */ jsx(Arrow$1, {
          ref: setArrowElement,
          style: styles3.arrow,
          placement: state == null ? void 0 : state.placement
        })]
      })
    })]
  });
};
const loading = "data:image/gif;base64,R0lGODlhMgAyAMQAAAAAAAYGBgwMDBERERgYGCMjIzAwMDs7O0VFRVFRUV5eXnBwcHl5eYSEhI+Pj5qamqKioqmpqbCwsLe3t7y8vMLCwsbGxszMzNHR0dPT09zc3OPj4+np6e3t7fT09Pr6+iH/C05FVFNDQVBFMi4wAwEAAAAh+QQECgAAACwAAAAAMgAyAAAF/yAgjmRpnmiqrmzrvnAsz3Rt33iu73zv/8Ag4YBAHA6GAkEQLBEaEEdjoTAqB4GmiCDRQBKErPbk8EwIY1Wlk0irMJqCO3XhIOYoyMeBPyU6GAN9JhQeDIMlCoByOgZMMRN7OgoKMwgbGgY4CQ9tM3oQNwUREGgzBxobdzUOGYesHxM1CRkUpjQEFx4LNBMcvDcLHhe3LwsdFGI3FJIwBRgclTkJHBoHMA8fEjx6ES+XG9c7Bhkd0iyRfD0MHhaCK8LEP8wNK8/mQNTWKtnbQXr+/GASB+SZoRMDKnyop0VYBoIjslV4pCVCLIoAFHDY4GmMAQwfIjBSoMEDQze0Ph5osHChg4dQfQ5I2MCBw4WTgwoYwYiop8+fQIP6DAEAIfkEBAoAAAAsCQAKACEAGgAABbwgII5jQJ5oOiaORFUXlmHUwyiIURCCehYSjqfT4WgyM0vklisMTL4R5YNxJBAHQmAb7QI+lIJ3fOokyGiRRpwmcxBt8scRH3cwg3qX4mHoowp3bH8pE3OEKggbGgaIKRAfEI4oBxobcJMkDh8ThHkoBBceC3oHgycLHhcEcQYLrCpTdGkCDaQ+CUYHaQsSZ1GQEWgHFBCfPgYZHQpkERm3XQweFsc+CxsTUF5TDV0FFxvMZLkauz4OHsIpIQAh+QQECgAAACwTAAoAFwAiAAAFhmAgjiNgniiarex6Tc6SIIdREILarpgVMQparUC8mUiklPI4WDqXgad0Sq1ar9isdsvter/gsHhMLiujy2a3QSU8NQcpwe38SJ4CRM6J8TCcCglSCx4ZcSkKDodPEXZ7JggRbFMGGB8RBSYJExQIVQkZHxoUFRoZf1YHEhobowtaBQcHaFQhACH5BAQKAAAALBAACgAcACIAAAWRIAAEZGmegaiuwIVlcCzPGWZVE7QMqkb/Ms2Gs9lcHgcRAcU0CQqHQ2LhaBRY2Gy2sFBov1+EQgAurwoKntlcSKTW5SjcfCDMwQXDHU/eZwV2fllqgoWGh4hfgYkADowiGkmMHxCPGBwJjAscFG+IExsLjAgYE4uHDRaiiQMPD1eJCA6ZjAkKnogHsIx9j76HIQAh+QQECgAAACwLAAsAIQAfAAAFwmDiSFR1YVmqrmyGWRUVMQVgc17XcVrrr5oNp+PxZBg2jCOBOBAC0Kh0ChUUDgmGhMNB1mzgsHhMXnQwBLJ6PZ50FOz42uFByu/hiGeB7xMyGwYDfXcMHhMAdoRrAxdvABhfi2QNhzYfDpNkBBMXCDYbGgaaYgkQfDYQHw+kYQpwYAZBn60FCpI2lRKtAE1jAxUbsJMEB2oKGhIBmgZpag8XqIRWbAYRD4OE2WwiCbxrCN7fagXb4+fo6err7O3u7wAhACH5BAQKAAAALAgAEAAiABkAAAWUIKYRQGmeaKqWjrUdayyb0dM5c54SGaJVAZ0QwPAAIBnFMDe4dAAHSkSwlDU+lBJjoqyqCppOV9BwUL0oxydyOjQS6PZmg0AhFOd45PNQIWBxChwZBSoBBwNxFR4MMQSFXgsdFXmGXgESGl1xKwgSDZwyCguJoV8KkKYpf6pfda0pBySwJ4+0KKm3AAOVtEG6JqUyIQAh+QQECgAAACwIAAsAHQAgAAAFnSAgGosTSdWFrVnrvi5mVaLySJN1WToL/xnNhgM4MBaIgjIgCjif0KigcAAYCqKsdsvter/gsHhMLpvP6LR6zW673/C2Ig6gwRkeeCHTgT8+Em8IGxtVbhMfDm8LHhcEbgUYHXNuDoBkTF8HGhqGYwJfDxwNZgMDXQgTEqBmBZlZAQwPnmUDBqdNCgwIagQIBwcICgu0aAQHCclYXSEAIfkEBAoAAAAsCQAKABcAIgAABYggII5kKQZoao5EwjwRVV0Ylt3ZKhpK80gUC82G0xlTKqNyyWw6n9CodEqtWq/YrHarE1gFA2shUCUYrIdCtZAIK9U6RGL5MBYWCmNio1RA8iYDFR9vEhVnJQ8fFUsNHBJeIwocG3NKBBYfEXAKGh4NTQkZHxpCHR4QTwcSGxwcF6BRBQgHkSIhACH5BAQKAAAALAsACgAaAB8AAAWrICCOZGmeqEgYiMI4jzRVllVRqdoujQPJtEtGw8kZAQFB4XBsOp/QqHRKrVqrgqtIkNUWtIDCV3sgVBUiA5NaGSUQU4ZnhGgkooVMZ0SITAxQDx8SJA4dEE8IGxtrIgUYHWhNEx8OJnIWA0cLHhdmJhQfDUaPkSgJHBqNJ4KEKRCDKQkbqjmPHgwnAxWimx4ZqyKCFV1GER8TxQAKHBt3TQYYHxFjChoeoyUhACH5BAQKAAAALAgACwAjABYAAAW1ICCOZGmeAFEUZiCg6EAEolAcCeM4SV3QsGBJcGBMKgpA4SVslhKYSsHgrJIiGwPVam1wDAiuFcIpJAbiJgGjASQOaSHDIwEYEsC4aXDpJAEKYXomDR8UIwoOcIMjBRp+jRIQaIwADh8RJQ8cDpUHGxuCIwcaoYwRHw8nlxODChwZLCYEFx4LehUeDDALHhcEaXMVTCgUH51cBRmQQQkcGotVDx91TRCYVgig0UEGy39NE8cnIQA7";
const Wrap$7 = styled.div.withConfig({
  displayName: "InlineLoaderstyled__Wrap",
  componentId: "sc-1d01rx-0"
})(["background-color:#000;display:flex;align-items:center;justify-content:center;flex-direction:column;gap:", ";padding:", ";"], theme.spacing(2), theme.spacing(2));
const Image$3 = styled.img.withConfig({
  displayName: "InlineLoaderstyled__Image",
  componentId: "sc-1d01rx-1"
})(["display:block;"]);
const Text$3 = styled.div.withConfig({
  displayName: "InlineLoaderstyled__Text",
  componentId: "sc-1d01rx-2"
})(["text-transform:uppercase;text-align:center;color:white;"]);
const InlineLoader = ({
  text
}) => /* @__PURE__ */ jsx(Fragment, {
  children: /* @__PURE__ */ jsxs(Wrap$7, {
    children: [/* @__PURE__ */ jsx(Image$3, {
      src: loading,
      alt: "Loading"
    }), text && /* @__PURE__ */ jsx(Text$3, {
      children: text
    })]
  })
});
const loadingIconWhite = "data:image/gif;base64,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";
const Wrap$6 = styled.div.withConfig({
  displayName: "ItemLoaderstyled__Wrap",
  componentId: "sc-1ml050z-0"
})(["position:relative;display:flex;align-items:center;justify-content:center;flex-direction:column;"]);
const Image$2 = styled.img.withConfig({
  displayName: "ItemLoaderstyled__Image",
  componentId: "sc-1ml050z-1"
})(["display:block;margin-bottom:10px;"]);
const Text$2 = styled.div.withConfig({
  displayName: "ItemLoaderstyled__Text",
  componentId: "sc-1ml050z-2"
})(["text-transform:uppercase;font-size:12px;color:#000;"]);
const Loader$1 = ({
  labelName
}) => /* @__PURE__ */ jsxs(Wrap$6, {
  children: [/* @__PURE__ */ jsx(Image$2, {
    src: loadingIconWhite,
    alt: "Loading"
  }), /* @__PURE__ */ jsx(Text$2, {})]
});
const Grid = styled.section.withConfig({
  displayName: "LinkGridstyled__Grid",
  componentId: "sc-1i55jc7-0"
})(["display:grid;grid-gap:clamp(", ",5vw,", ");grid-template-columns:repeat(auto-fill,minmax(22rem,1fr));"], theme.spacing(1), theme.spacing(2));
const Link = styled(Link$1).withConfig({
  displayName: "LinkGridstyled__Link",
  componentId: "sc-1i55jc7-1"
})(["display:flex;align-items:center;gap:clamp(", ",5vw,", ");padding:clamp(", ",5vw,", ");border:1px solid #e6e6e6;background-color:#fff;font-family:", ";font-weight:600;font-size:1rem;line-height:1.375;text-align:left;text-decoration:none;color:#000 !important;transition:border-color,150ms ease-in-out;&:hover,&:focus{border-color:", ";cursor:pointer;text-decoration:underline 2px !important;}.icon{flex-shrink:0;font-size:0.5rem;transform:rotate(90deg);transition:color 150ms ease-in-out;}", ""], theme.spacing(3), theme.spacing(5), theme.spacing(2), theme.spacing(5), theme.fonts.dinRegular, theme.colors.primary, Focusable());
const Image$1 = styled.img.withConfig({
  displayName: "LinkGridstyled__Image",
  componentId: "sc-1i55jc7-2"
})(["flex-shrink:0;width:100%;max-width:5rem;aspect-ratio:", ";"], 67 / 42);
const Name$1 = styled.span.withConfig({
  displayName: "LinkGridstyled__Name",
  componentId: "sc-1i55jc7-3"
})(["flex:1 1 0;small{line-height:1rem;}"]);
const LinkGrid = ({
  links = [],
  ...props
}) => /* @__PURE__ */ jsx(Grid, {
  ...props,
  children: links.map(({
    id,
    name,
    image,
    ...props2
  }) => /* @__PURE__ */ jsxs(Link, {
    as: !props2.to ? "button" : void 0,
    ...props2,
    children: [image && /* @__PURE__ */ jsx(Image$1, {
      src: image.src,
      alt: image.alt,
      width: image.width,
      height: image.height
    }), /* @__PURE__ */ jsx(Name$1, {
      dangerouslySetInnerHTML: {
        __html: name
      }
    }), /* @__PURE__ */ jsx(Icon, {
      name: "chevron-down",
      "aria-hidden": true
    })]
  }, id))
});
const Wrap$5 = styled.div.withConfig({
  displayName: "Loaderstyled__Wrap",
  componentId: "sc-gn4e5h-0"
})(["position:fixed;top:50%;left:50%;width:100px;height:100px;background-color:#000;margin:-50px 0 0 -50px;display:flex;align-items:center;justify-content:center;flex-direction:column;z-index:1000;"]);
const Image = styled.img.withConfig({
  displayName: "Loaderstyled__Image",
  componentId: "sc-gn4e5h-1"
})(["display:block;margin-bottom:10px;"]);
const Text$1 = styled.div.withConfig({
  displayName: "Loaderstyled__Text",
  componentId: "sc-gn4e5h-2"
})(["text-transform:uppercase;text-align:center;font-size:12px;color:white;"]);
const Overlay = styled.div.withConfig({
  displayName: "Loaderstyled__Overlay",
  componentId: "sc-gn4e5h-3"
})(["position:fixed;top:0;left:0;width:100%;height:100%;"]);
const Loader = ({
  text
}) => /* @__PURE__ */ jsxs(Fragment, {
  children: [/* @__PURE__ */ jsx(Overlay, {}), /* @__PURE__ */ jsxs(Wrap$5, {
    children: [/* @__PURE__ */ jsx(Image, {
      src: loading,
      alt: "Loading"
    }), text && /* @__PURE__ */ jsx(Text$1, {
      children: text
    })]
  })]
});
const Wrapper$5 = styled.div.withConfig({
  displayName: "LoadingOverlaystyled__Wrapper",
  componentId: "sc-6tsz61-0"
})(["box-sizing:border-box;position:fixed;inset:1;display:flex;flex-direction:column;justify-content:center;align-items:center;width:100vw;height:100vh;padding:", ";text-align:center;"], theme.spacing(3));
const Title$4 = styled.h2.withConfig({
  displayName: "LoadingOverlaystyled__Title",
  componentId: "sc-6tsz61-1"
})(["margin:0 0 ", ";font-family:", ";font-size:1.625rem;font-weight:600;line-height:1;text-transform:uppercase;@media ", "{margin-bottom:", ";}"], theme.spacing(3), theme.fonts.dinRegular, minBp("desktop"), theme.spacing(1));
const Subtitle = styled.p.withConfig({
  displayName: "LoadingOverlaystyled__Subtitle",
  componentId: "sc-6tsz61-2"
})(["margin:0;font-family:", ";font-size:1.25rem;font-weight:600;line-height:1.2;text-transform:uppercase;"], theme.fonts.dinRegular);
const Indicator = styled.img.withConfig({
  displayName: "LoadingOverlaystyled__Indicator",
  componentId: "sc-6tsz61-3"
})(["margin:", " 0;width:clamp(5rem,5vw,6.25rem);height:clamp(5rem,5vw,6.25rem);"], theme.spacing(7));
const Children = styled.div.withConfig({
  displayName: "LoadingOverlaystyled__Children",
  componentId: "sc-6tsz61-4"
})(["max-width:54ch;> *{&:not(:last-child){margin-bottom:clamp(3.125rem,5vw,5rem);}&:last-child{margin-bottom:0;}}"]);
const Text = styled.p.withConfig({
  displayName: "LoadingOverlaystyled__Text",
  componentId: "sc-6tsz61-5"
})(["font-family:", ";font-weight:600;", " a{color:#000;&:hover,&:focus{}}"], theme.fonts.dinRegular, ({
  alternative = false
}) => css$1(["font-size:", ";line-height:", ";", ""], alternative ? "14px" : "1rem", alternative ? 1.4285 : 1.375, alternative && css$1(["@media ", "{font-size:0.8125rem;line-height:1.538}"], minBp("desktop"))));
const LoadingOverlay = ({
  children,
  title,
  subtitle
}) => /* @__PURE__ */ jsxs(Wrapper$5, {
  "aria-busy": "true",
  "aria-live": "polite",
  children: [/* @__PURE__ */ jsx(Title$4, {
    children: title
  }), subtitle && /* @__PURE__ */ jsx(Subtitle, {
    children: subtitle
  }), /* @__PURE__ */ jsx(Indicator, {
    src: loading,
    alt: "Loading",
    "aria-hidden": true
  }), /* @__PURE__ */ jsx(Children, {
    children
  })]
});
LoadingOverlay.Text = Text;
const logo = "data:image/svg+xml;base64,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";
const logoAlt = "data:image/png;base64,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";
const Component = styled.img.withConfig({
  displayName: "Logostyled__Component",
  componentId: "sc-3e0zrw-0"
})(["max-width:130px;margin:0 auto;"]);
function Logo(props) {
  return props.altLogo ? /* @__PURE__ */ jsx(Component, {
    src: logoAlt,
    ...props
  }) : /* @__PURE__ */ jsx(Component, {
    src: logo,
    ...props
  });
}
const Wrap$4 = styled.div.withConfig({
  displayName: "NoResultsstyled__Wrap",
  componentId: "sc-ng9ahp-0"
})(["margin:30px 0;"]);
const Title$3 = styled.h3.withConfig({
  displayName: "NoResultsstyled__Title",
  componentId: "sc-ng9ahp-1"
})([""]);
const Description$2 = styled.p.withConfig({
  displayName: "NoResultsstyled__Description",
  componentId: "sc-ng9ahp-2"
})([""]);
const NoResults = () => /* @__PURE__ */ jsxs(Wrap$4, {
  children: [/* @__PURE__ */ jsx(Title$3, {}), /* @__PURE__ */ jsx(Description$2, {})]
});
const Wrapper$4 = styled.div.withConfig({
  displayName: "Notestyled__Wrapper",
  componentId: "sc-17n8t34-0"
})(["max-width:68ch;font-family:", ";font-size:", ";line-height:1.428;color:#2a2a2a;"], theme.fonts.dinRegular, ({
  $smallFont = false
}) => $smallFont ? "0.8125rem;" : "0.875rem;");
const Title$2 = styled.label.withConfig({
  displayName: "Notestyled__Title",
  componentId: "sc-17n8t34-1"
})(["display:block;margin-bottom:", ";font-weight:600;text-transform:uppercase;"], theme.spacing(1));
const Message = styled.p.withConfig({
  displayName: "Notestyled__Message",
  componentId: "sc-17n8t34-2"
})(["margin:0;font-size:", ";"], ({
  $smallFont = false
}) => $smallFont ? "0.8125rem;" : "0.875rem;");
const Note = ({
  children,
  title
}) => /* @__PURE__ */ jsxs(Wrapper$4, {
  role: "alert",
  children: [title && /* @__PURE__ */ jsx(Title$2, {
    children: title
  }), /* @__PURE__ */ jsx(Message, {
    children
  })]
});
const Wrap$3 = styled.div.withConfig({
  displayName: "PageHeadingstyled__Wrap",
  componentId: "sc-yhtl9a-0"
})(["max-width:450px;margin:0 auto 24px;text-align:center;@media ", "{margin-bottom:32px;}"], minBp("desktop"));
const Title$1 = styled.h2.withConfig({
  displayName: "PageHeadingstyled__Title",
  componentId: "sc-yhtl9a-1"
})(["font-family:", ";font-size:24px;line-height:26px;margin:0 0 11px;text-transform:uppercase;@media ", "{margin:0 0 14px;font-size:35px;line-height:45px;}"], theme.fonts.dinDemi, minBp("desktop"));
const Description$1 = styled.p.withConfig({
  displayName: "PageHeadingstyled__Description",
  componentId: "sc-yhtl9a-2"
})(["margin:0;"]);
const PageHeading = ({
  className,
  title,
  description
}) => /* @__PURE__ */ jsxs(Wrap$3, {
  className,
  children: [/* @__PURE__ */ jsx(Title$1, {
    children: title
  }), /* @__PURE__ */ jsx(Description$1, {
    children: description
  })]
});
const Wrapper$3 = styled.div.withConfig({
  displayName: "Panelstyled__Wrapper",
  componentId: "sc-3216ai-0"
})(["border:1px solid #E6E6E6;background-color:#fff;"]);
const Main = styled.div.withConfig({
  displayName: "Panelstyled__Main",
  componentId: "sc-3216ai-1"
})(["padding:", " ", ";@media ", "{padding:", " ", ";}"], theme.spacing(5), theme.spacing(3), minBp("tabletLarge"), theme.spacing(6), theme.spacing(5));
const Meta = styled.div.withConfig({
  displayName: "Panelstyled__Meta",
  componentId: "sc-3216ai-2"
})(["margin-bottom:", ";max-width:84ch;@media ", "{margin-bottom:", ";}"], theme.spacing(3), minBp("tabletLarge"), theme.spacing(5));
const Title = styled.p.withConfig({
  displayName: "Panelstyled__Title",
  componentId: "sc-3216ai-3"
})(["margin:0;font-family:", ";font-weight:600;font-size:1.375rem;line-height:1.363;text-transform:uppercase;color:#2A2A2A;"], theme.fonts.dinRegular);
const Description = styled.p.withConfig({
  displayName: "Panelstyled__Description",
  componentId: "sc-3216ai-4"
})(["margin:", " 0 0;font-family:", ";font-weight:600;font-size:0.875rem;line-height:1.25;color:#666;@media ", "{font-size:1rem;line-height:1.375;}"], theme.spacing(1), theme.fonts.dinRegular, minBp("tabletLarge"));
const Content = styled.div.withConfig({
  displayName: "Panelstyled__Content",
  componentId: "sc-3216ai-5"
})(["", ""], ({
  $spacing
}) => $spacing && `
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(5)};
    align-items: start;
  `);
const Footer = styled.div.withConfig({
  displayName: "Panelstyled__Footer",
  componentId: "sc-3216ai-6"
})(["padding:", " ", ";border-top:1px solid #e6e6e6;> :first-child{margin-top:0;}> :last-child{margin-bottom:0;}@media ", "{padding:", " ", ";}"], theme.spacing(5), theme.spacing(3), minBp("tabletLarge"), theme.spacing(6), theme.spacing(5));
const Panel = ({
  children,
  description,
  footer,
  title,
  spacing = false
}) => /* @__PURE__ */ jsxs(Wrapper$3, {
  children: [/* @__PURE__ */ jsxs(Main, {
    children: [(title || description) && /* @__PURE__ */ jsxs(Meta, {
      children: [title && /* @__PURE__ */ jsx(Title, {
        children: title
      }), description && /* @__PURE__ */ jsx(Description, {
        children: description
      })]
    }), /* @__PURE__ */ jsx(Content, {
      $spacing: spacing,
      children
    })]
  }), footer && /* @__PURE__ */ jsx(Footer, {
    children: footer
  })]
});
const Wrap$2 = styled.div.withConfig({
  displayName: "Paperstyled__Wrap",
  componentId: "sc-1ezhneq-0"
})(["box-shadow:0px 0px 40px 0px rgba(0,0,0,0.1);background-color:white;"]);
const Paper = forwardRef(({
  className,
  children
}, ref) => /* @__PURE__ */ jsx(Wrap$2, {
  ref,
  className,
  children
}));
const formatPrice = (amount = 0, currencyCode = "GBP", languageCode = getLanguageCode()) => amount.toLocaleString(languageCode, {
  style: "currency",
  currency: currencyCode
});
const Wrapper$2 = styled.span.withConfig({
  displayName: "PriceAndQuantitystyled__Wrapper",
  componentId: "sc-1a6hlgn-0"
})(["display:flex;flex-direction:column;gap:0.125rem;font-family:", ";font-weight:600;font-size:0.8125rem;line-height:1.25rem;color:#666;"], theme.fonts.dinRegular);
const Value = styled.span.withConfig({
  displayName: "PriceAndQuantitystyled__Value",
  componentId: "sc-1a6hlgn-1"
})(["span{font-family:", ";font-weight:600;font-size:1rem;color:#2a2a2a;}"], theme.fonts.dinRegular);
const PriceAndQuantity = ({
  price,
  quantity,
  currencyCode,
  perItemLabel = "{0} / item",
  quantityLabel = "{0} required"
}) => {
  return /* @__PURE__ */ jsxs(Wrapper$2, {
    children: [/* @__PURE__ */ jsx(Value, {
      dangerouslySetInnerHTML: {
        __html: perItemLabel.replace("{0}", `<span>${price || formatPrice(0, currencyCode)}</span>`)
      }
    }), quantity && /* @__PURE__ */ jsx("span", {
      children: quantityLabel.replace("{0}", quantity)
    })]
  });
};
const Wrapper$1 = styled.div.withConfig({
  displayName: "PartsBasketstyled__Wrapper",
  componentId: "sc-eau9oq-0"
})([""]);
const Table = styled.table.withConfig({
  displayName: "PartsBasketstyled__Table",
  componentId: "sc-eau9oq-1"
})(["width:100%;display:table;"]);
const Header = styled.thead.withConfig({
  displayName: "PartsBasketstyled__Header",
  componentId: "sc-eau9oq-2"
})(["@media ", "{display:none;}th{padding-bottom:15px;border-bottom:1px solid #e6e6e6;font-family:", ";font-weight:600;font-size:0.875rem;line-height:1.428;text-align:left;color:#666;}"], maxBp("tabletLarge"), theme.fonts.dinRegular);
const InformationWrapper = styled.div.withConfig({
  displayName: "PartsBasketstyled__InformationWrapper",
  componentId: "sc-eau9oq-3"
})(["display:flex;gap:0.25rem;.information__show{transform:translateY(10%);}@media ", "{", ";}"], minBp("tabletLarge"), ({
  $padding = false
}) => $padding && `
      padding-left: ${theme.spacing(2)};
    `);
const Body = styled.tbody.withConfig({
  displayName: "PartsBasketstyled__Body",
  componentId: "sc-eau9oq-4"
})(["@media ", "{> * + *{margin-top:", ";}}"], maxBp("tabletLarge"), theme.spacing(2));
const Row = styled.tr.withConfig({
  displayName: "PartsBasketstyled__Row",
  componentId: "sc-eau9oq-5"
})(["vertical-align:middle;@media ", "{display:grid;grid-template-columns:repeat(3,1fr);align-items:center;border:1px solid #e6e6e6;}@media ", "{padding:", " 0;width:100%;border-bottom:1px solid #e6e6e6;td{height:80px;border-bottom:1px solid #e6e6e6;}}"], maxBp("tabletLarge"), minBp("tabletLarge"), theme.spacing(3));
const Sku = styled.td.withConfig({
  displayName: "PartsBasketstyled__Sku",
  componentId: "sc-eau9oq-6"
})(["grid-column:1 / -1;font-family:", ";font-weight:600;font-size:0.8125rem;line-height:1.538;color:#666;@media ", "{padding:", " ", " 0;}"], theme.fonts.dinRegular, maxBp("tabletLarge"), theme.spacing(2), theme.spacing(2));
const Name = styled.td.withConfig({
  displayName: "PartsBasketstyled__Name",
  componentId: "sc-eau9oq-7"
})(["grid-column:1 / -1;font-family:", ";font-weight:600;font-size:1rem;line-height:1.375;color:#2a2a2a;@media ", "{padding:0 ", " ", ";border-bottom:1px solid #e6e6e6;}"], theme.fonts.dinRegular, maxBp("tabletLarge"), theme.spacing(2), theme.spacing(2));
const PriceWrapper = styled.td.withConfig({
  displayName: "PartsBasketstyled__PriceWrapper",
  componentId: "sc-eau9oq-8"
})(["span{line-height:1.25rem;}@media ", "{padding:", ";}"], maxBp("tabletLarge"), theme.spacing(2));
const Quantity = styled.div.withConfig({
  displayName: "PartsBasketstyled__Quantity",
  componentId: "sc-eau9oq-9"
})(["display:flex;align-items:center;gap:0.25rem;padding:", ";@media ", "{gap:", ";}"], theme.spacing(1), minBp("additional.mobile"), theme.spacing(1));
const quantityButtonStyles = css$1(["position:relative;width:1.25rem;height:1.25rem;border:none;appearance:none;background:none;color:#000;cursor:pointer;", " > *{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);}"], Focusable());
const QuantityMinus = styled.button.withConfig({
  displayName: "PartsBasketstyled__QuantityMinus",
  componentId: "sc-eau9oq-10"
})(["", " font-size:1px;"], quantityButtonStyles);
const QuantityValue = styled.span.withConfig({
  displayName: "PartsBasketstyled__QuantityValue",
  componentId: "sc-eau9oq-11"
})(["display:block;width:1.875rem;height:1.875rem;border:1px solid #000;font-family:", ";font-weight:600;font-size:0.875rem;line-height:1.875rem;text-align:center;"], theme.fonts.dinRegular);
const QuantityPlus = styled.button.withConfig({
  displayName: "PartsBasketstyled__QuantityPlus",
  componentId: "sc-eau9oq-12"
})(["", " font-size:0.75rem;"], quantityButtonStyles);
const RemoveWrapper = styled.td.withConfig({
  displayName: "PartsBasketstyled__RemoveWrapper",
  componentId: "sc-eau9oq-13"
})(["display:flex;justify-content:end;align-items:center;@media ", "{padding-right:", ";}"], maxBp("tabletLarge"), theme.spacing(2));
const Remove = styled.button.withConfig({
  displayName: "PartsBasketstyled__Remove",
  componentId: "sc-eau9oq-14"
})(["appearance:none;max-width:12rem;display:flex;flex-wrap:wrap;align-items:center;justify-content:center;gap:0.15rem;padding:0.4rem;border-radius:0.3em;border:none;background-color:#000;color:#fff;font-family:", ";font-weight:600;font-size:0.8125rem;line-height:1;text-transform:capitalize;cursor:pointer;outline-offset:2px;", " @media ", "{gap:0.25rem;padding:0.6rem;}"], theme.fonts.dinRegular, Focusable(), minBp("additional.mobile"));
const RemoveIcon = styled(Icon).withConfig({
  displayName: "PartsBasketstyled__RemoveIcon",
  componentId: "sc-eau9oq-15"
})(["margin-right:0.3125rem;font-size:0.5625rem;"]);
const Empty = styled.p.withConfig({
  displayName: "PartsBasketstyled__Empty",
  componentId: "sc-eau9oq-16"
})(["margin-bottom:2rem;"]);
const PartsBasket = ({
  items = [],
  labels: {
    basketEmpty,
    basketRemove,
    partsTableItemName,
    PartNo,
    partsTableQty,
    partsTableQtyInfo,
    partsTableQtyInfoTitle,
    partsTableRrp,
    partsTableRrpInfo,
    partsTableRrpInfoTitle,
    partsTablePerItem,
    partsTableRequired
  },
  onChange
}) => {
  const [activeInformation, setActiveInformation] = useState(null);
  return /* @__PURE__ */ jsx(Wrapper$1, {
    children: items.length > 0 ? /* @__PURE__ */ jsxs(Table, {
      children: [/* @__PURE__ */ jsx(Header, {
        children: /* @__PURE__ */ jsxs("tr", {
          children: [/* @__PURE__ */ jsx("th", {
            children: PartNo
          }), /* @__PURE__ */ jsx("th", {
            children: partsTableItemName
          }), /* @__PURE__ */ jsx("th", {
            children: /* @__PURE__ */ jsxs(InformationWrapper, {
              $padding: true,
              children: [/* @__PURE__ */ jsx(Information, {
                title: partsTableQtyInfoTitle,
                smallIcon: true,
                show: activeInformation === "qty",
                onShow: () => setActiveInformation("qty"),
                onClose: () => setActiveInformation(null),
                children: /* @__PURE__ */ jsx("span", {
                  dangerouslySetInnerHTML: {
                    __html: partsTableQtyInfo
                  }
                })
              }), " ", partsTableQty]
            })
          }), /* @__PURE__ */ jsx("th", {
            children: /* @__PURE__ */ jsxs(InformationWrapper, {
              children: [/* @__PURE__ */ jsx(Information, {
                title: partsTableRrpInfoTitle,
                smallIcon: true,
                show: activeInformation === "rrp",
                onShow: () => setActiveInformation("rrp"),
                onClose: () => setActiveInformation(null),
                children: /* @__PURE__ */ jsx("span", {
                  dangerouslySetInnerHTML: {
                    __html: partsTableRrpInfo
                  }
                })
              }), partsTableRrp]
            })
          }), /* @__PURE__ */ jsx("th", {})]
        })
      }), /* @__PURE__ */ jsx(Body, {
        children: items.map((part) => /* @__PURE__ */ jsxs(Row, {
          children: [/* @__PURE__ */ jsx(Sku, {
            children: part.sku
          }), /* @__PURE__ */ jsx(Name, {
            children: part.name
          }), /* @__PURE__ */ jsx("td", {
            children: /* @__PURE__ */ jsxs(Quantity, {
              children: [/* @__PURE__ */ jsx(QuantityMinus, {
                type: "button",
                onClick: () => onChange({
                  part,
                  quantity: Math.max(0, part.quantity - 1),
                  type: "decrease"
                }),
                children: /* @__PURE__ */ jsx(Icon, {
                  name: "minus",
                  "aria-hidden": true
                })
              }), /* @__PURE__ */ jsx(QuantityValue, {
                children: part == null ? void 0 : part.quantity
              }), /* @__PURE__ */ jsx(QuantityPlus, {
                type: "button",
                onClick: () => onChange({
                  part,
                  quantity: part.quantity + 1,
                  type: "increase"
                }),
                children: /* @__PURE__ */ jsx(Icon, {
                  name: "plus",
                  "aria-hidden": true
                })
              })]
            })
          }), /* @__PURE__ */ jsx(PriceWrapper, {
            children: (part == null ? void 0 : part.unitPriceLocalised) === "POA" ? part == null ? void 0 : part.unitPriceLocalised : /* @__PURE__ */ jsx(PriceAndQuantity, {
              price: part.unitPriceLocalised,
              quantity: part.requiredQuantity,
              perItemLabel: partsTablePerItem,
              quantityLabel: partsTableRequired
            })
          }), /* @__PURE__ */ jsx(RemoveWrapper, {
            children: /* @__PURE__ */ jsxs(Remove, {
              onClick: () => onChange({
                part,
                quantity: 0,
                type: "remove"
              }),
              children: [/* @__PURE__ */ jsx(RemoveIcon, {
                name: "close",
                "aria-hidden": true
              }), /* @__PURE__ */ jsx("span", {
                children: basketRemove
              })]
            })
          })]
        }, part.sku + part.displayIndex))
      })]
    }) : /* @__PURE__ */ jsx(Empty, {
      children: basketEmpty
    })
  });
};
const RichText = styled.div.withConfig({
  displayName: "RichText",
  componentId: "sc-w6bip4-0"
})(["line-height:", ";ul:not([class*='-sc-']):not([class*='styled__']){padding-left:1rem;list-style:inherit;@media screen and (-ms-high-contrast:active),screen and (-ms-high-contrast:none){list-style:disc;}li:not([class*='-sc-']):not([class*='styled__']){@media (min-width:1px){font-size:inherit;line-height:inherit;padding-left:0;}@media screen and (-ms-high-contrast:active),screen and (-ms-high-contrast:none){padding:1px 0;}&:before{content:'';}}}"], ({
  forceLineHeight
}) => forceLineHeight ? "1.375" : "inherit");
var Check = {};
var interopRequireDefault = { exports: {} };
(function(module) {
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  module.exports = _interopRequireDefault2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(interopRequireDefault);
var interopRequireWildcard = { exports: {} };
var _typeof$2 = { exports: {} };
(function(module) {
  function _typeof2(obj) {
    "@babel/helpers - typeof";
    return module.exports = _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
      return typeof obj2;
    } : function(obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof2(obj);
  }
  module.exports = _typeof2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(_typeof$2);
(function(module) {
  var _typeof2 = _typeof$2.exports["default"];
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
    var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache2(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard2(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof2(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache2 = _getRequireWildcardCache(nodeInterop);
    if (cache2 && cache2.has(obj)) {
      return cache2.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache2) {
      cache2.set(obj, newObj);
    }
    return newObj;
  }
  module.exports = _interopRequireWildcard2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(interopRequireWildcard);
var createSvgIcon$1 = {};
function chainPropTypes(propType1, propType2) {
  if (process.env.NODE_ENV === "production") {
    return function() {
      return null;
    };
  }
  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
function isPlainObject(item) {
  return item && _typeof$1(item) === "object" && item.constructor === Object;
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? _extends({}, target) : target;
  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function(key) {
      if (key === "__proto__") {
        return;
      }
      if (isPlainObject(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var specialProperty = "exact-prop: \u200B";
function exactProp(propTypes2) {
  if (process.env.NODE_ENV === "production") {
    return propTypes2;
  }
  return _extends({}, propTypes2, _defineProperty({}, specialProperty, function(props) {
    var unsupportedProps = Object.keys(props).filter(function(prop) {
      return !propTypes2.hasOwnProperty(prop);
    });
    if (unsupportedProps.length > 0) {
      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function(prop) {
        return "`".concat(prop, "`");
      }).join(", "), ". Please remove them."));
    }
    return null;
  }));
}
function formatMuiErrorMessage(code) {
  var url = "https://material-ui.com/production-error/?code=" + code;
  for (var i = 1; i < arguments.length; i += 1) {
    url += "&args[]=" + encodeURIComponent(arguments[i]);
  }
  return "Minified Material-UI error #" + code + "; visit " + url + " for the full message.";
}
var reactIs$2 = { exports: {} };
var reactIs_production_min$1 = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1)
    return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var b = 60103, c = 60106, d = 60107, e = 60108, f = 60114, g = 60109, h = 60110, k = 60112, l = 60113, m = 60120, n = 60115, p = 60116, q = 60121, r = 60122, u = 60117, v = 60129, w = 60131;
  if ("function" === typeof Symbol && Symbol.for) {
    var x = Symbol.for;
    b = x("react.element");
    c = x("react.portal");
    d = x("react.fragment");
    e = x("react.strict_mode");
    f = x("react.profiler");
    g = x("react.provider");
    h = x("react.context");
    k = x("react.forward_ref");
    l = x("react.suspense");
    m = x("react.suspense_list");
    n = x("react.memo");
    p = x("react.lazy");
    q = x("react.block");
    r = x("react.server.block");
    u = x("react.fundamental");
    v = x("react.debug_trace_mode");
    w = x("react.legacy_hidden");
  }
  function y(a) {
    if ("object" === typeof a && null !== a) {
      var t = a.$$typeof;
      switch (t) {
        case b:
          switch (a = a.type, a) {
            case d:
            case f:
            case e:
            case l:
            case m:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case h:
                case k:
                case p:
                case n:
                case g:
                  return a;
                default:
                  return t;
              }
          }
        case c:
          return t;
      }
    }
  }
  var z = g, A = b, B = k, C = d, D = p, E = n, F = c, G = f, H = e, I = l;
  reactIs_production_min$1.ContextConsumer = h;
  reactIs_production_min$1.ContextProvider = z;
  reactIs_production_min$1.Element = A;
  reactIs_production_min$1.ForwardRef = B;
  reactIs_production_min$1.Fragment = C;
  reactIs_production_min$1.Lazy = D;
  reactIs_production_min$1.Memo = E;
  reactIs_production_min$1.Portal = F;
  reactIs_production_min$1.Profiler = G;
  reactIs_production_min$1.StrictMode = H;
  reactIs_production_min$1.Suspense = I;
  reactIs_production_min$1.isAsyncMode = function() {
    return false;
  };
  reactIs_production_min$1.isConcurrentMode = function() {
    return false;
  };
  reactIs_production_min$1.isContextConsumer = function(a) {
    return y(a) === h;
  };
  reactIs_production_min$1.isContextProvider = function(a) {
    return y(a) === g;
  };
  reactIs_production_min$1.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === b;
  };
  reactIs_production_min$1.isForwardRef = function(a) {
    return y(a) === k;
  };
  reactIs_production_min$1.isFragment = function(a) {
    return y(a) === d;
  };
  reactIs_production_min$1.isLazy = function(a) {
    return y(a) === p;
  };
  reactIs_production_min$1.isMemo = function(a) {
    return y(a) === n;
  };
  reactIs_production_min$1.isPortal = function(a) {
    return y(a) === c;
  };
  reactIs_production_min$1.isProfiler = function(a) {
    return y(a) === f;
  };
  reactIs_production_min$1.isStrictMode = function(a) {
    return y(a) === e;
  };
  reactIs_production_min$1.isSuspense = function(a) {
    return y(a) === l;
  };
  reactIs_production_min$1.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === v || a === e || a === l || a === m || a === w || "object" === typeof a && null !== a && (a.$$typeof === p || a.$$typeof === n || a.$$typeof === g || a.$$typeof === h || a.$$typeof === k || a.$$typeof === u || a.$$typeof === q || a[0] === r) ? true : false;
  };
  reactIs_production_min$1.typeOf = y;
  return reactIs_production_min$1;
}
var reactIs_development$1 = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  if (hasRequiredReactIs_development$1)
    return reactIs_development$1;
  hasRequiredReactIs_development$1 = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var REACT_ELEMENT_TYPE = 60103;
      var REACT_PORTAL_TYPE = 60106;
      var REACT_FRAGMENT_TYPE = 60107;
      var REACT_STRICT_MODE_TYPE = 60108;
      var REACT_PROFILER_TYPE = 60114;
      var REACT_PROVIDER_TYPE = 60109;
      var REACT_CONTEXT_TYPE = 60110;
      var REACT_FORWARD_REF_TYPE = 60112;
      var REACT_SUSPENSE_TYPE = 60113;
      var REACT_SUSPENSE_LIST_TYPE = 60120;
      var REACT_MEMO_TYPE = 60115;
      var REACT_LAZY_TYPE = 60116;
      var REACT_BLOCK_TYPE = 60121;
      var REACT_SERVER_BLOCK_TYPE = 60122;
      var REACT_FUNDAMENTAL_TYPE = 60117;
      var REACT_DEBUG_TRACING_MODE_TYPE = 60129;
      var REACT_LEGACY_HIDDEN_TYPE = 60131;
      if (typeof Symbol === "function" && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE = symbolFor("react.element");
        REACT_PORTAL_TYPE = symbolFor("react.portal");
        REACT_FRAGMENT_TYPE = symbolFor("react.fragment");
        REACT_STRICT_MODE_TYPE = symbolFor("react.strict_mode");
        REACT_PROFILER_TYPE = symbolFor("react.profiler");
        REACT_PROVIDER_TYPE = symbolFor("react.provider");
        REACT_CONTEXT_TYPE = symbolFor("react.context");
        REACT_FORWARD_REF_TYPE = symbolFor("react.forward_ref");
        REACT_SUSPENSE_TYPE = symbolFor("react.suspense");
        REACT_SUSPENSE_LIST_TYPE = symbolFor("react.suspense_list");
        REACT_MEMO_TYPE = symbolFor("react.memo");
        REACT_LAZY_TYPE = symbolFor("react.lazy");
        REACT_BLOCK_TYPE = symbolFor("react.block");
        REACT_SERVER_BLOCK_TYPE = symbolFor("react.server.block");
        REACT_FUNDAMENTAL_TYPE = symbolFor("react.fundamental");
        symbolFor("react.scope");
        symbolFor("react.opaque.id");
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor("react.debug_trace_mode");
        symbolFor("react.offscreen");
        REACT_LEGACY_HIDDEN_TYPE = symbolFor("react.legacy_hidden");
      }
      var enableScopeAPI = false;
      function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") {
          return true;
        }
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) {
          return true;
        }
        if (typeof type === "object" && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
            return true;
          }
        }
        return false;
      }
      function typeOf(object) {
        if (typeof object === "object" && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                case REACT_SUSPENSE_LIST_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      var hasWarnedAboutDeprecatedIsConcurrentMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
          }
        }
        return false;
      }
      function isConcurrentMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true;
            console["warn"]("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
          }
        }
        return false;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement2(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development$1.ContextConsumer = ContextConsumer;
      reactIs_development$1.ContextProvider = ContextProvider;
      reactIs_development$1.Element = Element2;
      reactIs_development$1.ForwardRef = ForwardRef;
      reactIs_development$1.Fragment = Fragment2;
      reactIs_development$1.Lazy = Lazy;
      reactIs_development$1.Memo = Memo;
      reactIs_development$1.Portal = Portal;
      reactIs_development$1.Profiler = Profiler;
      reactIs_development$1.StrictMode = StrictMode;
      reactIs_development$1.Suspense = Suspense;
      reactIs_development$1.isAsyncMode = isAsyncMode;
      reactIs_development$1.isConcurrentMode = isConcurrentMode;
      reactIs_development$1.isContextConsumer = isContextConsumer;
      reactIs_development$1.isContextProvider = isContextProvider;
      reactIs_development$1.isElement = isElement2;
      reactIs_development$1.isForwardRef = isForwardRef;
      reactIs_development$1.isFragment = isFragment;
      reactIs_development$1.isLazy = isLazy;
      reactIs_development$1.isMemo = isMemo;
      reactIs_development$1.isPortal = isPortal;
      reactIs_development$1.isProfiler = isProfiler;
      reactIs_development$1.isStrictMode = isStrictMode;
      reactIs_development$1.isSuspense = isSuspense;
      reactIs_development$1.isValidElementType = isValidElementType;
      reactIs_development$1.typeOf = typeOf;
    })();
  }
  return reactIs_development$1;
}
(function(module) {
  if (process.env.NODE_ENV === "production") {
    module.exports = requireReactIs_production_min$1();
  } else {
    module.exports = requireReactIs_development$1();
  }
})(reactIs$2);
var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn2) {
  var match = "".concat(fn2).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || "";
}
function getFunctionComponentName(Component2) {
  var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return Component2.displayName || Component2.name || getFunctionName(Component2) || fallback;
}
function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== "" ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
}
function getDisplayName(Component2) {
  if (Component2 == null) {
    return void 0;
  }
  if (typeof Component2 === "string") {
    return Component2;
  }
  if (typeof Component2 === "function") {
    return getFunctionComponentName(Component2, "Component");
  }
  if (_typeof$1(Component2) === "object") {
    switch (Component2.$$typeof) {
      case reactIs$2.exports.ForwardRef:
        return getWrappedName(Component2, Component2.render, "ForwardRef");
      case reactIs$2.exports.Memo:
        return getWrappedName(Component2, Component2.type, "memo");
      default:
        return void 0;
    }
  }
  return void 0;
}
function capitalize(string) {
  if (typeof string !== "string") {
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: capitalize(string) expects a string argument." : formatMuiErrorMessage(7));
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }
  return funcs.reduce(function(acc, func) {
    if (func == null) {
      return acc;
    }
    if (process.env.NODE_ENV !== "production") {
      if (typeof func !== "function") {
        console.error("Material-UI: Invalid Argument Type, must only provide functions, undefined, or null.");
      }
    }
    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function() {
  });
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function toVal(mix) {
  var k, y, str = "";
  if (typeof mix === "string" || typeof mix === "number") {
    str += mix;
  } else if (typeof mix === "object") {
    if (Array.isArray(mix)) {
      for (k = 0; k < mix.length; k++) {
        if (mix[k]) {
          if (y = toVal(mix[k])) {
            str && (str += " ");
            str += y;
          }
        }
      }
    } else {
      for (k in mix) {
        if (mix[k]) {
          str && (str += " ");
          str += k;
        }
      }
    }
  }
  return str;
}
function clsx() {
  var i = 0, tmp, x, str = "";
  while (i < arguments.length) {
    if (tmp = arguments[i++]) {
      if (x = toVal(tmp)) {
        str && (str += " ");
        str += x;
      }
    }
  }
  return str;
}
var hasSymbol = typeof Symbol === "function" && Symbol.for;
const nested = hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";
var pseudoClasses = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"];
function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal, disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba, _options$productionPr = options.productionPrefix, productionPrefix = _options$productionPr === void 0 ? "jss" : _options$productionPr, _options$seed = options.seed, seed = _options$seed === void 0 ? "" : _options$seed;
  var seedPrefix = seed === "" ? "" : "".concat(seed, "-");
  var ruleCounter = 0;
  var getNextCounterId = function getNextCounterId2() {
    ruleCounter += 1;
    if (process.env.NODE_ENV !== "production") {
      if (ruleCounter >= 1e10) {
        console.warn(["Material-UI: You might have a memory leak.", "The ruleCounter is not supposed to grow that much."].join(""));
      }
    }
    return ruleCounter;
  };
  return function(rule, styleSheet) {
    var name = styleSheet.options.name;
    if (name && name.indexOf("Mui") === 0 && !styleSheet.options.link && !disableGlobal) {
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return "Mui-".concat(rule.key);
      }
      var prefix2 = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
      if (!styleSheet.options.theme[nested] || seed !== "") {
        return prefix2;
      }
      return "".concat(prefix2, "-").concat(getNextCounterId());
    }
    if (process.env.NODE_ENV === "production") {
      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    }
    var suffix = "".concat(rule.key, "-").concat(getNextCounterId());
    if (styleSheet.options.classNamePrefix) {
      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
    }
    return "".concat(seedPrefix).concat(suffix);
  };
}
function getThemeProps(params) {
  var theme2 = params.theme, name = params.name, props = params.props;
  if (!theme2 || !theme2.props || !theme2.props[name]) {
    return props;
  }
  var defaultProps = theme2.props[name];
  var propName;
  for (propName in defaultProps) {
    if (props[propName] === void 0) {
      props[propName] = defaultProps[propName];
    }
  }
  return props;
}
var isProduction = process.env.NODE_ENV === "production";
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }
    var text = "Warning: " + message;
    if (typeof console !== "undefined") {
      console.warn(text);
    }
    try {
      throw Error(text);
    } catch (x) {
    }
  }
}
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === "object" && document.nodeType === 9;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== "object")
    return style;
  if (Array.isArray(style))
    return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor)
    return style;
  var newStyle = {};
  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }
  return newStyle;
}
function createRule(name, decl, options) {
  if (name === void 0) {
    name = "unnamed";
  }
  var jss2 = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss2.plugins.onCreateRule(name, declCopy, options);
  if (rule)
    return rule;
  if (name[0] === "@") {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Unknown rule " + name) : void 0;
  }
  return null;
}
var join = function join2(value, by) {
  var result = "";
  for (var i = 0; i < value.length; i++) {
    if (value[i] === "!important")
      break;
    if (result)
      result += by;
    result += value[i];
  }
  return result;
};
var toCssValue = function toCssValue2(value, ignoreImportant) {
  if (ignoreImportant === void 0) {
    ignoreImportant = false;
  }
  if (!Array.isArray(value))
    return value;
  var cssValue = "";
  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === "!important")
        break;
      if (cssValue)
        cssValue += ", ";
      cssValue += join(value[i], " ");
    }
  } else
    cssValue = join(value, ", ");
  if (!ignoreImportant && value[value.length - 1] === "!important") {
    cssValue += " !important";
  }
  return cssValue;
};
function getWhitespaceSymbols(options) {
  if (options && options.format === false) {
    return {
      linebreak: "",
      space: ""
    };
  }
  return {
    linebreak: "\n",
    space: " "
  };
}
function indentStr(str, indent) {
  var result = "";
  for (var index = 0; index < indent; index++) {
    result += "  ";
  }
  return result + str;
}
function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }
  var result = "";
  if (!style)
    return result;
  var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;
  if (options.format === false) {
    indent = -Infinity;
  }
  var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
  if (selector)
    indent++;
  if (fallbacks) {
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];
        for (var prop in fallback) {
          var value = fallback[prop];
          if (value != null) {
            if (result)
              result += linebreak;
            result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];
        if (_value != null) {
          if (result)
            result += linebreak;
          result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
        }
      }
    }
  }
  for (var _prop2 in style) {
    var _value2 = style[_prop2];
    if (_value2 != null && _prop2 !== "fallbacks") {
      if (result)
        result += linebreak;
      result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
    }
  }
  if (!result && !options.allowEmpty)
    return result;
  if (!selector)
    return result;
  indent--;
  if (result)
    result = "" + linebreak + result + linebreak;
  return indentStr("" + selector + space + "{" + result, indent) + indentStr("}", indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== "undefined" && CSS.escape;
var escape = function(str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, "\\$1");
};
var BaseStyleRule = /* @__PURE__ */ function() {
  function BaseStyleRule2(key, style, options) {
    this.type = "style";
    this.isProcessed = false;
    var sheet = options.sheet, Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet)
      this.renderer = sheet.renderer;
    else if (Renderer)
      this.renderer = new Renderer();
  }
  var _proto = BaseStyleRule2.prototype;
  _proto.prop = function prop(name, value, options) {
    if (value === void 0)
      return this.style[name];
    var force = options ? options.force : false;
    if (!force && this.style[name] === value)
      return this;
    var newValue = value;
    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }
    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style;
    if (isEmpty && !isDefined && !force)
      return this;
    var remove = isEmpty && isDefined;
    if (remove)
      delete this.style[name];
    else
      this.style[name] = newValue;
    if (this.renderable && this.renderer) {
      if (remove)
        this.renderer.removeProperty(this.renderable, name);
      else
        this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }
    var sheet = this.options.sheet;
    if (sheet && sheet.attached) {
      process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
    }
    return this;
  };
  return BaseStyleRule2;
}();
var StyleRule = /* @__PURE__ */ function(_BaseStyleRule) {
  _inheritsLoose(StyleRule2, _BaseStyleRule);
  function StyleRule2(key, style, options) {
    var _this;
    _this = _BaseStyleRule.call(this, key, style, options) || this;
    var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId(_assertThisInitialized$1(_assertThisInitialized$1(_this)), sheet);
      _this.selectorText = "." + escape(_this.id);
    }
    return _this;
  }
  var _proto2 = StyleRule2.prototype;
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;
    if (renderer) {
      var json = this.toJSON();
      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }
    return this;
  };
  _proto2.toJSON = function toJSON() {
    var json = {};
    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== "object")
        json[prop] = value;
      else if (Array.isArray(value))
        json[prop] = toCssValue(value);
    }
    return json;
  };
  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };
  _createClass(StyleRule2, [{
    key: "selector",
    set: function set2(selector) {
      if (selector === this.selectorText)
        return;
      this.selectorText = selector;
      var renderer = this.renderer, renderable = this.renderable;
      if (!renderable || !renderer)
        return;
      var hasChanged = renderer.setSelector(renderable, selector);
      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    },
    get: function get2() {
      return this.selectorText;
    }
  }]);
  return StyleRule2;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (key[0] === "@" || options.parent && options.parent.type === "keyframes") {
      return null;
    }
    return new StyleRule(key, style, options);
  }
};
var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
var ConditionalRule = /* @__PURE__ */ function() {
  function ConditionalRule2(key, styles3, options) {
    this.type = "conditional";
    this.isProcessed = false;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : "unknown";
    this.query = options.name || "@" + this.at;
    this.options = options;
    this.rules = new RuleList(_extends({}, options, {
      parent: this
    }));
    for (var name in styles3) {
      this.rules.add(name, styles3[name]);
    }
    this.rules.process();
  }
  var _proto = ConditionalRule2.prototype;
  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  };
  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  };
  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule)
      return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  };
  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule)
      this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  };
  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
    if (options.indent == null)
      options.indent = defaultToStringOptions.indent;
    if (options.children == null)
      options.children = defaultToStringOptions.children;
    if (options.children === false) {
      return this.query + " {}";
    }
    var children = this.rules.toString(options);
    return children ? this.query + " {" + linebreak + children + linebreak + "}" : "";
  };
  return ConditionalRule2;
}();
var keyRegExp = /@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule2(key, styles3, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles3, options) : null;
  }
};
var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
var KeyframesRule = /* @__PURE__ */ function() {
  function KeyframesRule2(key, frames, options) {
    this.type = "keyframes";
    this.at = "@keyframes";
    this.isProcessed = false;
    var nameMatch = key.match(nameRegExp);
    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = "noname";
      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Bad keyframes name " + key) : void 0;
    }
    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
    this.rules = new RuleList(_extends({}, options, {
      parent: this
    }));
    for (var name in frames) {
      this.rules.add(name, frames[name], _extends({}, options, {
        parent: this
      }));
    }
    this.rules.process();
  }
  var _proto = KeyframesRule2.prototype;
  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
    if (options.indent == null)
      options.indent = defaultToStringOptions$1.indent;
    if (options.children == null)
      options.children = defaultToStringOptions$1.children;
    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }
    var children = this.rules.toString(options);
    if (children)
      children = "" + linebreak + children + linebreak;
    return this.at + " " + this.id + " {" + children + "}";
  };
  return KeyframesRule2;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp$1 = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe2(val, keyframes) {
  if (typeof val === "string") {
    return val.replace(refRegExp$1, function(match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }
      process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Referenced keyframes rule "' + name + '" is not defined.') : void 0;
      return match;
    });
  }
  return val;
};
var replaceRef = function replaceRef2(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);
  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};
var pluginKeyframesRule = {
  onCreateRule: function onCreateRule3(key, frames, options) {
    return typeof key === "string" && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== "style" || !sheet)
      return style;
    if ("animation-name" in style)
      replaceRef(style, "animation-name", sheet.keyframes);
    if ("animation" in style)
      replaceRef(style, "animation", sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;
    if (!sheet) {
      return val;
    }
    switch (prop) {
      case "animation":
        return findReferencedKeyframe(val, sheet.keyframes);
      case "animation-name":
        return findReferencedKeyframe(val, sheet.keyframes);
      default:
        return val;
    }
  }
};
var KeyframeRule = /* @__PURE__ */ function(_BaseStyleRule) {
  _inheritsLoose(KeyframeRule2, _BaseStyleRule);
  function KeyframeRule2() {
    return _BaseStyleRule.apply(this, arguments) || this;
  }
  var _proto = KeyframeRule2.prototype;
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };
  return KeyframeRule2;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule4(key, style, options) {
    if (options.parent && options.parent.type === "keyframes") {
      return new KeyframeRule(key, style, options);
    }
    return null;
  }
};
var FontFaceRule = /* @__PURE__ */ function() {
  function FontFaceRule2(key, style, options) {
    this.type = "font-face";
    this.at = "@font-face";
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  var _proto = FontFaceRule2.prototype;
  _proto.toString = function toString(options) {
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
    if (Array.isArray(this.style)) {
      var str = "";
      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.at, this.style[index]);
        if (this.style[index + 1])
          str += linebreak;
      }
      return str;
    }
    return toCss(this.at, this.style, options);
  };
  return FontFaceRule2;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule5(key, style, options) {
    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
  }
};
var ViewportRule = /* @__PURE__ */ function() {
  function ViewportRule2(key, style, options) {
    this.type = "viewport";
    this.at = "@viewport";
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  var _proto = ViewportRule2.prototype;
  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };
  return ViewportRule2;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule6(key, style, options) {
    return key === "@viewport" || key === "@-ms-viewport" ? new ViewportRule(key, style, options) : null;
  }
};
var SimpleRule = /* @__PURE__ */ function() {
  function SimpleRule2(key, value, options) {
    this.type = "simple";
    this.isProcessed = false;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  var _proto = SimpleRule2.prototype;
  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = "";
      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1])
          str += "\n";
      }
      return str;
    }
    return this.key + " " + this.value + ";";
  };
  return SimpleRule2;
}();
var keysMap = {
  "@charset": true,
  "@import": true,
  "@namespace": true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule7(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};
var plugins$1 = [pluginStyleRule, pluginConditionalRule, pluginKeyframesRule, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];
var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
};
var RuleList = /* @__PURE__ */ function() {
  function RuleList2(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.counter = 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  var _proto = RuleList2.prototype;
  _proto.add = function add(name, decl, ruleOptions) {
    var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss2 = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
    var options = _extends({
      classes: this.classes,
      parent,
      sheet,
      jss: jss2,
      Renderer,
      generateId,
      scoped,
      name,
      keyframes: this.keyframes,
      selector: void 0
    }, ruleOptions);
    var key = name;
    if (name in this.raw) {
      key = name + "-d" + this.counter++;
    }
    this.raw[key] = decl;
    if (key in this.classes) {
      options.selector = "." + escape(this.classes[key]);
    }
    var rule = createRule(key, decl, options);
    if (!rule)
      return null;
    this.register(rule);
    var index = options.index === void 0 ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  };
  _proto.replace = function replace(name, decl, ruleOptions) {
    var oldRule = this.get(name);
    var oldIndex = this.index.indexOf(oldRule);
    if (oldRule) {
      this.remove(oldRule);
    }
    var options = ruleOptions;
    if (oldIndex !== -1)
      options = _extends({}, ruleOptions, {
        index: oldIndex
      });
    return this.add(name, decl, options);
  };
  _proto.get = function get2(nameOrSelector) {
    return this.map[nameOrSelector];
  };
  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.index.indexOf(rule), 1);
  };
  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  };
  _proto.process = function process2() {
    var plugins2 = this.options.jss.plugins;
    this.index.slice(0).forEach(plugins2.onProcessRule, plugins2);
  };
  _proto.register = function register(rule) {
    this.map[rule.key] = rule;
    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id)
        this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  };
  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];
    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  };
  _proto.update = function update2() {
    var name;
    var data;
    var options;
    if (typeof (arguments.length <= 0 ? void 0 : arguments[0]) === "string") {
      name = arguments.length <= 0 ? void 0 : arguments[0];
      data = arguments.length <= 1 ? void 0 : arguments[1];
      options = arguments.length <= 2 ? void 0 : arguments[2];
    } else {
      data = arguments.length <= 0 ? void 0 : arguments[0];
      options = arguments.length <= 1 ? void 0 : arguments[1];
      name = null;
    }
    if (name) {
      this.updateOne(this.get(name), data, options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.updateOne(this.index[index], data, options);
      }
    }
  };
  _proto.updateOne = function updateOne(rule, data, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }
    var _this$options2 = this.options, plugins2 = _this$options2.jss.plugins, sheet = _this$options2.sheet;
    if (rule.rules instanceof RuleList2) {
      rule.rules.update(data, options);
      return;
    }
    var style = rule.style;
    plugins2.onUpdate(data, rule, sheet, options);
    if (options.process && style && style !== rule.style) {
      plugins2.onProcessStyle(rule.style, rule, sheet);
      for (var prop in rule.style) {
        var nextValue = rule.style[prop];
        var prevValue = style[prop];
        if (nextValue !== prevValue) {
          rule.prop(prop, nextValue, forceUpdateOptions);
        }
      }
      for (var _prop in style) {
        var _nextValue = rule.style[_prop];
        var _prevValue = style[_prop];
        if (_nextValue == null && _nextValue !== _prevValue) {
          rule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  };
  _proto.toString = function toString(options) {
    var str = "";
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css2 = rule.toString(options);
      if (!css2 && !link)
        continue;
      if (str)
        str += linebreak;
      str += css2;
    }
    return str;
  };
  return RuleList2;
}();
var StyleSheet = /* @__PURE__ */ function() {
  function StyleSheet2(styles3, options) {
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = _extends({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });
    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }
    this.rules = new RuleList(this.options);
    for (var name in styles3) {
      this.rules.add(name, styles3[name]);
    }
    this.rules.process();
  }
  var _proto = StyleSheet2.prototype;
  _proto.attach = function attach2() {
    if (this.attached)
      return this;
    if (this.renderer)
      this.renderer.attach();
    this.attached = true;
    if (!this.deployed)
      this.deploy();
    return this;
  };
  _proto.detach = function detach2() {
    if (!this.attached)
      return this;
    if (this.renderer)
      this.renderer.detach();
    this.attached = false;
    return this;
  };
  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue;
    if (this.attached && !queue)
      this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule)
      return null;
    this.options.jss.plugins.onProcessRule(rule);
    if (this.attached) {
      if (!this.deployed)
        return rule;
      if (queue)
        queue.push(rule);
      else {
        this.insertRule(rule);
        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = void 0;
        }
      }
      return rule;
    }
    this.deployed = false;
    return rule;
  };
  _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
    var oldRule = this.rules.get(nameOrSelector);
    if (!oldRule)
      return this.addRule(nameOrSelector, decl, options);
    var newRule = this.rules.replace(nameOrSelector, decl, options);
    if (newRule) {
      this.options.jss.plugins.onProcessRule(newRule);
    }
    if (this.attached) {
      if (!this.deployed)
        return newRule;
      if (this.renderer) {
        if (!newRule) {
          this.renderer.deleteRule(oldRule);
        } else if (oldRule.renderable) {
          this.renderer.replaceRule(oldRule.renderable, newRule);
        }
      }
      return newRule;
    }
    this.deployed = false;
    return newRule;
  };
  _proto.insertRule = function insertRule2(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  };
  _proto.addRules = function addRules(styles3, options) {
    var added = [];
    for (var name in styles3) {
      var rule = this.addRule(name, styles3[name], options);
      if (rule)
        added.push(rule);
    }
    return added;
  };
  _proto.getRule = function getRule(nameOrSelector) {
    return this.rules.get(nameOrSelector);
  };
  _proto.deleteRule = function deleteRule(name) {
    var rule = typeof name === "object" ? name : this.rules.get(name);
    if (!rule || this.attached && !rule.renderable) {
      return false;
    }
    this.rules.remove(rule);
    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }
    return true;
  };
  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  };
  _proto.deploy = function deploy() {
    if (this.renderer)
      this.renderer.deploy();
    this.deployed = true;
    return this;
  };
  _proto.update = function update2() {
    var _this$rules;
    (_this$rules = this.rules).update.apply(_this$rules, arguments);
    return this;
  };
  _proto.updateOne = function updateOne(rule, data, options) {
    this.rules.updateOne(rule, data, options);
    return this;
  };
  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };
  return StyleSheet2;
}();
var PluginsRegistry = /* @__PURE__ */ function() {
  function PluginsRegistry2() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = {};
  }
  var _proto = PluginsRegistry2.prototype;
  _proto.onCreateRule = function onCreateRule8(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule)
        return rule;
    }
    return null;
  };
  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed)
      return;
    var sheet = rule.options.sheet;
    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }
    if (rule.style)
      this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  };
  _proto.onProcessStyle = function onProcessStyle2(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  };
  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  };
  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  };
  _proto.onChangeValue = function onChangeValue2(value, prop, rule) {
    var processedValue = value;
    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }
    return processedValue;
  };
  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: "external"
      };
    }
    var plugins2 = this.plugins[options.queue];
    if (plugins2.indexOf(newPlugin) !== -1) {
      return;
    }
    plugins2.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        } else {
          process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Unknown hook "' + name + '".') : void 0;
        }
      }
      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };
  return PluginsRegistry2;
}();
var SheetsRegistry = /* @__PURE__ */ function() {
  function SheetsRegistry2() {
    this.registry = [];
  }
  var _proto = SheetsRegistry2.prototype;
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1)
      return;
    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    }
    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  };
  _proto.reset = function reset() {
    this.registry = [];
  };
  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  };
  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = _objectWithoutPropertiesLoose(_ref, ["attached"]);
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
    var css2 = "";
    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];
      if (attached != null && sheet.attached !== attached) {
        continue;
      }
      if (css2)
        css2 += linebreak;
      css2 += sheet.toString(options);
    }
    return css2;
  };
  _createClass(SheetsRegistry2, [{
    key: "index",
    get: function get2() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);
  return SheetsRegistry2;
}();
var sheets = new SheetsRegistry();
var globalThis$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" && window.Math === Math ? window : typeof self !== "undefined" && self.Math === Math ? self : Function("return this")();
var ns = "2f1acc6c3a606b082e5eef5e54414ffb";
if (globalThis$1[ns] == null)
  globalThis$1[ns] = 0;
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
var createGenerateId = function createGenerateId2(options) {
  if (options === void 0) {
    options = {};
  }
  var ruleCounter = 0;
  var generateId = function generateId2(rule, sheet) {
    ruleCounter += 1;
    if (ruleCounter > maxRules) {
      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
    }
    var jssId = "";
    var prefix2 = "";
    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix2 = sheet.options.classNamePrefix;
      }
      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }
    if (options.minify) {
      return "" + (prefix2 || "c") + moduleId + jssId + ruleCounter;
    }
    return prefix2 + rule.key + "-" + moduleId + (jssId ? "-" + jssId : "") + "-" + ruleCounter;
  };
  return generateId;
};
var memoize = function memoize2(fn2) {
  var value;
  return function() {
    if (!value)
      value = fn2();
    return value;
  };
};
var getPropertyValue = function getPropertyValue2(cssRule, prop) {
  try {
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }
    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    return "";
  }
};
var setProperty = function setProperty2(cssRule, prop, value) {
  try {
    var cssValue = value;
    if (Array.isArray(value)) {
      cssValue = toCssValue(value, true);
      if (value[value.length - 1] === "!important") {
        cssRule.style.setProperty(prop, cssValue, "important");
        return true;
      }
    }
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      cssRule.style.setProperty(prop, cssValue);
    }
  } catch (err) {
    return false;
  }
  return true;
};
var removeProperty = function removeProperty2(cssRule, prop) {
  try {
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
    process.env.NODE_ENV !== "production" ? warning(false, '[JSS] DOMException "' + err.message + '" was thrown. Tried to remove property "' + prop + '".') : void 0;
  }
};
var setSelector = function setSelector2(cssRule, selectorText) {
  cssRule.selectorText = selectorText;
  return cssRule.selectorText === selectorText;
};
var getHead = memoize(function() {
  return document.querySelector("head");
});
function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}
function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}
function findCommentNode(text) {
  var head = getHead();
  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];
    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }
  return null;
}
function findPrevNode(options) {
  var registry = sheets.registry;
  if (registry.length > 0) {
    var sheet = findHigherSheet(registry, options);
    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    }
    sheet = findHighestSheet(registry, options);
    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  }
  var insertionPoint = options.insertionPoint;
  if (insertionPoint && typeof insertionPoint === "string") {
    var comment = findCommentNode(insertionPoint);
    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    }
    process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Insertion point "' + insertionPoint + '" not found.') : void 0;
  }
  return false;
}
function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);
  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  }
  if (insertionPoint && typeof insertionPoint.nodeType === "number") {
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode)
      parentNode.insertBefore(style, insertionPointElement.nextSibling);
    else
      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Insertion point is not in the DOM.") : void 0;
    return;
  }
  getHead().appendChild(style);
}
var getNonce = memoize(function() {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute("content") : null;
});
var _insertRule = function insertRule(container, rule, index) {
  try {
    if ("insertRule" in container) {
      container.insertRule(rule, index);
    } else if ("appendRule" in container) {
      container.appendRule(rule);
    }
  } catch (err) {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] " + err.message) : void 0;
    return false;
  }
  return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex2(container, index) {
  var maxIndex = container.cssRules.length;
  if (index === void 0 || index > maxIndex) {
    return maxIndex;
  }
  return index;
};
var createStyle = function createStyle2() {
  var el2 = document.createElement("style");
  el2.textContent = "\n";
  return el2;
};
var DomRenderer = /* @__PURE__ */ function() {
  function DomRenderer2(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.hasInsertedRules = false;
    this.cssRules = [];
    if (sheet)
      sheets.add(sheet);
    this.sheet = sheet;
    var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
    this.element = element || createStyle();
    this.element.setAttribute("data-jss", "");
    if (media)
      this.element.setAttribute("media", media);
    if (meta)
      this.element.setAttribute("data-meta", meta);
    var nonce = getNonce();
    if (nonce)
      this.element.setAttribute("nonce", nonce);
  }
  var _proto = DomRenderer2.prototype;
  _proto.attach = function attach2() {
    if (this.element.parentNode || !this.sheet)
      return;
    insertStyle(this.element, this.sheet.options);
    var deployed = Boolean(this.sheet && this.sheet.deployed);
    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  };
  _proto.detach = function detach2() {
    if (!this.sheet)
      return;
    var parentNode = this.element.parentNode;
    if (parentNode)
      parentNode.removeChild(this.element);
    if (this.sheet.options.link) {
      this.cssRules = [];
      this.element.textContent = "\n";
    }
  };
  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet)
      return;
    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }
    this.element.textContent = "\n" + sheet.toString() + "\n";
  };
  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  };
  _proto.insertRule = function insertRule2(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }
    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;
      if (rule.type === "conditional" || rule.type === "keyframes") {
        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), _insertionIndex);
        if (latestNativeParent === false) {
          return false;
        }
        this.refCssRule(rule, _insertionIndex, latestNativeParent);
      }
      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    }
    var ruleStr = rule.toString();
    if (!ruleStr)
      return false;
    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
    if (nativeRule === false) {
      return false;
    }
    this.hasInsertedRules = true;
    this.refCssRule(rule, insertionIndex, nativeRule);
    return nativeRule;
  };
  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
    rule.renderable = cssRule;
    if (rule.options.parent instanceof StyleSheet) {
      this.cssRules.splice(index, 0, cssRule);
    }
  };
  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1)
      return false;
    sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return true;
  };
  _proto.indexOf = function indexOf(cssRule) {
    return this.cssRules.indexOf(cssRule);
  };
  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1)
      return false;
    this.element.sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return this.insertRule(rule, index);
  };
  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };
  return DomRenderer2;
}();
var instanceCounter = 0;
var Jss = /* @__PURE__ */ function() {
  function Jss2(options) {
    this.id = instanceCounter++;
    this.version = "10.9.0";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId,
      Renderer: isBrowser ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });
    for (var i = 0; i < plugins$1.length; i++) {
      this.plugins.use(plugins$1[i], {
        queue: "internal"
      });
    }
    this.setup(options);
  }
  var _proto = Jss2.prototype;
  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }
    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }
    if (options.id) {
      this.options.id = _extends({}, this.options.id, options.id);
    }
    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }
    if (options.insertionPoint != null)
      this.options.insertionPoint = options.insertionPoint;
    if ("Renderer" in options) {
      this.options.Renderer = options.Renderer;
    }
    if (options.plugins)
      this.use.apply(this, options.plugins);
    return this;
  };
  _proto.createStyleSheet = function createStyleSheet(styles3, options) {
    if (options === void 0) {
      options = {};
    }
    var _options = options, index = _options.index;
    if (typeof index !== "number") {
      index = sheets.index === 0 ? 0 : sheets.index + 1;
    }
    var sheet = new StyleSheet(styles3, _extends({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  };
  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    sheets.remove(sheet);
    return this;
  };
  _proto.createRule = function createRule$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }
    if (options === void 0) {
      options = {};
    }
    if (typeof name === "object") {
      return this.createRule(void 0, name, style);
    }
    var ruleOptions = _extends({}, options, {
      name,
      jss: this,
      Renderer: this.options.Renderer
    });
    if (!ruleOptions.generateId)
      ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes)
      ruleOptions.classes = {};
    if (!ruleOptions.keyframes)
      ruleOptions.keyframes = {};
    var rule = createRule(name, style, ruleOptions);
    if (rule)
      this.plugins.onProcessRule(rule);
    return rule;
  };
  _proto.use = function use() {
    var _this = this;
    for (var _len = arguments.length, plugins2 = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins2[_key] = arguments[_key];
    }
    plugins2.forEach(function(plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };
  return Jss2;
}();
var createJss = function createJss2(options) {
  return new Jss(options);
};
var hasCSSTOMSupport = typeof CSS === "object" && CSS != null && "number" in CSS;
function getDynamicStyles(styles3) {
  var to = null;
  for (var key in styles3) {
    var value = styles3[key];
    var type = typeof value;
    if (type === "function") {
      if (!to)
        to = {};
      to[key] = value;
    } else if (type === "object" && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);
      if (extracted) {
        if (!to)
          to = {};
        to[key] = extracted;
      }
    }
  }
  return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
createJss();
var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;
var functionPlugin = function functionPlugin2() {
  return {
    onCreateRule: function onCreateRule8(name, decl, options) {
      if (typeof decl !== "function")
        return null;
      var rule = createRule(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle2(style, rule) {
      if (fnValuesNs in rule || fnRuleNs in rule)
        return style;
      var fnValues = {};
      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== "function")
          continue;
        delete style[prop];
        fnValues[prop] = value;
      }
      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule;
      var fnRule = styleRule[fnRuleNs];
      if (fnRule) {
        styleRule.style = fnRule(data) || {};
        if (process.env.NODE_ENV === "development") {
          for (var prop in styleRule.style) {
            if (typeof styleRule.style[prop] === "function") {
              process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Function values inside function rules are not supported.") : void 0;
              break;
            }
          }
        }
      }
      var fnValues = styleRule[fnValuesNs];
      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
};
const functions = functionPlugin;
var at = "@global";
var atPrefix = "@global ";
var GlobalContainerRule = /* @__PURE__ */ function() {
  function GlobalContainerRule2(key, styles3, options) {
    this.type = "global";
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new RuleList(_extends({}, options, {
      parent: this
    }));
    for (var selector in styles3) {
      this.rules.add(selector, styles3[selector]);
    }
    this.rules.process();
  }
  var _proto = GlobalContainerRule2.prototype;
  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  };
  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (rule)
      this.options.jss.plugins.onProcessRule(rule);
    return rule;
  };
  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule)
      this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  };
  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  };
  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };
  return GlobalContainerRule2;
}();
var GlobalPrefixedRule = /* @__PURE__ */ function() {
  function GlobalPrefixedRule2(key, style, options) {
    this.type = "global";
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
      parent: this
    }));
  }
  var _proto2 = GlobalPrefixedRule2.prototype;
  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : "";
  };
  return GlobalPrefixedRule2;
}();
var separatorRegExp$1 = /\s*,\s*/g;
function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp$1);
  var scoped = "";
  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1])
      scoped += ", ";
  }
  return scoped;
}
function handleNestedGlobalContainerRule(rule, sheet) {
  var options = rule.options, style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules)
    return;
  for (var name in rules) {
    sheet.addRule(name, rules[name], _extends({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }
  delete style[at];
}
function handlePrefixedGlobalRule(rule, sheet) {
  var options = rule.options, style = rule.style;
  for (var prop in style) {
    if (prop[0] !== "@" || prop.substr(0, at.length) !== at)
      continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    sheet.addRule(selector, style[prop], _extends({}, options, {
      selector
    }));
    delete style[prop];
  }
}
function jssGlobal() {
  function onCreateRule8(name, styles3, options) {
    if (!name)
      return null;
    if (name === at) {
      return new GlobalContainerRule(name, styles3, options);
    }
    if (name[0] === "@" && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles3, options);
    }
    var parent = options.parent;
    if (parent) {
      if (parent.type === "global" || parent.options.parent && parent.options.parent.type === "global") {
        options.scoped = false;
      }
    }
    if (!options.selector && options.scoped === false) {
      options.selector = name;
    }
    return null;
  }
  function onProcessRule(rule, sheet) {
    if (rule.type !== "style" || !sheet)
      return;
    handleNestedGlobalContainerRule(rule, sheet);
    handlePrefixedGlobalRule(rule, sheet);
  }
  return {
    onCreateRule: onCreateRule8,
    onProcessRule
  };
}
var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;
function jssNested() {
  function getReplaceRef(container, sheet) {
    return function(match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);
      if (rule) {
        return rule.selector;
      }
      process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Could not find the referenced rule "' + key + '" in "' + (container.options.meta || container.toString()) + '".') : void 0;
      return key;
    };
  }
  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);
    var result = "";
    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];
      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested2 = nestedSelectors[j];
        if (result)
          result += ", ";
        result += nested2.indexOf("&") !== -1 ? nested2.replace(parentRegExp, parent) : parent + " " + nested2;
      }
    }
    return result;
  }
  function getOptions(rule, container, prevOptions) {
    if (prevOptions)
      return _extends({}, prevOptions, {
        index: prevOptions.index + 1
      });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === void 0 ? 1 : nestingLevel + 1;
    var options = _extends({}, rule.options, {
      nestingLevel,
      index: container.indexOf(rule) + 1
    });
    delete options.name;
    return options;
  }
  function onProcessStyle2(style, rule, sheet) {
    if (rule.type !== "style")
      return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef3;
    for (var prop in style) {
      var isNested = prop.indexOf("&") !== -1;
      var isNestedConditional = prop[0] === "@";
      if (!isNested && !isNestedConditional)
        continue;
      options = getOptions(styleRule, container, options);
      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector);
        if (!replaceRef3)
          replaceRef3 = getReplaceRef(container, sheet);
        selector = selector.replace(refRegExp, replaceRef3);
        var name = styleRule.key + "-" + prop;
        if ("replaceRule" in container) {
          container.replaceRule(name, style[prop], _extends({}, options, {
            selector
          }));
        } else {
          container.addRule(name, style[prop], _extends({}, options, {
            selector
          }));
        }
      } else if (isNestedConditional) {
        container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }
      delete style[prop];
    }
    return style;
  }
  return {
    onProcessStyle: onProcessStyle2
  };
}
var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache$2 = {};
function toHyphenLower(match) {
  return "-" + match.toLowerCase();
}
function hyphenateStyleName(name) {
  if (cache$2.hasOwnProperty(name)) {
    return cache$2[name];
  }
  var hName = name.replace(uppercasePattern, toHyphenLower);
  return cache$2[name] = msPattern.test(hName) ? "-" + hName : hName;
}
function convertCase(style) {
  var converted = {};
  for (var prop in style) {
    var key = prop.indexOf("--") === 0 ? prop : hyphenateStyleName(prop);
    converted[key] = style[prop];
  }
  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks))
      converted.fallbacks = style.fallbacks.map(convertCase);
    else
      converted.fallbacks = convertCase(style.fallbacks);
  }
  return converted;
}
function camelCase() {
  function onProcessStyle2(style) {
    if (Array.isArray(style)) {
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }
      return style;
    }
    return convertCase(style);
  }
  function onChangeValue2(value, prop, rule) {
    if (prop.indexOf("--") === 0) {
      return value;
    }
    var hyphenatedProp = hyphenateStyleName(prop);
    if (prop === hyphenatedProp)
      return value;
    rule.prop(hyphenatedProp, value);
    return null;
  }
  return {
    onProcessStyle: onProcessStyle2,
    onChangeValue: onChangeValue2
  };
}
var px = hasCSSTOMSupport && CSS ? CSS.px : "px";
var ms = hasCSSTOMSupport && CSS ? CSS.ms : "ms";
var percent = hasCSSTOMSupport && CSS ? CSS.percent : "%";
var defaultUnits = {
  "animation-delay": ms,
  "animation-duration": ms,
  "background-position": px,
  "background-position-x": px,
  "background-position-y": px,
  "background-size": px,
  border: px,
  "border-bottom": px,
  "border-bottom-left-radius": px,
  "border-bottom-right-radius": px,
  "border-bottom-width": px,
  "border-left": px,
  "border-left-width": px,
  "border-radius": px,
  "border-right": px,
  "border-right-width": px,
  "border-top": px,
  "border-top-left-radius": px,
  "border-top-right-radius": px,
  "border-top-width": px,
  "border-width": px,
  "border-block": px,
  "border-block-end": px,
  "border-block-end-width": px,
  "border-block-start": px,
  "border-block-start-width": px,
  "border-block-width": px,
  "border-inline": px,
  "border-inline-end": px,
  "border-inline-end-width": px,
  "border-inline-start": px,
  "border-inline-start-width": px,
  "border-inline-width": px,
  "border-start-start-radius": px,
  "border-start-end-radius": px,
  "border-end-start-radius": px,
  "border-end-end-radius": px,
  margin: px,
  "margin-bottom": px,
  "margin-left": px,
  "margin-right": px,
  "margin-top": px,
  "margin-block": px,
  "margin-block-end": px,
  "margin-block-start": px,
  "margin-inline": px,
  "margin-inline-end": px,
  "margin-inline-start": px,
  padding: px,
  "padding-bottom": px,
  "padding-left": px,
  "padding-right": px,
  "padding-top": px,
  "padding-block": px,
  "padding-block-end": px,
  "padding-block-start": px,
  "padding-inline": px,
  "padding-inline-end": px,
  "padding-inline-start": px,
  "mask-position-x": px,
  "mask-position-y": px,
  "mask-size": px,
  height: px,
  width: px,
  "min-height": px,
  "max-height": px,
  "min-width": px,
  "max-width": px,
  bottom: px,
  left: px,
  top: px,
  right: px,
  inset: px,
  "inset-block": px,
  "inset-block-end": px,
  "inset-block-start": px,
  "inset-inline": px,
  "inset-inline-end": px,
  "inset-inline-start": px,
  "box-shadow": px,
  "text-shadow": px,
  "column-gap": px,
  "column-rule": px,
  "column-rule-width": px,
  "column-width": px,
  "font-size": px,
  "font-size-delta": px,
  "letter-spacing": px,
  "text-decoration-thickness": px,
  "text-indent": px,
  "text-stroke": px,
  "text-stroke-width": px,
  "word-spacing": px,
  motion: px,
  "motion-offset": px,
  outline: px,
  "outline-offset": px,
  "outline-width": px,
  perspective: px,
  "perspective-origin-x": percent,
  "perspective-origin-y": percent,
  "transform-origin": percent,
  "transform-origin-x": percent,
  "transform-origin-y": percent,
  "transform-origin-z": percent,
  "transition-delay": ms,
  "transition-duration": ms,
  "vertical-align": px,
  "flex-basis": px,
  "shape-margin": px,
  size: px,
  gap: px,
  grid: px,
  "grid-gap": px,
  "row-gap": px,
  "grid-row-gap": px,
  "grid-column-gap": px,
  "grid-template-rows": px,
  "grid-template-columns": px,
  "grid-auto-rows": px,
  "grid-auto-columns": px,
  "box-shadow-x": px,
  "box-shadow-y": px,
  "box-shadow-blur": px,
  "box-shadow-spread": px,
  "font-line-height": px,
  "text-shadow-x": px,
  "text-shadow-y": px,
  "text-shadow-blur": px
};
function addCamelCasedVersion(obj) {
  var regExp2 = /(-[a-z])/g;
  var replace = function replace2(str) {
    return str[1].toUpperCase();
  };
  var newObj = {};
  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp2, replace)] = obj[key];
  }
  return newObj;
}
var units = addCamelCasedVersion(defaultUnits);
function iterate(prop, value, options) {
  if (value == null)
    return value;
  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === "object") {
    if (prop === "fallbacks") {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    }
  } else if (typeof value === "number" && isNaN(value) === false) {
    var unit = options[prop] || units[prop];
    if (unit && !(value === 0 && unit === px)) {
      return typeof unit === "function" ? unit(value).toString() : "" + value + unit;
    }
    return value.toString();
  }
  return value;
}
function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }
  var camelCasedOptions = addCamelCasedVersion(options);
  function onProcessStyle2(style, rule) {
    if (rule.type !== "style")
      return style;
    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }
    return style;
  }
  function onChangeValue2(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }
  return {
    onProcessStyle: onProcessStyle2,
    onChangeValue: onChangeValue2
  };
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var js = "";
var css = "";
var vendor = "";
var browser = "";
var isTouch = isBrowser && "ontouchstart" in document.documentElement;
if (isBrowser) {
  var jsCssMap = {
    Moz: "-moz-",
    ms: "-ms-",
    O: "-o-",
    Webkit: "-webkit-"
  };
  var _document$createEleme = document.createElement("p"), style = _document$createEleme.style;
  var testProp = "Transform";
  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  }
  if (js === "Webkit" && "msHyphens" in style) {
    js = "ms";
    css = jsCssMap.ms;
    browser = "edge";
  }
  if (js === "Webkit" && "-apple-trailing-word" in style) {
    vendor = "apple";
  }
}
var prefix = {
  js,
  css,
  vendor,
  browser,
  isTouch
};
function supportedKeyframes(key) {
  if (key[1] === "-")
    return key;
  if (prefix.js === "ms")
    return key;
  return "@" + prefix.css + "keyframes" + key.substr(10);
}
var appearence = {
  noPrefill: ["appearance"],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== "appearance")
      return false;
    if (prefix.js === "ms")
      return "-webkit-" + prop;
    return prefix.css + prop;
  }
};
var colorAdjust = {
  noPrefill: ["color-adjust"],
  supportedProperty: function supportedProperty2(prop) {
    if (prop !== "color-adjust")
      return false;
    if (prefix.js === "Webkit")
      return prefix.css + "print-" + prop;
    return prop;
  }
};
var regExp = /[-\s]+(.)?/g;
function toUpper(match, c) {
  return c ? c.toUpperCase() : "";
}
function camelize(str) {
  return str.replace(regExp, toUpper);
}
function pascalize(str) {
  return camelize("-" + str);
}
var mask = {
  noPrefill: ["mask"],
  supportedProperty: function supportedProperty3(prop, style) {
    if (!/^mask/.test(prop))
      return false;
    if (prefix.js === "Webkit") {
      var longhand = "mask-image";
      if (camelize(longhand) in style) {
        return prop;
      }
      if (prefix.js + pascalize(longhand) in style) {
        return prefix.css + prop;
      }
    }
    return prop;
  }
};
var textOrientation = {
  noPrefill: ["text-orientation"],
  supportedProperty: function supportedProperty4(prop) {
    if (prop !== "text-orientation")
      return false;
    if (prefix.vendor === "apple" && !prefix.isTouch) {
      return prefix.css + prop;
    }
    return prop;
  }
};
var transform = {
  noPrefill: ["transform"],
  supportedProperty: function supportedProperty5(prop, style, options) {
    if (prop !== "transform")
      return false;
    if (options.transform) {
      return prop;
    }
    return prefix.css + prop;
  }
};
var transition = {
  noPrefill: ["transition"],
  supportedProperty: function supportedProperty6(prop, style, options) {
    if (prop !== "transition")
      return false;
    if (options.transition) {
      return prop;
    }
    return prefix.css + prop;
  }
};
var writingMode = {
  noPrefill: ["writing-mode"],
  supportedProperty: function supportedProperty7(prop) {
    if (prop !== "writing-mode")
      return false;
    if (prefix.js === "Webkit" || prefix.js === "ms" && prefix.browser !== "edge") {
      return prefix.css + prop;
    }
    return prop;
  }
};
var userSelect = {
  noPrefill: ["user-select"],
  supportedProperty: function supportedProperty8(prop) {
    if (prop !== "user-select")
      return false;
    if (prefix.js === "Moz" || prefix.js === "ms" || prefix.vendor === "apple") {
      return prefix.css + prop;
    }
    return prop;
  }
};
var breakPropsOld = {
  supportedProperty: function supportedProperty9(prop, style) {
    if (!/^break-/.test(prop))
      return false;
    if (prefix.js === "Webkit") {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? prefix.css + "column-" + prop : false;
    }
    if (prefix.js === "Moz") {
      var _jsProp = "page" + pascalize(prop);
      return _jsProp in style ? "page-" + prop : false;
    }
    return false;
  }
};
var inlineLogicalOld = {
  supportedProperty: function supportedProperty10(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop))
      return false;
    if (prefix.js === "Moz")
      return prop;
    var newProp = prop.replace("-inline", "");
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};
var unprefixed = {
  supportedProperty: function supportedProperty11(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};
var prefixed = {
  supportedProperty: function supportedProperty12(prop, style) {
    var pascalized = pascalize(prop);
    if (prop[0] === "-")
      return prop;
    if (prop[0] === "-" && prop[1] === "-")
      return prop;
    if (prefix.js + pascalized in style)
      return prefix.css + prop;
    if (prefix.js !== "Webkit" && "Webkit" + pascalized in style)
      return "-webkit-" + prop;
    return false;
  }
};
var scrollSnap = {
  supportedProperty: function supportedProperty13(prop) {
    if (prop.substring(0, 11) !== "scroll-snap")
      return false;
    if (prefix.js === "ms") {
      return "" + prefix.css + prop;
    }
    return prop;
  }
};
var overscrollBehavior = {
  supportedProperty: function supportedProperty14(prop) {
    if (prop !== "overscroll-behavior")
      return false;
    if (prefix.js === "ms") {
      return prefix.css + "scroll-chaining";
    }
    return prop;
  }
};
var propMap = {
  "flex-grow": "flex-positive",
  "flex-shrink": "flex-negative",
  "flex-basis": "flex-preferred-size",
  "justify-content": "flex-pack",
  order: "flex-order",
  "align-items": "flex-align",
  "align-content": "flex-line-pack"
};
var flex2012 = {
  supportedProperty: function supportedProperty15(prop, style) {
    var newProp = propMap[prop];
    if (!newProp)
      return false;
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};
var propMap$1 = {
  flex: "box-flex",
  "flex-grow": "box-flex",
  "flex-direction": ["box-orient", "box-direction"],
  order: "box-ordinal-group",
  "align-items": "box-align",
  "flex-flow": ["box-orient", "box-direction"],
  "justify-content": "box-pack"
};
var propKeys = Object.keys(propMap$1);
var prefixCss = function prefixCss2(p) {
  return prefix.css + p;
};
var flex2009 = {
  supportedProperty: function supportedProperty16(prop, style, _ref) {
    var multiple = _ref.multiple;
    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];
      if (!Array.isArray(newProp)) {
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
      }
      if (!multiple)
        return false;
      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }
      return newProp.map(prefixCss);
    }
    return false;
  }
};
var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = plugins.filter(function(p) {
  return p.supportedProperty;
}).map(function(p) {
  return p.supportedProperty;
});
var noPrefill = plugins.filter(function(p) {
  return p.noPrefill;
}).reduce(function(a, p) {
  a.push.apply(a, _toConsumableArray(p.noPrefill));
  return a;
}, []);
var el;
var cache = {};
if (isBrowser) {
  el = document.createElement("p");
  var computed = window.getComputedStyle(document.documentElement, "");
  for (var key$1 in computed) {
    if (!isNaN(key$1))
      cache[computed[key$1]] = computed[key$1];
  }
  noPrefill.forEach(function(x) {
    return delete cache[x];
  });
}
function supportedProperty17(prop, options) {
  if (options === void 0) {
    options = {};
  }
  if (!el)
    return prop;
  if (process.env.NODE_ENV !== "benchmark" && cache[prop] != null) {
    return cache[prop];
  }
  if (prop === "transition" || prop === "transform") {
    options[prop] = prop in el.style;
  }
  for (var i = 0; i < propertyDetectors.length; i++) {
    cache[prop] = propertyDetectors[i](prop, el.style, options);
    if (cache[prop])
      break;
  }
  try {
    el.style[prop] = "";
  } catch (err) {
    return false;
  }
  return cache[prop];
}
var cache$1 = {};
var transitionProperties = {
  transition: 1,
  "transition-property": 1,
  "-webkit-transition": 1,
  "-webkit-transition-property": 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
function prefixTransitionCallback(match, p1, p2) {
  if (p1 === "var")
    return "var";
  if (p1 === "all")
    return "all";
  if (p2 === "all")
    return ", all";
  var prefixedValue = p1 ? supportedProperty17(p1) : ", " + supportedProperty17(p2);
  if (!prefixedValue)
    return p1 || p2;
  return prefixedValue;
}
if (isBrowser)
  el$1 = document.createElement("p");
function supportedValue(property, value) {
  var prefixedValue = value;
  if (!el$1 || property === "content")
    return value;
  if (typeof prefixedValue !== "string" || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  }
  var cacheKey = property + prefixedValue;
  if (process.env.NODE_ENV !== "benchmark" && cache$1[cacheKey] != null) {
    return cache$1[cacheKey];
  }
  try {
    el$1.style[property] = prefixedValue;
  } catch (err) {
    cache$1[cacheKey] = false;
    return false;
  }
  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === "") {
    prefixedValue = prefix.css + prefixedValue;
    if (prefixedValue === "-ms-flex")
      el$1.style[property] = "-ms-flexbox";
    el$1.style[property] = prefixedValue;
    if (el$1.style[property] === "") {
      cache$1[cacheKey] = false;
      return false;
    }
  }
  el$1.style[property] = "";
  cache$1[cacheKey] = prefixedValue;
  return cache$1[cacheKey];
}
function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === "keyframes") {
      var atRule = rule;
      atRule.at = supportedKeyframes(atRule.at);
    }
  }
  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];
      if (prop === "fallbacks" && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }
      var changeProp = false;
      var supportedProp = supportedProperty17(prop);
      if (supportedProp && supportedProp !== prop)
        changeProp = true;
      var changeValue = false;
      var supportedValue$1 = supportedValue(supportedProp, toCssValue(value));
      if (supportedValue$1 && supportedValue$1 !== value)
        changeValue = true;
      if (changeProp || changeValue) {
        if (changeProp)
          delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }
    return style;
  }
  function onProcessStyle2(style, rule) {
    if (rule.type !== "style")
      return style;
    return prefixStyle(style);
  }
  function onChangeValue2(value, prop) {
    return supportedValue(prop, toCssValue(value)) || value;
  }
  return {
    onProcessRule,
    onProcessStyle: onProcessStyle2,
    onChangeValue: onChangeValue2
  };
}
function jssPropsSort() {
  var sort = function sort2(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }
    return prop0.length - prop1.length;
  };
  return {
    onProcessStyle: function onProcessStyle2(style, rule) {
      if (rule.type !== "style")
        return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);
      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }
      return newStyle;
    }
  };
}
function jssPreset() {
  return {
    plugins: [
      functions(),
      jssGlobal(),
      jssNested(),
      camelCase(),
      defaultUnit(),
      typeof window === "undefined" ? null : jssVendorPrefixer(),
      jssPropsSort()
    ]
  };
}
function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var baseClasses = options.baseClasses, newClasses = options.newClasses, Component2 = options.Component;
  if (!newClasses) {
    return baseClasses;
  }
  var nextClasses = _extends({}, baseClasses);
  if (process.env.NODE_ENV !== "production") {
    if (typeof newClasses === "string") {
      console.error(["Material-UI: The value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat(getDisplayName(Component2), " is incorrect."), "You might want to use the className prop instead."].join("\n"));
      return baseClasses;
    }
  }
  Object.keys(newClasses).forEach(function(key) {
    if (process.env.NODE_ENV !== "production") {
      if (!baseClasses[key] && newClasses[key]) {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat(getDisplayName(Component2), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(","), ".")].join("\n"));
      }
      if (newClasses[key] && typeof newClasses[key] !== "string") {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat(getDisplayName(Component2), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join("\n"));
      }
    }
    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}
var multiKeyStore = {
  set: function set(cache2, key1, key2, value) {
    var subCache = cache2.get(key1);
    if (!subCache) {
      subCache = /* @__PURE__ */ new Map();
      cache2.set(key1, subCache);
    }
    subCache.set(key2, value);
  },
  get: function get(cache2, key1, key2) {
    var subCache = cache2.get(key1);
    return subCache ? subCache.get(key2) : void 0;
  },
  delete: function _delete(cache2, key1, key2) {
    var subCache = cache2.get(key1);
    subCache.delete(key2);
  }
};
const multiKeyStore$1 = multiKeyStore;
var ThemeContext = React__default.createContext(null);
if (process.env.NODE_ENV !== "production") {
  ThemeContext.displayName = "ThemeContext";
}
const ThemeContext$1 = ThemeContext;
function useTheme() {
  var theme2 = React__default.useContext(ThemeContext$1);
  if (process.env.NODE_ENV !== "production") {
    React__default.useDebugValue(theme2);
  }
  return theme2;
}
var jss = createJss(jssPreset());
var generateClassName = createGenerateClassName();
var sheetsManager = /* @__PURE__ */ new Map();
var defaultOptions = {
  disableGeneration: false,
  generateClassName,
  jss,
  sheetsCache: null,
  sheetsManager,
  sheetsRegistry: null
};
var StylesContext = React__default.createContext(defaultOptions);
if (process.env.NODE_ENV !== "production") {
  StylesContext.displayName = "StylesContext";
}
var injectFirstNode;
function StylesProvider(props) {
  var children = props.children, _props$injectFirst = props.injectFirst, injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst, _props$disableGenerat = props.disableGeneration, disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat, localOptions = _objectWithoutProperties(props, ["children", "injectFirst", "disableGeneration"]);
  var outerOptions = React__default.useContext(StylesContext);
  var context = _extends({}, outerOptions, {
    disableGeneration
  }, localOptions);
  if (process.env.NODE_ENV !== "production") {
    if (typeof window === "undefined" && !context.sheetsManager) {
      console.error("Material-UI: You need to use the ServerStyleSheets API when rendering on the server.");
    }
  }
  if (process.env.NODE_ENV !== "production") {
    if (context.jss.options.insertionPoint && injectFirst) {
      console.error("Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.");
    }
  }
  if (process.env.NODE_ENV !== "production") {
    if (injectFirst && localOptions.jss) {
      console.error("Material-UI: You cannot use the jss and injectFirst props at the same time.");
    }
  }
  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== "undefined") {
    if (!injectFirstNode) {
      var head = document.head;
      injectFirstNode = document.createComment("mui-inject-first");
      head.insertBefore(injectFirstNode, head.firstChild);
    }
    context.jss = createJss({
      plugins: jssPreset().plugins,
      insertionPoint: injectFirstNode
    });
  }
  return /* @__PURE__ */ jsx(StylesContext.Provider, {
    value: context,
    children
  });
}
process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = {
  children: propTypes.exports.node.isRequired,
  disableGeneration: propTypes.exports.bool,
  generateClassName: propTypes.exports.func,
  injectFirst: propTypes.exports.bool,
  jss: propTypes.exports.object,
  serverGenerateClassName: propTypes.exports.func,
  sheetsCache: propTypes.exports.object,
  sheetsManager: propTypes.exports.object,
  sheetsRegistry: propTypes.exports.object
} : void 0;
if (process.env.NODE_ENV !== "production") {
  process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = exactProp(StylesProvider.propTypes) : void 0;
}
var indexCounter = -1e9;
function increment() {
  indexCounter += 1;
  if (process.env.NODE_ENV !== "production") {
    if (indexCounter >= 0) {
      console.warn(["Material-UI: You might have a memory leak.", "The indexCounter is not supposed to grow that much."].join("\n"));
    }
  }
  return indexCounter;
}
var noopTheme = {};
const noopTheme$1 = noopTheme;
function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === "function";
  if (process.env.NODE_ENV !== "production") {
    if (_typeof$1(stylesOrCreator) !== "object" && !themingEnabled) {
      console.error(["Material-UI: The `styles` argument provided is invalid.", "You need to provide a function generating the styles or a styles object."].join("\n"));
    }
  }
  return {
    create: function create2(theme2, name) {
      var styles3;
      try {
        styles3 = themingEnabled ? stylesOrCreator(theme2) : stylesOrCreator;
      } catch (err) {
        if (process.env.NODE_ENV !== "production") {
          if (themingEnabled === true && theme2 === noopTheme$1) {
            console.error(["Material-UI: The `styles` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join("\n"));
          }
        }
        throw err;
      }
      if (!name || !theme2.overrides || !theme2.overrides[name]) {
        return styles3;
      }
      var overrides = theme2.overrides[name];
      var stylesWithOverrides = _extends({}, styles3);
      Object.keys(overrides).forEach(function(key) {
        if (process.env.NODE_ENV !== "production") {
          if (!stylesWithOverrides[key]) {
            console.warn(["Material-UI: You are trying to override a style that does not exist.", "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join("\n"));
          }
        }
        stylesWithOverrides[key] = deepmerge(stylesWithOverrides[key], overrides[key]);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}
function getClasses(_ref, classes, Component2) {
  var state = _ref.state, stylesOptions = _ref.stylesOptions;
  if (stylesOptions.disableGeneration) {
    return classes || {};
  }
  if (!state.cacheClasses) {
    state.cacheClasses = {
      value: null,
      lastProp: null,
      lastJSS: {}
    };
  }
  var generate = false;
  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }
  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }
  if (generate) {
    state.cacheClasses.value = mergeClasses({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component: Component2
    });
  }
  return state.cacheClasses.value;
}
function attach(_ref2, props) {
  var state = _ref2.state, theme2 = _ref2.theme, stylesOptions = _ref2.stylesOptions, stylesCreator = _ref2.stylesCreator, name = _ref2.name;
  if (stylesOptions.disableGeneration) {
    return;
  }
  var sheetManager = multiKeyStore$1.get(stylesOptions.sheetsManager, stylesCreator, theme2);
  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    multiKeyStore$1.set(stylesOptions.sheetsManager, stylesCreator, theme2, sheetManager);
  }
  var options = _extends({}, stylesCreator.options, stylesOptions, {
    theme: theme2,
    flip: typeof stylesOptions.flip === "boolean" ? stylesOptions.flip : theme2.direction === "rtl"
  });
  options.generateId = options.serverGenerateClassName || options.generateClassName;
  var sheetsRegistry = stylesOptions.sheetsRegistry;
  if (sheetManager.refs === 0) {
    var staticSheet;
    if (stylesOptions.sheetsCache) {
      staticSheet = multiKeyStore$1.get(stylesOptions.sheetsCache, stylesCreator, theme2);
    }
    var styles3 = stylesCreator.create(theme2, name);
    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles3, _extends({
        link: false
      }, options));
      staticSheet.attach();
      if (stylesOptions.sheetsCache) {
        multiKeyStore$1.set(stylesOptions.sheetsCache, stylesCreator, theme2, staticSheet);
      }
    }
    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }
    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = getDynamicStyles(styles3);
  }
  if (sheetManager.dynamicStyles) {
    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, _extends({
      link: true
    }, options));
    dynamicSheet.update(props);
    dynamicSheet.attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = mergeClasses({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });
    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }
  sheetManager.refs += 1;
}
function update(_ref3, props) {
  var state = _ref3.state;
  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}
function detach(_ref4) {
  var state = _ref4.state, theme2 = _ref4.theme, stylesOptions = _ref4.stylesOptions, stylesCreator = _ref4.stylesCreator;
  if (stylesOptions.disableGeneration) {
    return;
  }
  var sheetManager = multiKeyStore$1.get(stylesOptions.sheetsManager, stylesCreator, theme2);
  sheetManager.refs -= 1;
  var sheetsRegistry = stylesOptions.sheetsRegistry;
  if (sheetManager.refs === 0) {
    multiKeyStore$1.delete(stylesOptions.sheetsManager, stylesCreator, theme2);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }
  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}
function useSynchronousEffect(func, values) {
  var key = React__default.useRef([]);
  var output;
  var currentKey = React__default.useMemo(function() {
    return {};
  }, values);
  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }
  React__default.useEffect(
    function() {
      return function() {
        if (output) {
          output();
        }
      };
    },
    [currentKey]
  );
}
function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var name = options.name, classNamePrefixOption = options.classNamePrefix, Component2 = options.Component, _options$defaultTheme = options.defaultTheme, defaultTheme2 = _options$defaultTheme === void 0 ? noopTheme$1 : _options$defaultTheme, stylesOptions2 = _objectWithoutProperties(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);
  var stylesCreator = getStylesCreator(stylesOrCreator);
  var classNamePrefix = name || classNamePrefixOption || "makeStyles";
  stylesCreator.options = {
    index: increment(),
    name,
    meta: classNamePrefix,
    classNamePrefix
  };
  var useStyles = function useStyles2() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var theme2 = useTheme() || defaultTheme2;
    var stylesOptions = _extends({}, React__default.useContext(StylesContext), stylesOptions2);
    var instance = React__default.useRef();
    var shouldUpdate = React__default.useRef();
    useSynchronousEffect(function() {
      var current = {
        name,
        state: {},
        stylesCreator,
        stylesOptions,
        theme: theme2
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return function() {
        detach(current);
      };
    }, [theme2, stylesCreator]);
    React__default.useEffect(function() {
      if (shouldUpdate.current) {
        update(instance.current, props);
      }
      shouldUpdate.current = true;
    });
    var classes = getClasses(instance.current, props.classes, Component2);
    if (process.env.NODE_ENV !== "production") {
      React__default.useDebugValue(classes);
    }
    return classes;
  };
  return useStyles;
}
var reactIs$1 = { exports: {} };
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min)
    return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m;
  reactIs_production_min.ContextConsumer = k;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t;
  reactIs_production_min.Memo = r;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function(a) {
    return z(a) === k;
  };
  reactIs_production_min.isContextProvider = function(a) {
    return z(a) === h;
  };
  reactIs_production_min.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function(a) {
    return z(a) === n;
  };
  reactIs_production_min.isFragment = function(a) {
    return z(a) === e;
  };
  reactIs_production_min.isLazy = function(a) {
    return z(a) === t;
  };
  reactIs_production_min.isMemo = function(a) {
    return z(a) === r;
  };
  reactIs_production_min.isPortal = function(a) {
    return z(a) === d;
  };
  reactIs_production_min.isProfiler = function(a) {
    return z(a) === g;
  };
  reactIs_production_min.isStrictMode = function(a) {
    return z(a) === f;
  };
  reactIs_production_min.isSuspense = function(a) {
    return z(a) === p;
  };
  reactIs_production_min.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}
var reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development)
    return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol2 = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol2 ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol2 ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol2 ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol2 ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol2 ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol2 ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol2 ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol2 ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol2 ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol2 ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol2 ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol2 ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol2 ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol2 ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol2 ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol2 ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol2 ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol2 ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === "object" && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement2(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element2;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment2;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement2;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
(function(module) {
  if (process.env.NODE_ENV === "production") {
    module.exports = requireReactIs_production_min();
  } else {
    module.exports = requireReactIs_development();
  }
})(reactIs$1);
var reactIs = reactIs$1.exports;
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  "$$typeof": true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  "$$typeof": true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  }
  return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== "string") {
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);
      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }
    var keys2 = getOwnPropertyNames(sourceComponent);
    if (getOwnPropertySymbols) {
      keys2 = keys2.concat(getOwnPropertySymbols(sourceComponent));
    }
    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);
    for (var i = 0; i < keys2.length; ++i) {
      var key = keys2[i];
      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
        try {
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {
        }
      }
    }
  }
  return targetComponent;
}
var hoistNonReactStatics_cjs = hoistNonReactStatics;
var withStyles$1 = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function(Component2) {
    var defaultTheme2 = options.defaultTheme, _options$withTheme = options.withTheme, withTheme = _options$withTheme === void 0 ? false : _options$withTheme, name = options.name, stylesOptions = _objectWithoutProperties(options, ["defaultTheme", "withTheme", "name"]);
    if (process.env.NODE_ENV !== "production") {
      if (Component2 === void 0) {
        throw new Error(["You are calling withStyles(styles)(Component) with an undefined component.", "You may have forgotten to import it."].join("\n"));
      }
    }
    var classNamePrefix = name;
    if (process.env.NODE_ENV !== "production") {
      if (!name) {
        var displayName = getDisplayName(Component2);
        if (displayName !== void 0) {
          classNamePrefix = displayName;
        }
      }
    }
    var useStyles = makeStyles(stylesOrCreator, _extends({
      defaultTheme: defaultTheme2,
      Component: Component2,
      name: name || Component2.displayName,
      classNamePrefix
    }, stylesOptions));
    var WithStyles = /* @__PURE__ */ React__default.forwardRef(function WithStyles2(props, ref) {
      props.classes;
      var innerRef = props.innerRef, other = _objectWithoutProperties(props, ["classes", "innerRef"]);
      var classes = useStyles(_extends({}, Component2.defaultProps, props));
      var theme2;
      var more = other;
      if (typeof name === "string" || withTheme) {
        theme2 = useTheme() || defaultTheme2;
        if (name) {
          more = getThemeProps({
            theme: theme2,
            name,
            props: other
          });
        }
        if (withTheme && !more.theme) {
          more.theme = theme2;
        }
      }
      return /* @__PURE__ */ jsx(Component2, {
        ref: innerRef || ref,
        classes,
        ...more
      });
    });
    process.env.NODE_ENV !== "production" ? WithStyles.propTypes = {
      classes: propTypes.exports.object,
      innerRef: chainPropTypes(propTypes.exports.oneOfType([propTypes.exports.func, propTypes.exports.object]), function(props) {
        if (props.innerRef == null) {
          return null;
        }
        return null;
      })
    } : void 0;
    if (process.env.NODE_ENV !== "production") {
      WithStyles.displayName = "WithStyles(".concat(getDisplayName(Component2), ")");
    }
    hoistNonReactStatics_cjs(WithStyles, Component2);
    if (process.env.NODE_ENV !== "production") {
      WithStyles.Naked = Component2;
      WithStyles.options = options;
      WithStyles.useStyles = useStyles;
    }
    return WithStyles;
  };
};
const withStylesWithoutDefault = withStyles$1;
var keys = ["xs", "sm", "md", "lg", "xl"];
function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values, values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values, _breakpoints$unit = breakpoints.unit, unit = _breakpoints$unit === void 0 ? "px" : _breakpoints$unit, _breakpoints$step = breakpoints.step, step = _breakpoints$step === void 0 ? 5 : _breakpoints$step, other = _objectWithoutProperties(breakpoints, ["values", "unit", "step"]);
  function up(key) {
    var value = typeof values[key] === "number" ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }
  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];
    if (endIndex === keys.length) {
      return up("xs");
    }
    var value = typeof upperbound === "number" && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }
  function between(start2, end2) {
    var endIndex = keys.indexOf(end2);
    if (endIndex === keys.length - 1) {
      return up(start2);
    }
    return "@media (min-width:".concat(typeof values[start2] === "number" ? values[start2] : start2).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === "number" ? values[keys[endIndex + 1]] : end2) - step / 100).concat(unit, ")");
  }
  function only(key) {
    return between(key, key);
  }
  var warnedOnce2 = false;
  function width(key) {
    if (process.env.NODE_ENV !== "production") {
      if (!warnedOnce2) {
        warnedOnce2 = true;
        console.warn(["Material-UI: The `theme.breakpoints.width` utility is deprecated because it's redundant.", "Use the `theme.breakpoints.values` instead."].join("\n"));
      }
    }
    return values[key];
  }
  return _extends({
    keys,
    values,
    up,
    down,
    between,
    only,
    width
  }, other);
}
function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;
  return _extends({
    gutters: function gutters() {
      var styles3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      console.warn(["Material-UI: theme.mixins.gutters() is deprecated.", "You can use the source of the mixin directly:", "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "].join("\n"));
      return _extends({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles3, _defineProperty({}, breakpoints.up("sm"), _extends({
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }, styles3[breakpoints.up("sm")])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, _defineProperty(_toolbar, "".concat(breakpoints.up("xs"), " and (orientation: landscape)"), {
      minHeight: 48
    }), _defineProperty(_toolbar, breakpoints.up("sm"), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}
var common = {
  black: "#000",
  white: "#fff"
};
const common$1 = common;
var grey = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#d5d5d5",
  A200: "#aaaaaa",
  A400: "#303030",
  A700: "#616161"
};
const grey$1 = grey;
var indigo = {
  50: "#e8eaf6",
  100: "#c5cae9",
  200: "#9fa8da",
  300: "#7986cb",
  400: "#5c6bc0",
  500: "#3f51b5",
  600: "#3949ab",
  700: "#303f9f",
  800: "#283593",
  900: "#1a237e",
  A100: "#8c9eff",
  A200: "#536dfe",
  A400: "#3d5afe",
  A700: "#304ffe"
};
const indigo$1 = indigo;
var pink = {
  50: "#fce4ec",
  100: "#f8bbd0",
  200: "#f48fb1",
  300: "#f06292",
  400: "#ec407a",
  500: "#e91e63",
  600: "#d81b60",
  700: "#c2185b",
  800: "#ad1457",
  900: "#880e4f",
  A100: "#ff80ab",
  A200: "#ff4081",
  A400: "#f50057",
  A700: "#c51162"
};
const pink$1 = pink;
var red = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
};
const red$1 = red;
var orange = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
};
const orange$1 = orange;
var blue = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
};
const blue$1 = blue;
var green = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
};
const green$1 = green;
function clamp(value) {
  var min2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var max2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  if (process.env.NODE_ENV !== "production") {
    if (value < min2 || value > max2) {
      console.error("Material-UI: The value provided ".concat(value, " is out of range [").concat(min2, ", ").concat(max2, "]."));
    }
  }
  return Math.min(Math.max(min2, value), max2);
}
function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), "g");
  var colors = color.match(re);
  if (colors && colors[0].length === 1) {
    colors = colors.map(function(n) {
      return n + n;
    });
  }
  return colors ? "rgb".concat(colors.length === 4 ? "a" : "", "(").concat(colors.map(function(n, index) {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3;
  }).join(", "), ")") : "";
}
function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color, values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);
  var f = function f2(n) {
    var k = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };
  var type = "rgb";
  var rgb2 = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
  if (color.type === "hsla") {
    type += "a";
    rgb2.push(values[3]);
  }
  return recomposeColor({
    type,
    values: rgb2
  });
}
function decomposeColor(color) {
  if (color.type) {
    return color;
  }
  if (color.charAt(0) === "#") {
    return decomposeColor(hexToRgb(color));
  }
  var marker = color.indexOf("(");
  var type = color.substring(0, marker);
  if (["rgb", "rgba", "hsl", "hsla"].indexOf(type) === -1) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: Unsupported `".concat(color, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().") : formatMuiErrorMessage(3, color));
  }
  var values = color.substring(marker + 1, color.length - 1).split(",");
  values = values.map(function(value) {
    return parseFloat(value);
  });
  return {
    type,
    values
  };
}
function recomposeColor(color) {
  var type = color.type;
  var values = color.values;
  if (type.indexOf("rgb") !== -1) {
    values = values.map(function(n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf("hsl") !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }
  return "".concat(type, "(").concat(values.join(", "), ")");
}
function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function getLuminance(color) {
  color = decomposeColor(color);
  var rgb2 = color.type === "hsl" ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb2 = rgb2.map(function(val) {
    val /= 255;
    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  });
  return Number((0.2126 * rgb2[0] + 0.7152 * rgb2[1] + 0.0722 * rgb2[2]).toFixed(3));
}
function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);
  if (color.type.indexOf("hsl") !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf("rgb") !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return recomposeColor(color);
}
function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);
  if (color.type.indexOf("hsl") !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf("rgb") !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }
  return recomposeColor(color);
}
var light = {
  text: {
    primary: "rgba(0, 0, 0, 0.87)",
    secondary: "rgba(0, 0, 0, 0.54)",
    disabled: "rgba(0, 0, 0, 0.38)",
    hint: "rgba(0, 0, 0, 0.38)"
  },
  divider: "rgba(0, 0, 0, 0.12)",
  background: {
    paper: common$1.white,
    default: grey$1[50]
  },
  action: {
    active: "rgba(0, 0, 0, 0.54)",
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    disabled: "rgba(0, 0, 0, 0.26)",
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
var dark = {
  text: {
    primary: common$1.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    hint: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: grey$1[800],
    default: "#303030"
  },
  action: {
    active: common$1.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function addLightOrDark(intent, direction, shade, tonalOffset) {
  var tonalOffsetLight = tonalOffset.light || tonalOffset;
  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === "light") {
      intent.light = lighten(intent.main, tonalOffsetLight);
    } else if (direction === "dark") {
      intent.dark = darken(intent.main, tonalOffsetDark);
    }
  }
}
function createPalette(palette) {
  var _palette$primary = palette.primary, primary = _palette$primary === void 0 ? {
    light: indigo$1[300],
    main: indigo$1[500],
    dark: indigo$1[700]
  } : _palette$primary, _palette$secondary = palette.secondary, secondary = _palette$secondary === void 0 ? {
    light: pink$1.A200,
    main: pink$1.A400,
    dark: pink$1.A700
  } : _palette$secondary, _palette$error = palette.error, error = _palette$error === void 0 ? {
    light: red$1[300],
    main: red$1[500],
    dark: red$1[700]
  } : _palette$error, _palette$warning = palette.warning, warning2 = _palette$warning === void 0 ? {
    light: orange$1[300],
    main: orange$1[500],
    dark: orange$1[700]
  } : _palette$warning, _palette$info = palette.info, info = _palette$info === void 0 ? {
    light: blue$1[300],
    main: blue$1[500],
    dark: blue$1[700]
  } : _palette$info, _palette$success = palette.success, success = _palette$success === void 0 ? {
    light: green$1[300],
    main: green$1[500],
    dark: green$1[700]
  } : _palette$success, _palette$type = palette.type, type = _palette$type === void 0 ? "light" : _palette$type, _palette$contrastThre = palette.contrastThreshold, contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre, _palette$tonalOffset = palette.tonalOffset, tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset, other = _objectWithoutProperties(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]);
  function getContrastText(background) {
    var contrastText = getContrastRatio(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
    if (process.env.NODE_ENV !== "production") {
      var contrast = getContrastRatio(background, contrastText);
      if (contrast < 3) {
        console.error(["Material-UI: The contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join("\n"));
      }
    }
    return contrastText;
  }
  var augmentColor = function augmentColor2(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 700;
    color = _extends({}, color);
    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }
    if (!color.main) {
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(mainShade, "` property.") : formatMuiErrorMessage(4, mainShade));
    }
    if (typeof color.main !== "string") {
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify(color.main), '` was provided instead.\n\nDid you intend to use one of the following approaches?\n\nimport {\xA0green } from "@material-ui/core/colors";\n\nconst theme1 = createTheme({ palette: {\n  primary: green,\n} });\n\nconst theme2 = createTheme({ palette: {\n  primary: { main: green[500] },\n} });') : formatMuiErrorMessage(5, JSON.stringify(color.main)));
    }
    addLightOrDark(color, "light", lightShade, tonalOffset);
    addLightOrDark(color, "dark", darkShade, tonalOffset);
    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }
    return color;
  };
  var types = {
    dark,
    light
  };
  if (process.env.NODE_ENV !== "production") {
    if (!types[type]) {
      console.error("Material-UI: The palette type `".concat(type, "` is not supported."));
    }
  }
  var paletteOutput = deepmerge(_extends({
    common: common$1,
    type,
    primary: augmentColor(primary),
    secondary: augmentColor(secondary, "A400", "A200", "A700"),
    error: augmentColor(error),
    warning: augmentColor(warning2),
    info: augmentColor(info),
    success: augmentColor(success),
    grey: grey$1,
    contrastThreshold,
    getContrastText,
    augmentColor,
    tonalOffset
  }, types[type]), other);
  return paletteOutput;
}
function round(value) {
  return Math.round(value * 1e5) / 1e5;
}
var warnedOnce = false;
function roundWithDeprecationWarning(value) {
  if (process.env.NODE_ENV !== "production") {
    if (!warnedOnce) {
      console.warn(["Material-UI: The `theme.typography.round` helper is deprecated.", "Head to https://material-ui.com/r/migration-v4/#theme for a migration path."].join("\n"));
      warnedOnce = true;
    }
  }
  return round(value);
}
var caseAllCaps = {
  textTransform: "uppercase"
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function createTypography(palette, typography) {
  var _ref = typeof typography === "function" ? typography(palette) : typography, _ref$fontFamily = _ref.fontFamily, fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily, _ref$fontSize = _ref.fontSize, fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize, _ref$fontWeightLight = _ref.fontWeightLight, fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight, _ref$fontWeightRegula = _ref.fontWeightRegular, fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula, _ref$fontWeightMedium = _ref.fontWeightMedium, fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium, _ref$fontWeightBold = _ref.fontWeightBold, fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold, _ref$htmlFontSize = _ref.htmlFontSize, htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize, allVariants = _ref.allVariants, pxToRem2 = _ref.pxToRem, other = _objectWithoutProperties(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);
  if (process.env.NODE_ENV !== "production") {
    if (typeof fontSize !== "number") {
      console.error("Material-UI: `fontSize` is required to be a number.");
    }
    if (typeof htmlFontSize !== "number") {
      console.error("Material-UI: `htmlFontSize` is required to be a number.");
    }
  }
  var coef = fontSize / 14;
  var pxToRem3 = pxToRem2 || function(size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };
  var buildVariant = function buildVariant2(fontWeight, size, lineHeight, letterSpacing, casing) {
    return _extends({
      fontFamily,
      fontWeight,
      fontSize: pxToRem3(size),
      lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };
  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return deepmerge(_extends({
    htmlFontSize,
    pxToRem: pxToRem3,
    round: roundWithDeprecationWarning,
    fontFamily,
    fontSize,
    fontWeightLight,
    fontWeightRegular,
    fontWeightMedium,
    fontWeightBold
  }, variants), other, {
    clone: false
  });
}
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;
function createShadow() {
  return ["".concat(arguments.length <= 0 ? void 0 : arguments[0], "px ").concat(arguments.length <= 1 ? void 0 : arguments[1], "px ").concat(arguments.length <= 2 ? void 0 : arguments[2], "px ").concat(arguments.length <= 3 ? void 0 : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? void 0 : arguments[4], "px ").concat(arguments.length <= 5 ? void 0 : arguments[5], "px ").concat(arguments.length <= 6 ? void 0 : arguments[6], "px ").concat(arguments.length <= 7 ? void 0 : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? void 0 : arguments[8], "px ").concat(arguments.length <= 9 ? void 0 : arguments[9], "px ").concat(arguments.length <= 10 ? void 0 : arguments[10], "px ").concat(arguments.length <= 11 ? void 0 : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(",");
}
var shadows = ["none", createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
const shadows$1 = shadows;
var shape = {
  borderRadius: 4
};
const shape$1 = shape;
var responsivePropType = process.env.NODE_ENV !== "production" ? propTypes.exports.oneOfType([propTypes.exports.number, propTypes.exports.string, propTypes.exports.object, propTypes.exports.array]) : {};
const responsivePropType$1 = responsivePropType;
var spacingKeys = ["m", "mt", "mr", "mb", "ml", "mx", "my", "p", "pt", "pr", "pb", "pl", "px", "py", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY"];
function createUnarySpacing(theme2) {
  var themeSpacing = theme2.spacing || 8;
  if (typeof themeSpacing === "number") {
    return function(abs) {
      if (process.env.NODE_ENV !== "production") {
        if (typeof abs !== "number") {
          console.error("Material-UI: Expected spacing argument to be a number, got ".concat(abs, "."));
        }
      }
      return themeSpacing * abs;
    };
  }
  if (Array.isArray(themeSpacing)) {
    return function(abs) {
      if (process.env.NODE_ENV !== "production") {
        if (abs > themeSpacing.length - 1) {
          console.error(["Material-UI: The value provided (".concat(abs, ") overflows."), "The supported values are: ".concat(JSON.stringify(themeSpacing), "."), "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")].join("\n"));
        }
      }
      return themeSpacing[abs];
    };
  }
  if (typeof themeSpacing === "function") {
    return themeSpacing;
  }
  if (process.env.NODE_ENV !== "production") {
    console.error(["Material-UI: The `theme.spacing` value (".concat(themeSpacing, ") is invalid."), "It should be a number, an array or a function."].join("\n"));
  }
  return function() {
    return void 0;
  };
}
process.env.NODE_ENV !== "production" ? spacingKeys.reduce(function(obj, key) {
  obj[key] = responsivePropType$1;
  return obj;
}, {}) : {};
var warnOnce;
function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 8;
  if (spacingInput.mui) {
    return spacingInput;
  }
  var transform2 = createUnarySpacing({
    spacing: spacingInput
  });
  var spacing = function spacing2() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (process.env.NODE_ENV !== "production") {
      if (!(args.length <= 4)) {
        console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
      }
    }
    if (args.length === 0) {
      return transform2(1);
    }
    if (args.length === 1) {
      return transform2(args[0]);
    }
    return args.map(function(argument) {
      if (typeof argument === "string") {
        return argument;
      }
      var output = transform2(argument);
      return typeof output === "number" ? "".concat(output, "px") : output;
    }).join(" ");
  };
  Object.defineProperty(spacing, "unit", {
    get: function get2() {
      if (process.env.NODE_ENV !== "production") {
        if (!warnOnce || process.env.NODE_ENV === "test") {
          console.error(["Material-UI: theme.spacing.unit usage has been deprecated.", "It will be removed in v5.", "You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.", "", "You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother."].join("\n"));
        }
        warnOnce = true;
      }
      return spacingInput;
    }
  });
  spacing.mui = true;
  return spacing;
}
var easing = {
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  standard: 300,
  complex: 375,
  enteringScreen: 225,
  leavingScreen: 195
};
function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}
const transitions = {
  easing,
  duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ["all"];
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _options$duration = options.duration, durationOption = _options$duration === void 0 ? duration.standard : _options$duration, _options$easing = options.easing, easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing, _options$delay = options.delay, delay3 = _options$delay === void 0 ? 0 : _options$delay, other = _objectWithoutProperties(options, ["duration", "easing", "delay"]);
    if (process.env.NODE_ENV !== "production") {
      var isString = function isString2(value) {
        return typeof value === "string";
      };
      var isNumber = function isNumber2(value) {
        return !isNaN(parseFloat(value));
      };
      if (!isString(props) && !Array.isArray(props)) {
        console.error('Material-UI: Argument "props" must be a string or Array.');
      }
      if (!isNumber(durationOption) && !isString(durationOption)) {
        console.error('Material-UI: Argument "duration" must be a number or a string but found '.concat(durationOption, "."));
      }
      if (!isString(easingOption)) {
        console.error('Material-UI: Argument "easing" must be a string.');
      }
      if (!isNumber(delay3) && !isString(delay3)) {
        console.error('Material-UI: Argument "delay" must be a number or a string.');
      }
      if (Object.keys(other).length !== 0) {
        console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(other).join(","), "]."));
      }
    }
    return (Array.isArray(props) ? props : [props]).map(function(animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === "string" ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay3 === "string" ? delay3 : formatMs(delay3));
    }).join(",");
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }
    var constant = height / 36;
    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};
var zIndex = {
  mobileStepper: 1e3,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
const zIndex$1 = zIndex;
function createTheme() {
  var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var _options$breakpoints = options.breakpoints, breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints, _options$mixins = options.mixins, mixinsInput = _options$mixins === void 0 ? {} : _options$mixins, _options$palette = options.palette, paletteInput = _options$palette === void 0 ? {} : _options$palette, spacingInput = options.spacing, _options$typography = options.typography, typographyInput = _options$typography === void 0 ? {} : _options$typography, other = _objectWithoutProperties(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);
  var palette = createPalette(paletteInput);
  var breakpoints = createBreakpoints(breakpointsInput);
  var spacing = createSpacing(spacingInput);
  var muiTheme = deepmerge({
    breakpoints,
    direction: "ltr",
    mixins: createMixins(breakpoints, spacing, mixinsInput),
    overrides: {},
    palette,
    props: {},
    shadows: shadows$1,
    typography: createTypography(palette, typographyInput),
    spacing,
    shape: shape$1,
    transitions,
    zIndex: zIndex$1
  }, other);
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  muiTheme = args.reduce(function(acc, argument) {
    return deepmerge(acc, argument);
  }, muiTheme);
  if (process.env.NODE_ENV !== "production") {
    var pseudoClasses2 = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"];
    var traverse = function traverse2(node, parentKey) {
      var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
      var key;
      for (key in node) {
        var child = node[key];
        if (depth === 1) {
          if (key.indexOf("Mui") === 0 && child) {
            traverse2(child, key, depth + 1);
          }
        } else if (pseudoClasses2.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            console.error(["Material-UI: The `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), "You can not override it like this: ", JSON.stringify(node, null, 2), "", "Instead, you need to use the $ruleName syntax:", JSON.stringify({
              root: _defineProperty({}, "&$".concat(key), child)
            }, null, 2), "", "https://material-ui.com/r/pseudo-classes-guide"].join("\n"));
          }
          node[key] = {};
        }
      }
    };
    traverse(muiTheme.overrides);
  }
  return muiTheme;
}
var defaultTheme = createTheme();
const defaultTheme$1 = defaultTheme;
function withStyles2(stylesOrCreator, options) {
  return withStylesWithoutDefault(stylesOrCreator, _extends({
    defaultTheme: defaultTheme$1
  }, options));
}
var styles = function styles2(theme2) {
  return {
    root: {
      userSelect: "none",
      width: "1em",
      height: "1em",
      display: "inline-block",
      fill: "currentColor",
      flexShrink: 0,
      fontSize: theme2.typography.pxToRem(24),
      transition: theme2.transitions.create("fill", {
        duration: theme2.transitions.duration.shorter
      })
    },
    colorPrimary: {
      color: theme2.palette.primary.main
    },
    colorSecondary: {
      color: theme2.palette.secondary.main
    },
    colorAction: {
      color: theme2.palette.action.active
    },
    colorError: {
      color: theme2.palette.error.main
    },
    colorDisabled: {
      color: theme2.palette.action.disabled
    },
    fontSizeInherit: {
      fontSize: "inherit"
    },
    fontSizeSmall: {
      fontSize: theme2.typography.pxToRem(20)
    },
    fontSizeLarge: {
      fontSize: theme2.typography.pxToRem(35)
    }
  };
};
var SvgIcon = /* @__PURE__ */ React$3.forwardRef(function SvgIcon2(props, ref) {
  var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "inherit" : _props$color, _props$component = props.component, Component2 = _props$component === void 0 ? "svg" : _props$component, _props$fontSize = props.fontSize, fontSize = _props$fontSize === void 0 ? "medium" : _props$fontSize, htmlColor = props.htmlColor, titleAccess = props.titleAccess, _props$viewBox = props.viewBox, viewBox = _props$viewBox === void 0 ? "0 0 24 24" : _props$viewBox, other = _objectWithoutProperties(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);
  return /* @__PURE__ */ jsxs(Component2, {
    className: clsx(classes.root, className, color !== "inherit" && classes["color".concat(capitalize(color))], fontSize !== "default" && fontSize !== "medium" && classes["fontSize".concat(capitalize(fontSize))]),
    focusable: "false",
    viewBox,
    color: htmlColor,
    "aria-hidden": titleAccess ? void 0 : true,
    role: titleAccess ? "img" : void 0,
    ref,
    ...other,
    children: [children, titleAccess ? /* @__PURE__ */ jsx("title", {
      children: titleAccess
    }) : null]
  });
});
process.env.NODE_ENV !== "production" ? SvgIcon.propTypes = {
  children: propTypes.exports.node,
  classes: propTypes.exports.object,
  className: propTypes.exports.string,
  color: propTypes.exports.oneOf(["action", "disabled", "error", "inherit", "primary", "secondary"]),
  component: propTypes.exports.elementType,
  fontSize: chainPropTypes(propTypes.exports.oneOf(["default", "inherit", "large", "medium", "small"]), function(props) {
    var fontSize = props.fontSize;
    if (fontSize === "default") {
      throw new Error('Material-UI: `fontSize="default"` is deprecated. Use `fontSize="medium"` instead.');
    }
    return null;
  }),
  htmlColor: propTypes.exports.string,
  shapeRendering: propTypes.exports.string,
  titleAccess: propTypes.exports.string,
  viewBox: propTypes.exports.string
} : void 0;
SvgIcon.muiName = "SvgIcon";
const SvgIcon$1 = withStyles2(styles, {
  name: "MuiSvgIcon"
})(SvgIcon);
function createSvgIcon(path, displayName) {
  var Component2 = function Component3(props, ref) {
    return /* @__PURE__ */ jsx(SvgIcon$1, {
      ref,
      ...props,
      children: path
    });
  };
  if (process.env.NODE_ENV !== "production") {
    Component2.displayName = "".concat(displayName, "Icon");
  }
  Component2.muiName = SvgIcon$1.muiName;
  return /* @__PURE__ */ React__default.memo(/* @__PURE__ */ React__default.forwardRef(Component2));
}
function debounce(func) {
  var wait = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 166;
  var timeout;
  function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var that = this;
    var later = function later2() {
      func.apply(that, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }
  debounced.clear = function() {
    clearTimeout(timeout);
  };
  return debounced;
}
function deprecatedPropType(validator, reason) {
  if (process.env.NODE_ENV === "production") {
    return function() {
      return null;
    };
  }
  return function(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || "<<anonymous>>";
    var propFullNameSafe = propFullName || propName;
    if (typeof props[propName] !== "undefined") {
      return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason));
    }
    return null;
  };
}
function isMuiElement(element, muiNames) {
  return /* @__PURE__ */ React$3.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}
function ownerWindow(node) {
  var doc = ownerDocument(node);
  return doc.defaultView || window;
}
function requirePropFactory(componentNameInError) {
  if (process.env.NODE_ENV === "production") {
    return function() {
      return null;
    };
  }
  var requireProp = function requireProp2(requiredProp) {
    return function(props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;
      if (typeof props[propName] !== "undefined" && !props[requiredProp]) {
        return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
      }
      return null;
    };
  };
  return requireProp;
}
function setRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}
function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === "production") {
    return null;
  }
  var propFullNameSafe = propFullName || propName;
  if (typeof props[propName] !== "undefined") {
    return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
  }
  return null;
}
function useControlled(_ref) {
  var controlled = _ref.controlled, defaultProp = _ref.default, name = _ref.name, _ref$state = _ref.state, state = _ref$state === void 0 ? "value" : _ref$state;
  var _React$useRef = React$3.useRef(controlled !== void 0), isControlled = _React$useRef.current;
  var _React$useState = React$3.useState(defaultProp), valueState = _React$useState[0], setValue = _React$useState[1];
  var value = isControlled ? controlled : valueState;
  if (process.env.NODE_ENV !== "production") {
    React$3.useEffect(function() {
      if (isControlled !== (controlled !== void 0)) {
        console.error(["Material-UI: A component is changing the ".concat(isControlled ? "" : "un", "controlled ").concat(state, " state of ").concat(name, " to be ").concat(isControlled ? "un" : "", "controlled."), "Elements should not switch from uncontrolled to controlled (or vice versa).", "Decide between using a controlled or uncontrolled ".concat(name, " ") + "element for the lifetime of the component.", "The nature of the state is determined during the first render, it's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join("\n"));
      }
    }, [controlled]);
    var _React$useRef2 = React$3.useRef(defaultProp), defaultValue = _React$useRef2.current;
    React$3.useEffect(function() {
      if (!isControlled && defaultValue !== defaultProp) {
        console.error(["Material-UI: A component is changing the default ".concat(state, " state of an uncontrolled ").concat(name, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(name, ".")].join("\n"));
      }
    }, [JSON.stringify(defaultProp)]);
  }
  var setValueIfUncontrolled = React$3.useCallback(function(newValue) {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}
var useEnhancedEffect = typeof window !== "undefined" ? React$3.useLayoutEffect : React$3.useEffect;
function useEventCallback(fn2) {
  var ref = React$3.useRef(fn2);
  useEnhancedEffect(function() {
    ref.current = fn2;
  });
  return React$3.useCallback(function() {
    return ref.current.apply(void 0, arguments);
  }, []);
}
function useForkRef(refA, refB) {
  return React$3.useMemo(function() {
    if (refA == null && refB == null) {
      return null;
    }
    return function(refValue) {
      setRef(refA, refValue);
      setRef(refB, refValue);
    };
  }, [refA, refB]);
}
function useId$1(idOverride) {
  var _React$useState = React$3.useState(idOverride), defaultId = _React$useState[0], setDefaultId = _React$useState[1];
  var id = idOverride || defaultId;
  React$3.useEffect(function() {
    if (defaultId == null) {
      setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }
  }, [defaultId]);
  return id;
}
var hadKeyboardEvent = true;
var hadFocusVisibleRecently = false;
var hadFocusVisibleRecentlyTimeout = null;
var inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  "datetime-local": true
};
function focusTriggersKeyboardModality(node) {
  var type = node.type, tagName = node.tagName;
  if (tagName === "INPUT" && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }
  if (tagName === "TEXTAREA" && !node.readOnly) {
    return true;
  }
  if (node.isContentEditable) {
    return true;
  }
  return false;
}
function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }
  hadKeyboardEvent = true;
}
function handlePointerDown() {
  hadKeyboardEvent = false;
}
function handleVisibilityChange() {
  if (this.visibilityState === "hidden") {
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}
function prepare(doc) {
  doc.addEventListener("keydown", handleKeyDown, true);
  doc.addEventListener("mousedown", handlePointerDown, true);
  doc.addEventListener("pointerdown", handlePointerDown, true);
  doc.addEventListener("touchstart", handlePointerDown, true);
  doc.addEventListener("visibilitychange", handleVisibilityChange, true);
}
function isFocusVisible(event) {
  var target = event.target;
  try {
    return target.matches(":focus-visible");
  } catch (error) {
  }
  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
function handleBlurVisible() {
  hadFocusVisibleRecently = true;
  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
  hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
    hadFocusVisibleRecently = false;
  }, 100);
}
function useIsFocusVisible() {
  var ref = React$3.useCallback(function(instance) {
    var node = require$$1.findDOMNode(instance);
    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);
  if (process.env.NODE_ENV !== "production") {
    React$3.useDebugValue(isFocusVisible);
  }
  return {
    isFocusVisible,
    onBlurVisible: handleBlurVisible,
    ref
  };
}
const utils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize,
  createChainedFunction,
  createSvgIcon,
  debounce,
  deprecatedPropType,
  isMuiElement,
  ownerDocument,
  ownerWindow,
  requirePropFactory,
  setRef,
  unsupportedProp,
  useControlled,
  useEventCallback,
  useForkRef,
  unstable_useId: useId$1,
  useIsFocusVisible
}, Symbol.toStringTag, { value: "Module" }));
const require$$0 = /* @__PURE__ */ getAugmentedNamespace(utils);
var hasRequiredCreateSvgIcon;
function requireCreateSvgIcon() {
  if (hasRequiredCreateSvgIcon)
    return createSvgIcon$1;
  hasRequiredCreateSvgIcon = 1;
  (function(exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    Object.defineProperty(exports, "default", {
      enumerable: true,
      get: function get2() {
        return _utils.createSvgIcon;
      }
    });
    var _utils = require$$0;
  })(createSvgIcon$1);
  return createSvgIcon$1;
}
var _interopRequireDefault$1 = interopRequireDefault.exports;
var _interopRequireWildcard$1 = interopRequireWildcard.exports;
Object.defineProperty(Check, "__esModule", {
  value: true
});
var default_1$1 = Check.default = void 0;
var React$1 = _interopRequireWildcard$1(React__default);
var _createSvgIcon$1 = _interopRequireDefault$1(requireCreateSvgIcon());
var _default$1 = (0, _createSvgIcon$1.default)(/* @__PURE__ */ React$1.createElement("path", {
  d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check");
default_1$1 = Check.default = _default$1;
const Wrap$1 = styled.div.withConfig({
  displayName: "Stepperstyled__Wrap",
  componentId: "sc-1ijfued-0"
})(["width:100%;position:relative;height:62px;overflow:hidden;", " @media ", "{height:50px;min-height:50px;padding-bottom:0;margin-bottom:0;}"], ({
  $bordered
}) => $bordered && `
    border-left: 1px solid #dedede;
    border-right: 1px solid #dedede;
  `, minBp("desktop"));
const LeftShade = styled.div.withConfig({
  displayName: "Stepperstyled__LeftShade",
  componentId: "sc-1ijfued-1"
})(["position:absolute;height:62px;width:15px;top:0;left:0;background:linear-gradient(-90deg,rgba(0,0,0,0) 0%,rgba(0,0,0,0.11) 100%);opacity:", ";transition:opacity 0.2s ease-in-out;pointer-events:none;@media ", "{display:none;}"], ({
  visible
}) => Number(visible), minBp("desktop"));
const RightShade = styled.div.withConfig({
  displayName: "Stepperstyled__RightShade",
  componentId: "sc-1ijfued-2"
})(["position:absolute;height:62px;width:15px;top:0;right:0;background:linear-gradient(90deg,rgba(0,0,0,0) 0%,rgba(0,0,0,0.11) 100%);opacity:", ";transition:opacity 0.2s ease-in-out;pointer-events:none;@media ", "{display:none;}"], ({
  visible
}) => Number(visible), minBp("desktop"));
const Scroller = styled.div.withConfig({
  displayName: "Stepperstyled__Scroller",
  componentId: "sc-1ijfued-3"
})(["overflow-x:auto;overflow-y:hidden;padding:0 10px;white-space:nowrap;height:65px;position:absolute;top:0;left:0;width:100%;", " @media ", "{display:flex;align-items:center;justify-content:space-evenly;}@media ", "{overflow:inherit;justify-content:flex-start;align-items:flex-start;padding:0;height:100%;}"], ({
  $bordered
}) => $bordered && `
    padding: 0;
  `, minBp("tablet"), minBp("desktop"));
const stepStyles = css$1(["padding:20px 0 16px;margin:0 10px;appearance:none;font-family:", ";font-size:17px;background:transparent;border:0;text-decoration:none;color:#585a5f;display:inline-block;position:relative;white-space:nowrap;cursor:default;&:not(:disabled){cursor:pointer;}@media ", "{display:flex;height:100%;align-items:center;justify-content:center;flex:1;margin:0;font-size:14px;font-family:", ";padding:0;}", " ", ""], theme.fonts.dinDemi, minBp("desktop"), theme.fonts.dinRegular, ({
  bold
}) => bold && `
    @media ${minBp("desktop")} {
      font-family: ${theme.fonts.dinDemi};
      color: #000;
    }
  `, ({
  $uppercase
}) => $uppercase && `
    text-transform: uppercase;
  `);
const _Button = forwardRef(({
  bold,
  active,
  ...props
}, ref) => /* @__PURE__ */ jsx("button", {
  type: "button",
  ref,
  ...props
}));
const Step = styled(_Button).withConfig({
  displayName: "Stepperstyled__Step",
  componentId: "sc-1ijfued-4"
})(["", ";", " ", " ", ""], stepStyles, ({
  $bordered
}) => $bordered && `
    flex-grow: 1;
    text-align: center;
    margin: 0;
    padding: 20px 16px;
    min-width: 250px;

    &:not(:last-child) {
      border-right: 1px solid #dedede;
    }
  `, ({
  active
}) => active ? `
      color: #000;

      &:after {
        content: ' ';
        width: 100%;
        height: 8px;
        background-color: #cd192d;
        position: absolute;
        bottom: -4px;
        left: 0;
      }

      @media ${minBp("desktop")} {
        font-family: ${theme.fonts.dinDemi};
      }
  ` : ``, Focusable(-1));
const CheckIcon = styled.span.withConfig({
  displayName: "Stepperstyled__CheckIcon",
  componentId: "sc-1ijfued-5"
})(["display:none;@media ", "{display:inline-block;margin-right:2px;height:20px;svg{height:18px;}}"], minBp("desktop"));
const StepNumber = styled.span.withConfig({
  displayName: "Stepperstyled__StepNumber",
  componentId: "sc-1ijfued-6"
})(["margin-right:4px;"]);
const Stepper = ({
  steps = [],
  activeStep = 0,
  completedSteps = [],
  allDisabled = false,
  onChange = () => {
  },
  bordered,
  hideStepNumbersIfCompleted = false,
  shade = true,
  style,
  className,
  linear = false
}) => {
  const [showScrollLeft, toggleShowScrollLeft] = useState(false);
  const [showScrollRight, toggleShowScrollRight] = useState(true);
  const scrollerRef = useRef();
  useEffect(() => {
    var _a2;
    const element = scrollerRef.current;
    const handleScroll = () => {
      const {
        scrollLeft,
        scrollWidth
      } = element;
      toggleShowScrollLeft(scrollLeft > 0);
      toggleShowScrollRight(scrollLeft < scrollWidth - getViewportWidth());
    };
    (_a2 = element == null ? void 0 : element.addEventListener) == null ? void 0 : _a2.call(element, "scroll", handleScroll);
    return () => {
      var _a3;
      (_a3 = element == null ? void 0 : element.removeEventListener) == null ? void 0 : _a3.call(element, "scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    var _a2, _b2;
    if (!scrollerRef) {
      return;
    }
    const element = document.querySelector(`.js-step-${activeStep}`);
    const xOffset = Math.max(0, element.offsetLeft - scrollerRef.current.getBoundingClientRect().width / 2 + element.getBoundingClientRect().width / 2);
    (_b2 = (_a2 = scrollerRef.current).scrollTo) == null ? void 0 : _b2.call(_a2, {
      behavior: "smooth",
      left: xOffset,
      top: 0
    });
  }, [activeStep, steps]);
  return /* @__PURE__ */ jsxs(Wrap$1, {
    $bordered: bordered,
    className,
    style,
    children: [/* @__PURE__ */ jsx(Scroller, {
      ref: scrollerRef,
      $bordered: bordered,
      children: steps.map((step, stepIndex) => {
        const completed = completedSteps.includes(step.number);
        const buttonProps = {};
        const disabled = !completed && linear || allDisabled;
        if (step.href && !disabled) {
          buttonProps.href = step.href;
          buttonProps.target = step.target;
          buttonProps.as = "a";
        } else {
          buttonProps.type = "button";
          buttonProps.disabled = disabled;
          buttonProps.onClick = () => onChange({
            activeStep: stepIndex,
            completedSteps
          });
        }
        const showStepNumber = !hideStepNumbersIfCompleted || hideStepNumbersIfCompleted && !completed;
        const label = /* @__PURE__ */ jsxs(Fragment, {
          children: [completed ? /* @__PURE__ */ jsx(CheckIcon, {
            children: /* @__PURE__ */ jsx(default_1$1, {})
          }) : null, showStepNumber && /* @__PURE__ */ jsxs(StepNumber, {
            check: completed,
            children: [step.number, "."]
          }), step.label]
        });
        return /* @__PURE__ */ jsx(Step, {
          ref: step.ref,
          bold: step.bold || completed,
          active: activeStep === stepIndex,
          className: `js-step-${stepIndex}`,
          $bordered: bordered,
          $uppercase: step.uppercase,
          ...buttonProps,
          children: label
        }, step.number);
      })
    }), /* @__PURE__ */ jsx(LeftShade, {
      visible: shade && showScrollLeft
    }), /* @__PURE__ */ jsx(RightShade, {
      visible: shade && showScrollRight
    })]
  });
};
function useIsHeaderPinned() {
  const [pinned, setPinned] = useState(true);
  useEffect(() => {
    const pin = () => setPinned(true);
    const unpin = () => setPinned(false);
    window.addEventListener("header.pin", pin);
    window.addEventListener("header.unpin", unpin);
    return () => {
      window.removeEventListener("header.pin", pin);
      window.removeEventListener("header.unpin", unpin);
    };
  }, []);
  return pinned;
}
const StickyHeaderComponent = styled.div.withConfig({
  displayName: "StickyHeaderstyled__StickyHeaderComponent",
  componentId: "sc-eyuztn-0"
})(["position:sticky;top:0;transition:transform 0.4s ease-in-out;z-index:100;"]);
function StickyHeader({
  children
}) {
  var _a2;
  const pinned = useIsHeaderPinned();
  const headerHeight = ((_a2 = document.querySelector(".header")) == null ? void 0 : _a2.clientHeight) || 0;
  return /* @__PURE__ */ jsx(StickyHeaderComponent, {
    style: {
      top: `${headerHeight}px`,
      transform: `translateY(${pinned ? 0 : headerHeight * -1}px)`
    },
    children
  });
}
var ArrowForward = {};
var _interopRequireDefault = interopRequireDefault.exports;
var _interopRequireWildcard = interopRequireWildcard.exports;
Object.defineProperty(ArrowForward, "__esModule", {
  value: true
});
var default_1 = ArrowForward.default = void 0;
var React = _interopRequireWildcard(React__default);
var _createSvgIcon = _interopRequireDefault(requireCreateSvgIcon());
var _default = (0, _createSvgIcon.default)(/* @__PURE__ */ React.createElement("path", {
  d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), "ArrowForward");
default_1 = ArrowForward.default = _default;
const Wrap = styled.div.withConfig({
  displayName: "ToggleGroupstyled__Wrap",
  componentId: "sc-1inspe8-0"
})(["display:flex;flex-direction:column;gap:0 ", ";@media ", "{flex-direction:", ";}"], theme.spacing(1), minBp("tabletLarge"), ({
  horizontal
}) => horizontal ? "row" : "column");
const Option = styled.button.withConfig({
  displayName: "ToggleGroupstyled__Option",
  componentId: "sc-1inspe8-1"
})(["appearance:none;background:white;border:1px solid ", ";padding:0 16px;height:76px;position:relative;display:flex;gap:0.5rem;align-items:center;text-align:left;width:100%;cursor:pointer;transition:border-color 0.1s ease-in;", " &:not(:last-child){margin-bottom:10px;}&:hover{border:1px solid ", ";}"], ({
  checked
}) => checked ? "black" : theme.colors.outline, Focusable(), ({
  checked
}) => checked ? "black" : curriedDarken$1(0.2, theme.colors.outline));
const SelectedIndicator = styled.div.withConfig({
  displayName: "ToggleGroupstyled__SelectedIndicator",
  componentId: "sc-1inspe8-2"
})(["position:absolute;top:0;right:0;svg{width:14px;height:14px;position:absolute;top:0;right:1px;path{fill:white;}}@media ", "{svg{top:5px;right:6px;}}"], minBp("tabletLarge"));
const Triangle = styled.div.withConfig({
  displayName: "ToggleGroupstyled__Triangle",
  componentId: "sc-1inspe8-3"
})(["position:absolute;top:0;right:0;width:0;height:0;border-style:solid;border-width:0 26px 26px 0;border-color:transparent #000000 transparent transparent;@media ", "{border-width:0 40px 40px 0;}"], minBp("tabletLarge"));
const Arrow = styled.div.withConfig({
  displayName: "ToggleGroupstyled__Arrow",
  componentId: "sc-1inspe8-4"
})(["position:absolute;top:50%;transform:translateY(-50%);right:8px;color:#000000;@media ", "{right:16px;}svg{vertical-align:middle;}"], minBp("tabletLarge"));
const OptionNameContainer = styled.div.withConfig({
  displayName: "ToggleGroupstyled__OptionNameContainer",
  componentId: "sc-1inspe8-5"
})(["display:flex;flex-direction:column;gap:0.25rem;"]);
const OptionName = styled.div.withConfig({
  displayName: "ToggleGroupstyled__OptionName",
  componentId: "sc-1inspe8-6"
})(["font-size:1rem;font-family:", ";text-transform:uppercase;color:black;"], theme.fonts.dinDemi);
const OptionLongName = styled.div.withConfig({
  displayName: "ToggleGroupstyled__OptionLongName",
  componentId: "sc-1inspe8-7"
})(["font-size:0.75rem;color:black;"]);
const ToggleGroup = ({
  className,
  options = [],
  large = false,
  horizontal = false,
  noArrow = false,
  selectedOptionId,
  onChange = () => {
  }
}) => /* @__PURE__ */ jsx(Wrap, {
  className,
  horizontal,
  role: "radiogroup",
  children: options.map((option) => {
    const checked = option.id === selectedOptionId;
    return /* @__PURE__ */ jsxs(Option, {
      onClick: () => onChange(option.id),
      role: "radio",
      "aria-checked": checked,
      checked,
      large,
      tabIndex: "0",
      onKeyPress: (event) => {
        event.preventDefault();
        if (event.key === "Enter" || event.key === " ")
          onChange(option.id);
      },
      children: [/* @__PURE__ */ jsxs(OptionNameContainer, {
        children: [/* @__PURE__ */ jsx(OptionName, {
          large,
          children: option.name
        }), option.subHeading ? /* @__PURE__ */ jsx(OptionLongName, {
          large,
          children: option.subHeading
        }) : null]
      }), checked ? /* @__PURE__ */ jsxs(SelectedIndicator, {
        large,
        children: [/* @__PURE__ */ jsx(Triangle, {
          large
        }), /* @__PURE__ */ jsx(default_1$1, {})]
      }) : !noArrow && /* @__PURE__ */ jsx(Arrow, {
        children: /* @__PURE__ */ jsx(default_1, {})
      })]
    }, option.id);
  })
});
const TrackerComponent = styled.div.withConfig({
  displayName: "Trackerstyled__TrackerComponent",
  componentId: "sc-ny5bij-0"
})(["padding:", ";display:flex;justify-content:center;align-items:center;background:white;"], `${theme.spacing(6)} ${theme.spacing(2)}`);
const Wrapper = styled.div.withConfig({
  displayName: "Trackerstyled__Wrapper",
  componentId: "sc-ny5bij-1"
})(["position:relative;display:flex;justify-content:center;align-items:start;gap:2rem;:after{content:'';position:absolute;top:1.5rem;width:75%;height:3.5rem;display:block;height:0.5rem;background:", ";}@media ", "{gap:5rem;:after{width:90%;}}"], theme.colors.gray["20"], minBp("tabletLarge"));
const Bubble = styled.div.withConfig({
  displayName: "Trackerstyled__Bubble",
  componentId: "sc-ny5bij-2"
})(["display:flex;justify-content:center;align-items:center;width:3.5rem;height:3.5rem;background:", ";border-radius:50%;border:0.25rem solid white;color:white;"], theme.colors.gray[50]);
const Label = styled.div.withConfig({
  displayName: "Trackerstyled__Label",
  componentId: "sc-ny5bij-3"
})(["max-width:6rem;font-size:1rem;word-break:break-word;text-align:center;"]);
const BubbleAndLabel = styled.div.withConfig({
  displayName: "Trackerstyled__BubbleAndLabel",
  componentId: "sc-ny5bij-4"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;gap:", ";z-index:1;", ""], theme.spacing(1), ({
  $selected
}) => $selected && `
      transform: scale(1.2);

      ${Bubble} {
        background: black;
        transform: translateY(0.125rem)
      }

      ${Label} {
        transform: scale(0.9);
        font-weight: bold;
        color: black;
      }
    `);
const Tracker = ({
  steps
}) => {
  return /* @__PURE__ */ jsx(TrackerComponent, {
    children: /* @__PURE__ */ jsx(Wrapper, {
      children: steps.map(({
        icon,
        label,
        selected
      }) => /* @__PURE__ */ jsxs(BubbleAndLabel, {
        $selected: selected,
        children: [/* @__PURE__ */ jsx(Bubble, {
          children: icon
        }), /* @__PURE__ */ jsx(Label, {
          children: label
        })]
      }, label))
    })
  });
};
function content(content2, ...parts) {
  return /* @__PURE__ */ jsx(Fragment, {
    children: content2.split(/(\{[0-9]+\})/g).map((section) => {
      return parts.reduce((section2, part, index) => section2 === `{${index}}` ? isValidElement ? {
        ...part,
        key: index
      } : part : section2, section);
    })
  });
}
const downloadFile = (blob, fileName) => {
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  link.target = "_blank";
  document.body.append(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(link.href), 7e3);
};
function hasPartsBasket() {
  return document.cookie.indexOf("x-partsbasketid") !== -1;
}
function pushToDataLayer({
  name,
  action,
  category,
  label,
  props = {}
}) {
  const globalProps = {
    countryMarket: getLanguageCode()
  };
  const event = {
    event: name,
    eventAction: action,
    eventCategory: category,
    eventLabel: label,
    ...globalProps,
    ...props
  };
  const isGa = !!document.querySelector('script[id="ga"]');
  if (isGa) {
    if (!(window == null ? void 0 : window.gtag)) {
      return;
    }
    window.gtag("event", event.event, event);
  } else {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
  }
}
const getCapCode = (colours, loadedConfiguration) => {
  var _a2, _b2;
  const urlParams = new URLSearchParams(window.location.search);
  const colourId = urlParams.get("colourId");
  const capCode = ((_a2 = colours.find((colour) => colour.id === colourId)) == null ? void 0 : _a2.capCode) || ((_b2 = colours.find((colour) => colour.id === (loadedConfiguration == null ? void 0 : loadedConfiguration.colourId))) == null ? void 0 : _b2.capCode);
  return capCode;
};
function withLockedHeader(fn2, pause = 0) {
  window.dispatchEvent(new Event("header.lock"));
  window.setTimeout(async () => {
    await fn2();
    window.setTimeout(() => {
      window.dispatchEvent(new Event("header.unlock"));
    }, 3e3);
  }, pause);
}
const getBikeId = (colours) => {
  var _a2;
  const urlParams = new URLSearchParams(window.location.search);
  const colourId = urlParams.get("colourId");
  const bikeId = (_a2 = colours.find((colour) => colour.id === colourId)) == null ? void 0 : _a2.id;
  return bikeId;
};
const useBreakpoint = (breakpoint) => {
  const [match, setMatch] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setMatch(window.matchMedia(minBp(breakpoint)).matches);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return match;
};
const useComponentDimensions = () => {
  const ref = useRef();
  const [dimensions, setDimensions] = useState();
  useEffect(() => {
    if (!ref.current) {
      return;
    }
    const update2 = () => setDimensions({
      width: ref.current.offsetWidth,
      height: ref.current.offsetHeight
    });
    const observer = new ResizeObserver(update2);
    update2();
    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, [ref.current]);
  return {
    dimensions,
    ref
  };
};
const useDisablePageOverflow = () => {
  useEffect(() => {
    const htmlOverflowX = document.documentElement.style.overflowX;
    const htmlOverflowY = document.documentElement.style.overflowY;
    const bodyOverflowX = document.body.style.overflowX;
    const bodyOverflowY = document.body.style.overflowY;
    document.documentElement.style.overflowX = "hidden";
    document.documentElement.style.overflowY = "hidden";
    document.body.style.overflowX = "hidden";
    document.body.style.overflowY = "hidden";
    return () => {
      document.documentElement.style.overflowX = htmlOverflowX;
      document.documentElement.style.overflowY = htmlOverflowY;
      document.body.style.overflowX = bodyOverflowX;
      document.body.style.overflowY = bodyOverflowY;
    };
  });
};
const useElementDimensions = (selector) => {
  const [dimensions, setDimensions] = useState({
    width: 0,
    height: 0
  });
  useEffect(() => {
    const element = document.querySelector(selector);
    const observer = new ResizeObserver(() => setDimensions({
      width: element.offsetWidth,
      height: element.offsetHeight
    }));
    observer.observe(element);
    return () => {
      observer.disconnect();
    };
  }, []);
  return dimensions;
};
const useForceDeviceViewport = () => {
  useEffect(() => {
    const existingViewportElement = document.querySelector('meta[name="viewport"]');
    existingViewportElement.remove();
    const viewportElement = document.createElement("meta");
    viewportElement.name = "viewport";
    viewportElement.content = "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0";
    document.querySelector("head").appendChild(viewportElement);
    return () => {
      viewportElement.remove();
      document.querySelector("head").appendChild(existingViewportElement);
    };
  }, []);
};
const useHeaderBasketCount = (category, count) => {
  useEffect(() => {
    if (isNaN(count)) {
      return;
    }
    window.dispatchEvent(new CustomEvent("basket-count-set", {
      detail: {
        category,
        count
      }
    }));
  }, [count]);
};
function useHeaderOffset() {
  const [offset2, setOffset] = useState(0);
  useEffect(() => {
    const updateOffset = () => {
      var _a2, _b2, _c;
      let updatedOffset = (_c = (_b2 = (_a2 = document.querySelector("header")) == null ? void 0 : _a2.getBoundingClientRect) == null ? void 0 : _b2.call(_a2)) == null ? void 0 : _c.bottom;
      if (isNaN(updatedOffset)) {
        updatedOffset = offset2;
      }
      updatedOffset = Math.max(updatedOffset, 0);
      setOffset(updatedOffset);
    };
    const waitForAnimationsThenUpdateOffset = () => setTimeout(() => updateOffset(), 1e3);
    window.addEventListener("header.pin", () => waitForAnimationsThenUpdateOffset);
    window.addEventListener("header.unpin", () => waitForAnimationsThenUpdateOffset);
    window.addEventListener("resize", updateOffset);
    updateOffset();
    return () => {
      window.addEventListener("header.pin", () => waitForAnimationsThenUpdateOffset);
      window.addEventListener("header.unpin", () => waitForAnimationsThenUpdateOffset);
      window.removeEventListener("resize", updateOffset);
    };
  }, []);
  return offset2;
}
const useHideElement = (selector, enabled = true) => {
  useEffect(() => {
    if (!enabled) {
      return;
    }
    const element = document.querySelector(selector);
    if (element) {
      requestAnimationFrame(() => {
        element.style.display = "none";
      });
    }
    return () => {
      if (element) {
        element.style.display = null;
      }
    };
  }, [selector, enabled]);
};
function useId() {
  return useMemo(() => Math.random().toString(36).substring(2, 15), []);
}
function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}
function useScrollLock(enabled = true) {
  useEffect(() => {
    if (enabled) {
      bodyNoScroll.add();
    }
    return () => {
      bodyNoScroll.remove();
    };
  }, [enabled]);
}
function useWindowEvent(type, handler) {
  useEffect(() => {
    window.addEventListener(type, handler);
    return () => {
      window.removeEventListener(type, handler);
    };
  }, [type, handler]);
}
const api = axios.create({
  baseURL: window.location.origin,
  timeout: 6e4
});
const noop = (state) => state;
const createReducer = ({
  initialState,
  reducers
}) => (state = initialState, action) => (reducers[action.type] || noop)(state, action);
export {
  Accordion,
  Action,
  BikeName,
  Breadcrumb,
  Button,
  Container,
  DataTable,
  DealerAddress$1 as DealerAddress,
  DealerCard,
  DummyHeader,
  EcommUsps,
  EmailBasket,
  EmailBasketModal,
  ExpandablePanel,
  ExpandingContainer,
  Focusable,
  Checkbox as FormFieldCheckbox,
  FormFieldDisclaimer,
  FormFieldError,
  FormFieldGroup,
  FormFieldGuidance,
  FormFieldInput,
  FormFieldLabel,
  Radio as FormFieldRadio,
  FormFieldSelect,
  FormFieldToggle,
  FormikEffect$1 as FormikEffect,
  FormikSubmitEffect,
  GlobalStyle,
  Icon,
  Information,
  InlineLoader,
  Loader$1 as ItemLoader,
  LinkButton,
  LinkGrid,
  Loader,
  LoadingOverlay,
  Logo,
  NoResults,
  Note,
  PageHeading,
  Panel,
  Paper,
  PartsBasket,
  PriceAndQuantity,
  RichText,
  Stepper,
  StickyHeader,
  ToggleGroup,
  Tracker,
  api,
  bodyNoScroll,
  content,
  createReducer,
  downloadFile,
  formatNumber,
  formatPrice,
  getApiEntrypoint,
  getBikeId,
  getCapCode,
  getContentBasePath,
  getHostname,
  getImageBaseUrl,
  getLanguageCode,
  getScrollHeight,
  getTwoLetterIsoLanguageName,
  getTwoLetterIsoName,
  getUserAgent,
  getViewportDimensions,
  getViewportHeight,
  getViewportWidth,
  hasPartsBasket,
  interceptLinkClick,
  isAndroid,
  isAndroidOrIOS,
  isEdge,
  isIE,
  isIOS,
  isWindows,
  maxBp,
  minBp,
  openSocialPopup,
  pluraliseEn,
  pushToDataLayer,
  request,
  resolve,
  roundPrecisionDecimal,
  stripHtmlTags,
  theme,
  toQueryString,
  truncateString,
  useBreakpoint,
  useComponentDimensions,
  useDisablePageOverflow,
  useElementDimensions,
  useForceDeviceViewport,
  useHeaderBasketCount,
  useHeaderOffset,
  useHideElement,
  useId,
  useIsHeaderPinned,
  usePrevious,
  useScrollLock,
  useWindowEvent,
  withLockedHeader
};
